import React, { useState, useEffect, useRef } from 'react';
import { useSearchParams, useNavigate } from 'react-router-dom';
import { realtimeDatabase } from "../../database/firebase";
import { ref, set, onValue, push, update, remove, get, serverTimestamp } from 'firebase/database';
import axios from "axios";
import InviteUsersModal from './InviteUsersModal';
const Swal = require('sweetalert2').default;

function Game({ updateHeader }) {
  const canvasRef = useRef(null);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const gameId = searchParams.get('gameId');
  const isSpectator = searchParams.get('spectate') === '1';
  const isSpectatorRef = useRef(isSpectator);
  useEffect(() => { isSpectatorRef.current = isSpectator; }, [isSpectator]);
  const [gameState, setGameState] = useState('menu');
  const [gameMode, setGameMode] = useState(null); // '1v1', '2v2', or '1vcpu'
  const [matchFormat, setMatchFormat] = useState('single'); // 'single' or 'match'
  const [boardsPlayed, setBoardsPlayed] = useState(0);
  const [winnerData, setWinnerData] = useState(null); // Store winner data for API call on exit
  const [roomCode, setRoomCode] = useState(gameId || '');
  const [playerName, setPlayerName] = useState('');
  const [playerId, setPlayerId] = useState(null);
  const [gameData, setGameData] = useState(null);
  const [currentTurn, setCurrentTurn] = useState(1);
  const [scores, setScores] = useState({ player1: 0, player2: 0, player3: 0, player4: 0 });
  const [striker, setStriker] = useState(null);
  const [carromMen, setCarromMen] = useState([]);
  const [isDragging, setIsDragging] = useState(false);
  const [dragStart, setDragStart] = useState(null);
  const [dragEnd, setDragEnd] = useState(null);
  const [isAnimating, setIsAnimating] = useState(false);
  const [isRepositioning, setIsRepositioning] = useState(false);
  const [isCurrentPlayerAiming, setIsCurrentPlayerAiming] = useState(false);
  const [nowMs, setNowMs] = useState(Date.now());
  const [queenPocketed, setQueenPocketed] = useState(null);
  const [lastPocketedPiece, setLastPocketedPiece] = useState(null);
  const [foulCount, setFoulCount] = useState({ player1: 0, player2: 0, player3: 0, player4: 0 });
  const [userData, setUserData] = useState(null);
  const [themeData, setThemeData] = useState(null);
  const [textcolor, Setcolorcode] = useState(null);
  const [boxcolor, SetBoxcolorcode] = useState(null);
  const [boxtextcolor, SetBoxTextcolor] = useState(null);
  const [Buttoncolor, SetButtoncolor] = useState(null);
  const [buttontextcolor, SetButtonTextcolor] = useState(null);
  const [tournamentData, setTournamentData] = useState(null);
  const [activeRound, setActiveRound] = useState(0);
  const [loading, setLoading] = useState(true);
  const [gameType, setGameType] = useState(null);
  const [gametype, setGametype] = useState(null); // 'tournament', 'live', or '1vcpu'
  const [tournamentId, settournamentId] = useState(null);
  const [playerColorFromApi, setPlayerColorFromApi] = useState(null);
  const [apiPlayersData, setApiPlayersData] = useState(null);
  const [showInviteModal, setShowInviteModal] = useState(false);

  // Utility functions
  const clearSession = () => {
    localStorage.removeItem('carrom_roomCode');
    localStorage.removeItem('carrom_playerId');
    localStorage.removeItem('carrom_playerName');
  };

  const getPlayerSeat = (playerNum, mode) => {
    if (mode === '2v2') {
      switch (playerNum) {
        case 1: return 'bottom';
        case 2: return 'right';
        case 3: return 'top';
        case 4: return 'left';
        default: return 'bottom';
      }
    }
    return playerNum === 1 ? 'bottom' : 'top';
  };
  function uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0;
      const v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  useEffect(() => {

    // Check game type and set appropriate navigation
    const storedSession = sessionStorage.getItem("userData");
    let backButtonRedirect = "/login?save=true";

    if (storedSession) {
      try {
        const parsedUser = JSON.parse(storedSession);
        if (parsedUser && typeof parsedUser === 'object') {
          const gametype = parsedUser.gametype;
          if (gametype === 'live') {
            backButtonRedirect = "/allusers";
          } else if (gametype === 'live-2v2') {
            backButtonRedirect = "/userpage";
          } else if (gametype === '1v1') {
            backButtonRedirect = "/allusers";
          } else if (gametype === '2v2') {
            backButtonRedirect = "/userpage";
          } else if (gametype === 'tournament') {
            backButtonRedirect = `/tournamentStructure?tournamentId=${parsedUser.tournamentId}`;
          } else if (gametype === '1vcpu') {
            backButtonRedirect = "/userpage";
          } else if (gametype === 'tournament' && parsedUser.tournamentId) {
            backButtonRedirect = `/tournamentStructure?tournamentId=${parsedUser.tournamentId}`;
          }
        }
      } catch (error) {
        console.error('Error parsing session for navigation:', error);
      }
    }

    if (typeof updateHeader === 'function') {
      updateHeader({ backButtonRedirect });
    }

    const fetchData = async () => {
      const storedSession = sessionStorage.getItem("userData");
      console.log(storedSession);
      const storedTheme = sessionStorage.getItem("themeData");

      if (storedSession && storedTheme) {
        const parsedUser = JSON.parse(storedSession);
        const parsedTheme = JSON.parse(storedTheme);

        setUserData(parsedUser);
        setThemeData(parsedTheme);
        Setcolorcode(parsedTheme.landing_page_title_color);
        SetBoxcolorcode(parsedTheme.box_color);
        SetBoxTextcolor(parsedTheme.box_text_color);
        SetButtonTextcolor(parsedTheme.button_text_color);
        SetButtoncolor(parsedTheme.button_color);

        setPlayerName(parsedUser.name);
        setRoomCode(gameId); // roomCode is always gameId from link
        settournamentId(parsedUser.tournamentId);

        const gametypeValue = parsedUser.gametype;
        console.log("gametypeValue", gametypeValue);
        // alert(gametypeValue);
        setGametype(gametypeValue);

        // ---- SPECTATOR MODE ----
        // A non-player opened /game?gameId=...&spectate=1 to watch a live match.
        // Do NOT join, do NOT claim a player slot, do NOT write anything to Firebase.
        // Just attach a read-only listener so the board/scores/turns render live.
        if (isSpectatorRef.current && gameId) {
          try {
            const gameRef = ref(realtimeDatabase, `games/${gameId}`);
            const snapshot = await get(gameRef);
            if (!snapshot.exists()) {
              Swal.fire('Not available', 'This match is no longer live.', 'info').then(() => {
                navigate(parsedUser.tournamentId ? `/tournamentStructure?tournamentId=${parsedUser.tournamentId}` : '/tournament');
              });
              return;
            }
            const data = snapshot.val() || {};
            // Spectator is never a player
            playerIdRef.current = null;
            setPlayerId(null);
            setRoomCode(gameId);
            setGameMode(data.gameMode || '1v1');
            gameStateRef.current = 'playing';
            setGameState('playing');
            setGameData(data);
            setLoading(false);
            attachGameListener(gameId);
          } catch (err) {
            console.error('Spectator init error:', err);
            Swal.fire('Error', 'Unable to load the match to watch.', 'error');
          }
          return; // stop here – skip all join/slot-claim flows
        }

        // Branch behavior based on gametype stored in userData
        if (gametypeValue === 'tournament') {
          
          try {
            const response = await axios.post(
              `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}getMatchesList.php`,
              {
                tournamentId: parsedUser.tournamentId
              },
              {
                headers: {
                  'Content-Type': 'text/plain'
                }
              }
            );
            const tournaments = response.data?.tournaments;
            console.log(" response.data", tournaments);
            //alert(tournaments.length);

            if (Array.isArray(tournaments) && tournaments.length > 0) {
              // Find the match for current gameId (refresh/direct link) or fall back to last round's first match
              let selectedMatch = null;
              if (gameId) {
                for (const t of tournaments) {
                  const list = t.matches || [];
                  const found = list.find((m) => m.gameId === gameId || String(m.gameId) === String(gameId));
                  if (found) {
                    selectedMatch = found;
                    break;
                  }
                }
              }
              if (!selectedMatch) {
                const lastTournament = tournaments[tournaments.length - 1];
                const matches = lastTournament?.matches || [];
                selectedMatch = matches.length > 0 ? matches[0] : null;
              }

              const matches = tournaments.flatMap((t) => t.matches || []);
              console.log("getMatchType----", matches);

              if (selectedMatch) {
                const match = selectedMatch;
                console.log("selectedMatch", match);
                // API may return game_type or match_type; use both to avoid null on refresh
                const gameType = match.match_type || match.game_type || '1v1';
                console.log("gameType", gameType);
                const playersFromApi = match.players || [];

                // Try to match current logged-in user with API players
                const thisPlayerFromApi = playersFromApi.find(
                  (p) => p.userid === parsedUser.userId
                );
                //  alert(thisPlayerFromApi.color);

                // Store player color from API
                if (thisPlayerFromApi && thisPlayerFromApi.color) {
                  setPlayerColorFromApi(thisPlayerFromApi.color);
                  console.log("Player color from API:", thisPlayerFromApi.color);
                }

                // Store API players data for later use in color assignment
                setApiPlayersData(playersFromApi);

                const isHost =
                  thisPlayerFromApi &&
                  playersFromApi.length > 0 &&
                  thisPlayerFromApi.userid === playersFromApi[0].userid;

                setGameType(gameType);

                // Common user payload for tournament games
                const tournamentUser = {
                  ...parsedUser,
                  name: thisPlayerFromApi?.name || parsedUser.name,
                };

                if (gameType === '1vcpu') {
                  setGameMode('1vcpu');
                  // For CPU games, start directly without needing gameId
                  startCpuGame(tournamentUser);
                } else if (gameType === '1v1') {
                  setGameMode('1v1');

                  // ✅ Tournament 1v1:
                  //    - If game already exists, just reattach by userid (no lobby reset on refresh)
                  //    - Otherwise host creates, opponent joins
                  const gameRef = ref(realtimeDatabase, `games/${gameId}`);
                  const snapshot = await get(gameRef);

                  if (snapshot.exists()) {
                    const data = snapshot.val() || {};
                    const players = data.players || {};
                    const myUserId = tournamentUser.userId;
                    const isAlreadyInGame = Object.values(players).some(p => p && p.userid === myUserId);

                    if (isAlreadyInGame) {
                      // Reattach to existing slot (refresh) by userid
                      await joinLiveGame(tournamentUser);
                    } else {
                      // New tournament player joining existing room
                      await joinRoom(tournamentUser);
                    }
                  } else if (isHost) {
                    await create1v1Game(tournamentUser);
                  } else {
                    await joinRoom(tournamentUser);
                  }
                } else if (gameType === '2v2') {
                  setGameMode('2v2');

                  // ✅ Tournament 2v2:
                  //    - If game already exists, just reattach by userid
                  //    - Otherwise host creates, others join
                  const gameRef = ref(realtimeDatabase, `games/${gameId}`);
                  const snapshot = await get(gameRef);

                  if (snapshot.exists()) {
                    const data = snapshot.val() || {};
                    const players = data.players || {};
                    const myUserId = tournamentUser.userId;
                    const isAlreadyInGame = Object.values(players).some(p => p && p.userid === myUserId);

                    if (isAlreadyInGame) {
                      await joinLiveGame(tournamentUser);
                    } else {
                      await joinRoom(tournamentUser);
                    }
                  } else if (isHost) {
                    await createRoom(tournamentUser);
                  } else {
                    await joinRoom(tournamentUser);
                  }
                } else {
                  // Unknown or null game type (e.g. on refresh if API field missing): default to 1v1 and join
                  setGameType('1v1');
                  setGameMode('1v1');
                  const gameRef = ref(realtimeDatabase, `games/${gameId}`);
                  const snapshot = await get(gameRef);
                  if (snapshot.exists()) {
                    const data = snapshot.val() || {};
                    const players = data.players || {};
                    const myUserId = tournamentUser.userId;
                    const isAlreadyInGame = Object.values(players).some(p => p && p.userid === myUserId);
                    if (isAlreadyInGame) {
                      await joinLiveGame(tournamentUser);
                    } else {
                      await joinRoom(tournamentUser);
                    }
                  } else if (isHost) {
                    await create1v1Game(tournamentUser);
                  } else {
                    await joinRoom(tournamentUser);
                  }
                }
              } else {
                Swal.fire('Info', 'No matches found for this tournament', 'info');
              }
            }

          } catch (error) {
            console.error('Error fetching match type:', error);
            Swal.fire('Info', 'Using default game mode (1v1)', 'info');
            // Fallback to 1v1 tournament game on error, but do not reset existing lobby
            setGameMode('1v1');
            try {
              const gameRef = ref(realtimeDatabase, `games/${gameId}`);
              const snapshot = await get(gameRef);
              if (snapshot.exists()) {
                const data = snapshot.val() || {};
                const players = data.players || {};
                const myUserId = parsedUser.userId;
                const isAlreadyInGame = Object.values(players).some(p => p && p.userid === myUserId);

                if (isAlreadyInGame) {
                  await joinLiveGame({
                    ...parsedUser,
                    name: parsedUser.name,
                  });
                } else {
                  await joinRoom({
                    ...parsedUser,
                    name: parsedUser.name,
                  });
                }
              } else {
                await create1v1Game({
                  ...parsedUser,
                  name: parsedUser.name,
                });
              }
            } catch (innerErr) {
              console.error('Error in tournament fallback flow:', innerErr);
            }
          }
        } else if (gametypeValue === 'live-2v2') {
          // 🔹 Live 2v2 – lobby: create room or join by room code; game starts when all 4 ready
          setGameType('2v2');
          setGameMode('2v2');
          setLoading(true);
          if (!realtimeDatabase) {
            setLoading(false);
            setGameState('menu');
            return;
          }
          if (gameId) {
            try {
              const gameRef = ref(realtimeDatabase, `games/${gameId}`);
              const snapshot = await get(gameRef);
              if (snapshot.exists()) {
                const data = snapshot.val() || {};
                const players = data.players || {};
                const myUserId = parsedUser.userId;
                const isAlreadyInGame = Object.values(players).some(p => p && p.userid === myUserId);
                const live2v2User = { ...parsedUser, name: parsedUser.name || parsedUser.firstName || 'Player', isLiveGame: false };
                if (isAlreadyInGame) {
                  await joinLiveGame(live2v2User);
                } else {
                  setRoomCode(gameId);
                  await joinRoom(live2v2User, gameId);
                }
              } else {
                setRoomCode(gameId);
                setGameState('menu');
              }
            } catch (error) {
              console.error('Error joining live 2v2 game:', error);
              setGameState('menu');
              setRoomCode(gameId || '');
              Swal.fire('Error', 'Error joining game: ' + (error?.message || 'Network error. Please try again.'), 'error');
            } finally {
              setLoading(false);
            }
          } else {
            setGameState('menu');
            setLoading(false);
          }
        } else if (gametypeValue === 'live') {
          // 🔹 Live flow – create or join game using userData with both players
          // When boardType is 'match', always set game to 25/8 (match format); otherwise single board
          const boardType = parsedUser.boardType;
          if (boardType === 'match') {
            setGameType('25/8');
            setMatchFormat('match');
          } else {
            setGameType('1v1');
            setMatchFormat('single');
          }
          setGameMode('1v1');

          // For live games, get name and opponent from userData (challenge flow)
          const playerName = parsedUser.name || parsedUser.firstName || 'Player';
          const opponentId = parsedUser.challengeTo || parsedUser.opponentId || 'player2';
          let opponentName = parsedUser.opponentName;

          // If opponentName is not in userData, try to get it from Firebase
          if (!opponentName) {
            try {
              const gameRef = ref(realtimeDatabase, `games/${gameId}`);
              const gameSnapshot = await get(gameRef);
              if (gameSnapshot.exists()) {
                const gameData = gameSnapshot.val();
                const players = gameData.players || {};
                // Find opponent's name from game data
                Object.entries(players).forEach(([pid, player]) => {
                  if (player.userid !== parsedUser.userId && player.name && player.name !== 'Player 2') {
                    opponentName = player.name;
                  }
                });
              }
            } catch (error) {
              console.log('Could not fetch opponent name from Firebase:', error);
            }
          }

          // If still no opponent name, try to get it from session data
          if (!opponentName && parsedUser.sessionId) {
            try {
              const sessionRef = ref(realtimeDatabase, `sessions/${parsedUser.sessionId}/users/${opponentId}`);
              const sessionSnapshot = await get(sessionRef);
              if (sessionSnapshot.exists()) {
                const sessionData = sessionSnapshot.val();
                opponentName = sessionData.name || sessionData.firstName;
              }
            } catch (error) {
              console.log('Could not fetch opponent name from session:', error);
            }
          }

          const liveUser = {
            ...parsedUser,
            name: playerName,
            opponentId: opponentId,
            opponentName: opponentName,
            opponentEmail: parsedUser.opponentEmail || '',
            isLiveGame: true
          };

          // Show loading state while connecting to Firebase
          setLoading(true);

          try {
            const gameRef = ref(realtimeDatabase, `games/${gameId}`);
            const snapshot = await get(gameRef);
            if (!snapshot.exists()) {
              // Create the game room if it doesn't exist (first player to arrive)
              // For CPU games, start CPU game instead of creating 1v1 game
              if (parsedUser.gametype === '1vcpu') {
                startCpuGame(liveUser);
              } else {
                await create1v1Game(liveUser);
              }
            } else {
              // Room exists, join it
              await joinLiveGame(liveUser);
            }

            // Listen to game updates
            attachGameListener(gameId);
          } catch (error) {
            console.error('Error joining live game:', error);
            Swal.fire('Error', 'Error joining game: ' + error.message, 'error');
            setLoading(false);
          }
        } else {
          // 🔹 Fallback – treat as live 1v1

          // For CPU games, create room as local instead
          if (parsedUser.gametype === '1vcpu') {
            setRoomCode('LOCAL');
            setGameMode('1vcpu');
            setGameType('1v1');
            setGameMode('1v1');
            startCpuGame(parsedUser);
          } else {
            await create1v1Game({
              ...parsedUser,
              name: parsedUser.name,
            });
          }
        }

      } else {
        navigate("/login"); // Redirect if session data is missing
      }
    }

    fetchData();
  }, [navigate]);

  // Disable header Back button on game page (user must use Exit/Leave)
  useEffect(() => {
    if (typeof updateHeader !== 'function') return;
    updateHeader({ backButtonDisabled: true });
  }, [updateHeader]);

  const getBaselineForSeat = (seat) => {
    const leftBaselineX = BOARD_PADDING + BASELINE_OFFSET;
    const rightBaselineX = BOARD_SIZE - BOARD_PADDING - BASELINE_OFFSET;
    const topBaselineY = BOARD_PADDING + BASELINE_OFFSET;
    const bottomBaselineY = BOARD_SIZE - BOARD_PADDING - BASELINE_OFFSET;
    // Shorten at corners so striker stays on its baseline and doesn't overlap diagonals
    const leftX = leftBaselineX + BASE_CORNER_OFFSET;
    const rightX = rightBaselineX - BASE_CORNER_OFFSET;
    const topY = topBaselineY + BASE_CORNER_OFFSET;
    const bottomY = bottomBaselineY - BASE_CORNER_OFFSET;

    // fixed = striker position, offset toward center so it sits on baseline not below/outside
    switch (seat) {
      case 'top':
        return { axis: 'x', fixed: topBaselineY + STRIKER_UP_OFFSET, min: leftX, max: rightX };
      case 'bottom':
        return { axis: 'x', fixed: bottomBaselineY - STRIKER_UP_OFFSET, min: leftX, max: rightX };
      case 'left':
        return { axis: 'y', fixed: leftBaselineX + STRIKER_UP_OFFSET, min: topY, max: bottomY };
      case 'right':
        return { axis: 'y', fixed: rightBaselineX - STRIKER_UP_OFFSET, min: topY, max: bottomY };
      default:
        return { axis: 'x', fixed: bottomBaselineY - STRIKER_UP_OFFSET, min: leftX, max: rightX };
    }
  };

  const getBaseCirclesForSeat = (seat) => {
    const leftBaselineX = BOARD_PADDING + BASELINE_OFFSET;
    const rightBaselineX = BOARD_SIZE - BOARD_PADDING - BASELINE_OFFSET;
    const topBaselineY = BOARD_PADDING + BASELINE_OFFSET;
    const bottomBaselineY = BOARD_SIZE - BOARD_PADDING - BASELINE_OFFSET;
    switch (seat) {
      case 'top':
        return [
          { x: leftBaselineX + BASE_CORNER_OFFSET, y: topBaselineY },
          { x: rightBaselineX - BASE_CORNER_OFFSET, y: topBaselineY },
        ];
      case 'bottom':
        return [
          { x: leftBaselineX + BASE_CORNER_OFFSET, y: bottomBaselineY },
          { x: rightBaselineX - BASE_CORNER_OFFSET, y: bottomBaselineY },
        ];
      case 'left':
        return [
          { x: leftBaselineX, y: topBaselineY + BASE_CORNER_OFFSET },
          { x: leftBaselineX, y: bottomBaselineY - BASE_CORNER_OFFSET },
        ];
      case 'right':
        return [
          { x: rightBaselineX, y: topBaselineY + BASE_CORNER_OFFSET },
          { x: rightBaselineX, y: bottomBaselineY - BASE_CORNER_OFFSET },
        ];
      default:
        return [
          { x: leftBaselineX + BASE_CORNER_OFFSET, y: bottomBaselineY },
          { x: rightBaselineX - BASE_CORNER_OFFSET, y: bottomBaselineY },
        ];
    }
  };

  const getViewRotationForSeat = (seat) => {
    switch (seat) {
      case 'top':
        return '180';
      case 'right':
        return '90cw';
      case 'left':
        return '90ccw';
      case 'bottom':
      default:
        return '0';
    }
  };

  const mapScreenToWorld = (x, y, seat) => {
    switch (seat) {
      case 'top':
        return { x: BOARD_SIZE - x, y: BOARD_SIZE - y };
      case 'right':
        return { x: y, y: BOARD_SIZE - x };
      case 'left':
        return { x: BOARD_SIZE - y, y: x };
      case 'bottom':
      default:
        return { x, y };
    }
  };

  const playerIdRef = useRef(null); // Must be declared before effectivePlayerId
  const modeForView = gameData?.gameMode || gameMode;
  const effectivePlayerId = playerIdRef.current ?? playerId;
  // Only use playerId for view if it's a valid slot (player1, player2, etc.) – not userId
  const validPlayerId = effectivePlayerId && /^player[1-4]$/.test(effectivePlayerId) ? effectivePlayerId : null;
  const playerNumForView = validPlayerId ? parseInt(validPlayerId.replace('player', ''), 10) : null;
  const playerSeatForView = playerNumForView ? getPlayerSeat(playerNumForView, modeForView) : 'bottom';
  const viewRotation = getViewRotationForSeat(playerSeatForView);
  const isPerspectiveFlipped = viewRotation === '180';

  const getPlayerColor = (pid, mode, playersOverride = null) => {
    if (!pid) return 'white';
    const playersSource = playersOverride || gameData?.players;
    // If we have API players data (e.g. tournament), use the color from API
    if (apiPlayersData && apiPlayersData.length > 0) {
      const currentPlayer = playersSource?.[pid];
      if (currentPlayer?.userid) {
        const apiPlayer = apiPlayersData.find((p) => String(p.userid) === String(currentPlayer.userid));
        if (apiPlayer?.color) {
          return apiPlayer.color;
        }
      }
      // Tournament: slot has no userid yet (e.g. opponent not joined). Derive color from the other slot so both don't show same color.
      if (apiPlayersData.length >= 2) {
        const otherPid = mode === '2v2'
          ? (pid === 'player1' ? 'player2' : pid === 'player2' ? 'player1' : pid === 'player3' ? 'player4' : 'player3')
          : (pid === 'player1' ? 'player2' : 'player1');
        const otherPlayer = playersSource?.[otherPid];
        if (otherPlayer?.userid) {
          const otherApi = apiPlayersData.find((p) => String(p.userid) === String(otherPlayer.userid));
          if (otherApi?.color) {
            return otherApi.color === 'white' ? 'black' : 'white';
          }
        }
      }
    }

    // Fallback to default logic if no API data
    if (mode === '2v2') {
      return pid === 'player1' || pid === 'player3' ? 'white' : 'black';
    }
    return pid === 'player1' ? 'white' : 'black';
  };

  const animationRef = useRef(null);
  const gameRef = useRef(null);
  const pocketedThisTurnRef = useRef([]);
  const timeoutHandledRef = useRef(null);
  const pendingShotRef = useRef(null); // Store pending shot velocity to apply on first physics frame
  const strikerRef = useRef(null); // Ref for physics loop to bypass React state timing
  const carromMenRef = useRef([]); // Ref for physics loop to bypass React state timing
  const isRepositioningRef = useRef(false); // Ref for immediate repositioning state
  const gameStateRef = useRef('menu'); // Ref for Firebase listener to avoid stale closure
  const lastTurnRef = useRef(null); // Track last turn to reinit striker on remote clients
  const shotTurnRef = useRef(null); // Turn at shot start – avoid stale currentTurn in handleTurnEnd when listener updates state
  const shotStartStrikerRef = useRef(null); // Striker position at shot start – for baseline foul check
  const lastLiveStateWriteRef = useRef(0); // Throttle Firebase writes during shot for live sync
  const turnEndHandledRef = useRef(null); // Prevent double handleTurnEnd for same shot (e.g. physics frame race)
  const physicsTurnEndingRef = useRef(false); // Skip further physics frames until next shot (stops striker "playing twice")
  const physicsStableFramesRef = useRef(0); // Consecutive frames with all bodies sleeping – only then switch turn
  const listeningRoomRef = useRef(null); // Track current listening room
  const activeTouchIdRef = useRef(null); // Track active touch for mobile gesture
  const boardResetLockTurnRef = useRef(null); // After 25/8 board reset, avoid listener overwriting winner's turn with stale snapshot
  const boardResetLockUntilRef = useRef(0);
  const handleMouseMoveRef = useRef(null);
  const handleMouseUpRef = useRef(null);
  const gametypeRef = useRef(null); // Ref so Firebase listener always sees current gametype (live/tournament/1vcpu)
  const gameDataRef = useRef(null); // Ref for latest gameData to avoid stale closure in handleLeaveGame (1vCPU scores)
  const scoresRef = useRef(null); // Ref for latest scores so leave/gameover handlers show correct scores when user leaves
  const liveWinnerReportSentRef = useRef(false); // Ensure winner report (getReportUrlAndPayload) is sent only once per game
  const winnerSavedRef = useRef(false);
  const gameEndInProgressRef = useRef(false);
  const lobbyTimeoutHandledRef = useRef(false);
  const autoReadyInProgressRef = useRef(false);
  const turnStartedAtFallbackRef = useRef(null);
  const lastTurnClockKeyRef = useRef(null);
  const lastProcessedTimeoutKeyRef = useRef(null);
  /** Demo (sessionId demobypass): count completed human (player1 / red striker) turns in local CPU game; then full-page redirect to plans (external URL, not React Router). */
  const demoHumanStrikerTurnsRef = useRef(0);

  useEffect(() => {
    gametypeRef.current = gametype;
  }, [gametype]);
  useEffect(() => {
    playerIdRef.current = playerId;
  }, [playerId]);
  useEffect(() => {
    gameDataRef.current = gameData;
  }, [gameData]);
  useEffect(() => {
    scoresRef.current = scores;
  }, [scores]);
  useEffect(() => {
    if (roomCode) {
      liveWinnerReportSentRef.current = false;
      winnerSavedRef.current = false;
    }
  }, [roomCode]);

  // When gameover for live 1v1 (e.g. other user left), close any open Swal (e.g. Leave confirmation) so gameover popup shows cleanly
  useEffect(() => {
    if (gameState === 'gameover' && gametype === 'live') {
      Swal.close();
    }
  }, [gameState, gametype]);

  // When user is on gameover popup for live 1v1 and closes browser without clicking Exit, reset status to online
  useEffect(() => {
    if (gameState === 'gameover' && gametype === 'live' && userData?.sessionId && userData?.userId) {
      sessionStorage.setItem('resetToOnlineOnUnload', '1');
      return () => {
        sessionStorage.removeItem('resetToOnlineOnUnload');
      };
    }
  }, [gameState, gametype, userData?.sessionId, userData?.userId]);
  const roomInviteRejectedHandledRef = useRef(null);
  const [previousPlayerCount, setPreviousPlayerCount] = useState(0); // Track previous player count for lobby leave detection

  // Listen for 2v2 room invite rejections (when host is in lobby, show popup if someone rejected)
  useEffect(() => {
    if (!realtimeDatabase || gametype !== 'live-2v2' || !userData?.sessionId || !userData?.userId) return;

    const hostRef = ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`);
    const unsubscribe = onValue(hostRef, (snapshot) => {
      if (!snapshot.exists()) return;
      const data = snapshot.val();
      const rejected = data.roomInviteRejected;
      if (!rejected || !rejected.roomCode) return;
      const key = `${rejected.roomCode}-${rejected.by}-${rejected.timestamp}`;
      if (roomInviteRejectedHandledRef.current === key) return;
      roomInviteRejectedHandledRef.current = key;

      Swal.fire({
        title: 'Invite Rejected',
        text: `${rejected.byName || 'This user'} has rejected your room invite.`,
        icon: 'info',
        confirmButtonText: 'OK',
        background: '#1e1e2d'
      }).then(async () => {
        try {
          await update(hostRef, { roomInviteRejected: null });
        } catch (e) {
          console.error('Error clearing roomInviteRejected:', e);
        }
      });
    });

    return () => unsubscribe();
  }, [gametype, userData?.sessionId, userData?.userId]);

  // Generate random room code
  const generateRoomCode = () => {
    return Math.random().toString(36).substring(2, 10).toUpperCase();
  };

  const cpuShotReadyAtRef = useRef(null);
  const cpuShotTurnRef = useRef(null);
  const pendingTimeoutRef = useRef(null);

  // Constants
  const BOARD_SIZE = 700;
  const BOARD_PADDING = 50;
  const PLAY_AREA = BOARD_SIZE - (BOARD_PADDING * 2);
  const POCKET_RADIUS = 36;
  const CARROM_MAN_RADIUS = 13.5;
  const STRIKER_RADIUS = 20.5;
  const FRICTION = 0.982;
  const RESTITUTION = 0.9;
  // Only switch turn when all bodies have stopped (velocity below this). Prevents premature turn change in 25/8.
  const VELOCITY_SLEEP_THRESHOLD = 0.02;
  const STABLE_FRAMES_REQUIRED = 3; // Consecutive frames with all bodies below threshold before switching turn
  const BASELINE_LENGTH = PLAY_AREA - 220; // Further reduced baseline length to prevent overlap
  const BASELINE_THICKNESS = 24;
  const BASELINE_OFFSET = 72;
  const BASELINE_GAP = 20;
  const BASELINE_MARKER_RADIUS = 16;
  const BASE_CIRCLE_RADIUS = 14;
  const BASE_CORNER_OFFSET = 26;
  const STRIKER_UP_OFFSET = 2; // Move striker toward center so it sits on baseline, not below
  const STRIKER_MASS = 2;
  const CARROM_MAN_MASS = 1;
  const SHOT_VELOCITY_MULTIPLIER = 10; // Reduced from 16 to prevent striker overlapping coin on full-power near hits
  // Match scoring rules: first to 25 wins, or most points after 8 boards
  const LOBBY_TIMEOUT_MS = 10 * 60 * 1000;
  const MAX_MISSED_TURNS = 3;
  const FORFEIT_WIN_SCORE = 9;
  const MATCH_TARGET_POINTS = 25;
  const MATCH_MAX_BOARDS = 8;
  const MAX_POINTS_PER_BOARD = 12;
  const QUEEN_BONUS_POINTS = 3;
  const QUEEN_BONUS_MAX_SCORE = 21; // Queen bonus only if winner score ≤ 21 before adding it

  // Find a position that does not overlap any in-play piece (for returning queen/due piece on foul)
  const findNonOverlappingPosition = (men, pieceRadius, excludeId = null) => {
    const minGap = pieceRadius * 2 + 2;
    const centerX = BOARD_SIZE / 2;
    const centerY = BOARD_SIZE / 2;
    const minX = BOARD_PADDING + pieceRadius;
    const maxX = BOARD_SIZE - BOARD_PADDING - pieceRadius;
    const minY = BOARD_PADDING + pieceRadius;
    const maxY = BOARD_SIZE - BOARD_PADDING - pieceRadius;
    const inPlay = men.filter(m => m.inPlay && m.id !== excludeId);

    const overlaps = (x, y) => {
      return inPlay.some(m => {
        const d = Math.hypot(m.x - x, m.y - y);
        return d < minGap + (m.radius || CARROM_MAN_RADIUS);
      });
    };

    const candidates = [
      { x: centerX, y: centerY },
      { x: centerX + minGap, y: centerY },
      { x: centerX - minGap, y: centerY },
      { x: centerX, y: centerY + minGap },
      { x: centerX, y: centerY - minGap },
      { x: centerX + minGap * 0.866, y: centerY + minGap * 0.5 },
      { x: centerX + minGap * 0.866, y: centerY - minGap * 0.5 },
      { x: centerX - minGap * 0.866, y: centerY + minGap * 0.5 },
      { x: centerX - minGap * 0.866, y: centerY - minGap * 0.5 },
      { x: centerX + minGap * 2, y: centerY },
      { x: centerX - minGap * 2, y: centerY },
      { x: centerX, y: centerY + minGap * 2 },
      { x: centerX, y: centerY - minGap * 2 }
    ];

    for (const pos of candidates) {
      const x = Math.max(minX, Math.min(maxX, pos.x));
      const y = Math.max(minY, Math.min(maxY, pos.y));
      if (!overlaps(x, y)) return { x, y };
    }
    // Fallback: try grid around center
    for (let r = 0; r <= 4; r++) {
      for (let i = 0; i < 12; i++) {
        const angle = (i * Math.PI) / 6 + r * 0.5;
        const x = Math.max(minX, Math.min(maxX, centerX + Math.cos(angle) * minGap * (r + 1)));
        const y = Math.max(minY, Math.min(maxY, centerY + Math.sin(angle) * minGap * (r + 1)));
        if (!overlaps(x, y)) return { x, y };
      }
    }
    return { x: centerX, y: centerY };
  };

  // Rehydrate session on refresh (skip if URL has a different gameId - e.g. new live game)
  useEffect(() => {
    if (!realtimeDatabase || playerId) return;

    const storedRoom = localStorage.getItem('carrom_roomCode');
    const storedPlayerId = localStorage.getItem('carrom_playerId');
    const storedName = userData?.name || localStorage.getItem('carrom_playerName');

    if (!storedRoom || !storedPlayerId || !storedName) return;

    // If we have gameId in URL and it's a different game, don't restore old session (live game flow will set state). For 1vcpu (LOCAL) never use URL gameId.
    if (gameId && storedRoom && storedRoom !== 'LOCAL' && gameId !== storedRoom) return;

    // Live-2v2 with gameId in URL: let fetchData handle re-attach so we don't race with restore
    try {
      const ss = sessionStorage.getItem('userData');
      if (ss) {
        const u = JSON.parse(ss);
        if (u?.gametype === 'live-2v2' && gameId && storedRoom === gameId) return;
      }
    } catch (_) { }

    const restore = async () => {
      if (storedRoom === 'LOCAL') {
        const localRaw = localStorage.getItem('carrom_localGame');
        if (!localRaw) return;
        try {
          const localData = JSON.parse(localRaw);
          const normalized = {
            ...localData,
            roomCode: 'LOCAL',
            gameMode: '1vcpu',
            turnStartedAt: typeof localData.turnStartedAt === 'number' ? localData.turnStartedAt : Date.now(),
            shotInProgress: false,
            players: {
              ...localData.players,
              player1: { ...(localData.players?.player1 || {}), name: storedName },
              player2: { ...(localData.players?.player2 || {}), name: 'CPU' }
            }
          };
          setGameMode('1vcpu');
          setRoomCode('LOCAL');
          setPlayerId(storedPlayerId);
          setPlayerName(storedName);
          setGametype('1vcpu');
          if (normalized.status === 'gameover') {
            gameStateRef.current = 'gameover';
            setGameState('gameover');
            setGameData(normalized);
            const winnerColor = normalized.winner ? getPlayerColor(normalized.winner, '1vcpu') : null;
            setWinnerData({
              winnerColor,
              winner: normalized.winner,
              gameMode: '1vcpu',
              players: normalized.players,
              isLive: false,
              currentGametype: '1vcpu'
            });
          } else {
            gameStateRef.current = 'playing';
            setGameState('playing');
            applyLocalGameState(normalized);
            initializeStriker(normalized.currentTurn || 1, '1vcpu');
          }
        } catch (error) {
          localStorage.removeItem('carrom_localGame');
        }
        return;
      }
      try {
        const roomRef = ref(realtimeDatabase, `games/${storedRoom}`);
        const snapshot = await get(roomRef);
        if (!snapshot.exists()) {
          clearSession();
          return;
        }

        const data = snapshot.val();


        // Check if game is already over - for live games, show popup instead of redirecting
        // alert("Game status: " + data.status);
        if (data.status === 'gameover' || data.status === 'players_exiting') {
          // Determine game type from multiple sources
          let currentGametype = gametypeRef.current || gametype;
          //  alert(currentGametype);
          // If still no gametype, try to determine from game data
          if (!currentGametype) {
            // Check if it's a live game by looking at player data
            const players = data.players || {};
            const hasUserIds = Object.values(players).some(p => p.userid);
            // More comprehensive live game detection
            if (hasUserIds || (data.matchFormat === 'multiplayer') || data.gameMode === '1v1') {
              currentGametype = 'live';
            } else {
              currentGametype = 'tournament';
            }
          }

          // For players_exiting or gameover: show game over popup for both live and tournament (do not redirect until user clicks Exit)
          if (data.status === 'players_exiting' || currentGametype === 'live' || currentGametype === 'live-2v2' || currentGametype === 'tournament') {
            gameStateRef.current = 'gameover';
            setGameState('gameover');
            setGameData(data);
            setGametype(currentGametype);
            setRoomCode(storedRoom);
            playerIdRef.current = storedPlayerId;
            setPlayerId(storedPlayerId);
            setPlayerName(storedName);
            const winnerColor = data.winner ? getPlayerColor(data.winner, data.gameMode) : null;
            // Merge scores so game over popup shows correct values (e.g. when game ended by leave)
            const dp = data.players || {};
            const allPids = [...new Set([...Object.keys(dp), 'player1', 'player2'])];
            const playersWithScores = allPids.reduce((acc, pid) => {
              const p = dp[pid] || {};
              acc[pid] = { ...p, score: Number(p?.score ?? 0) || 0 };
              return acc;
            }, {});
            setWinnerData({
              winnerColor,
              winner: data.winner,
              gameMode: data.gameMode,
              players: playersWithScores,
              isLive: currentGametype === 'live' || currentGametype === 'live-2v2',
              currentGametype
            });
            setGameData(prev => ({ ...(prev || data), ...data, status: 'gameover', players: playersWithScores }));
            setScores(prev => ({ ...prev, ...Object.fromEntries(Object.entries(playersWithScores).map(([pid, p]) => [pid, Number(p?.score ?? 0) || 0])) }));
            attachGameListener(storedRoom);
            return;
          }
        } else {
          // alert("else");

          const players = data.players || {};
          const playerCount = Object.keys(players).length;
          const maxPlayers = data.gameMode === '2v2' ? 4 : 2;

          setRoomCode(storedRoom);
          playerIdRef.current = storedPlayerId;
          setPlayerId(storedPlayerId);
          setPlayerName(storedName);
          // Show lobby for tournament and live-2v2; for live 1v1 go straight to playing
          const isLobbyGame = gametypeRef.current === 'tournament' || gametypeRef.current === 'live-2v2' ||
            (!data.players?.player1?.userid && data.gameMode !== '1vcpu');

          if (isLobbyGame) {
            gameStateRef.current = 'lobby';
            setGameState('lobby');
          } else {
            // For live games, go directly to playing state
            gameStateRef.current = 'playing';
            setGameState('playing');
          }

          if (!players[storedPlayerId]) {
            if (playerCount < maxPlayers) {
              await update(ref(realtimeDatabase, `games/${storedRoom}/players/${storedPlayerId}`), {
                name: storedName,
                ready: data.status === 'playing',
                score: 0,
                fouls: 0
              });
            } else {
              clearSession();
              setGameState('menu');
              return;
            }
          }


          attachGameListener(storedRoom);

        }
      } catch (err) {
        console.error('Error restoring session on refresh:', err);
        clearSession();
        setGameState('menu');
      }
    };

    restore();
  }, [realtimeDatabase, playerId, gameId]);

  const startCpuGame = (user = null) => {
    const currentUser = user || { name: playerName };
    if (!currentUser.name) {
      alert('Please enter your name');
      return;
    }
    setGameMode('1vcpu');

    const men = initializeCarromMen();
    const localGameData = {
      roomCode: 'LOCAL',
      gameMode: '1vcpu',
      matchFormat,
      boardsPlayed: 0,
      matchDraw: false,
      host: 'player1',
      currentTurn: 1,
      turnStartedAt: Date.now(),
      turnDurationMs: 30000,
      shotInProgress: false,
      players: {
        player1: { name: currentUser.name, ready: true, score: 0, fouls: 0 },
        player2: { name: 'CPU', ready: true, score: 0, fouls: 0 }
      },
      carromMen: men,
      striker: null,
      queenPocketed: null,
      queenCovered: false,
      status: 'playing',
      turnLog: [],
      boardResult: null
    };

    setRoomCode('LOCAL');
    setPlayerId('player1');
    demoHumanStrikerTurnsRef.current = 0;
    saveSession('LOCAL', 'player1', currentUser.name);
    gameStateRef.current = 'playing';
    setGameState('playing');
    pendingShotRef.current = null;
    setIsAnimating(false);
    setIsDragging(false);
    isRepositioningRef.current = false;
    setIsRepositioning(false);

    applyLocalGameState(localGameData);
    initializeStriker(1, '1vcpu');
  };

  const parseFirebaseTimestamp = (ts) => {
    if (typeof ts === 'number' && !Number.isNaN(ts)) return ts;
    if (ts && typeof ts === 'object') {
      if (typeof ts.seconds === 'number') return ts.seconds * 1000;
      if (typeof ts._seconds === 'number') return ts._seconds * 1000;
    }
    return null;
  };

  const buildMissedTurnsPayload = (players) => {
    const payload = {};
    Object.values(players || {}).forEach((p) => {
      if (p?.userid) payload[p.userid] = Number(p.missedTurns ?? 0);
    });
    return payload;
  };

  const updatePlayerPresence = async (userId) => {
    if (!userId || !gameId || gametypeRef.current !== 'tournament') return;
    try {
      await axios.post(
        `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}updatePresence.php`,
        { gameId, userId },
        { headers: { 'Content-Type': 'application/json' } }
      );
    } catch (err) {
      console.error('Error updating player presence:', err);
    }
  };

  const create1v1Game = async (user = null) => {
    const currentUser = user || userData;
    if (!realtimeDatabase || !currentUser?.name) {
      Swal.fire('Error', 'User data or Firebase not available', 'error');
      return;
    }
    if (!gameId) {
      Swal.fire('Error', 'Game ID missing from URL', 'error');
      return;
    }

    // Get the correct player name from API data
    let playerNameToUse = currentUser.name;
    if (apiPlayersData && apiPlayersData.length > 0) {
      const thisPlayerFromApi = apiPlayersData.find(p => p.userid === currentUser.userId);
      if (thisPlayerFromApi && thisPlayerFromApi.name) {
        playerNameToUse = thisPlayerFromApi.name;
      }
    }

    const code = gameId; // roomCode is always gameId
    const newPlayerId = 'player1';

    // Live: boardType 'match' => 25/8; boardType 'single' (or else) => normal 1v1 single board
    const isLiveMatch = currentUser.isLiveGame && (currentUser.boardType === 'match' || userData?.boardType === 'match');
    const initialGameState = {
      roomCode: code,
      gameMode: '1v1',
      matchFormat: isLiveMatch ? 'match' : 'single',
      boardsPlayed: 0,
      matchDraw: false,
      host: newPlayerId,
      currentTurn: 1,
      turnStartedAt: currentUser.isLiveGame ? Date.now() : null,
      turnDurationMs: 30000,
      shotInProgress: false,
      players: currentUser.isLiveGame ? {
        player1: {
          name: playerNameToUse,
          userid: currentUser.userId,
          email: currentUser.email || userData?.email || '',
          ready: false,
          score: 0,
          fouls: 0,
          missedTurns: 0
        },
        player2: {
          name: currentUser.opponentName || 'Player 2',
          userid: currentUser.opponentId || null,
          email: currentUser.opponentEmail || '',
          ready: false,
          score: 0,
          fouls: 0,
          missedTurns: 0
        }
      } : {
        player1: { name: playerNameToUse, userid: currentUser.userId, ready: true, score: 0, fouls: 0, missedTurns: 0 }
      },
      carromMen: initializeCarromMen(),
      striker: null,
      queenPocketed: null,
      queenCovered: false,
      status: currentUser.isLiveGame ? 'playing' : 'waiting',
      lobbyStartedAt: currentUser.isLiveGame ? null : Date.now(),
      lobbyTimeoutMs: LOBBY_TIMEOUT_MS,
      lobbyTimeoutCancelled: false,
      lobbyTimeoutHandled: false,
      turnLog: [],
      boardResult: null
    };

    try {
      await set(ref(realtimeDatabase, `games/${code}`), initialGameState);
      setRoomCode(code);
      playerIdRef.current = newPlayerId;
      setPlayerId(newPlayerId);
      saveSession(code, newPlayerId, currentUser.name);
      const startState = currentUser.isLiveGame ? 'playing' : 'lobby';
      gameStateRef.current = startState;

      // alert(startState);
      setGameState(startState);

      if (currentUser.isLiveGame) {
        initializeStriker(1, '1v1');
      }

      // Listen to game updates
      attachGameListener(code);

      if (!currentUser.isLiveGame) {
        await updatePlayerPresence(currentUser.userId);
      }

      // Re-verify slot from Firebase (handles create race: if another client overwrote our write, we get correct slot)
      const verifySnapshot = await get(ref(realtimeDatabase, `games/${code}`));
      if (verifySnapshot.exists()) {
        const verifyData = verifySnapshot.val();
        const verifyPlayers = verifyData?.players || {};
        const myUid = currentUser.userId;
        let slotThatIsMe = null;
        for (const [pid, p] of Object.entries(verifyPlayers)) {
          if (p?.userid === myUid) {
            slotThatIsMe = pid;
            break;
          }
        }
        if (slotThatIsMe && slotThatIsMe !== newPlayerId) {
          playerIdRef.current = slotThatIsMe;
          setPlayerId(slotThatIsMe);
          saveSession(code, slotThatIsMe, currentUser.name);
        }
      }

      //Swal.fire('Success', '1v1 game created! Room code: ' + code, 'success');
    } catch (error) {
      Swal.fire('Error', 'Error creating 1v1 game: ' + error.message, 'error');
    }
  };

  // Join existing live game (find my slot by userid, attach listener)
  const joinLiveGame = async (user = null) => {
    const currentUser = user || userData;
    if (!realtimeDatabase || !gameId) {
      Swal.fire('Error', 'Game data missing', 'error');
      return;
    }

    try {
      const gameRef = ref(realtimeDatabase, `games/${gameId}`);
      const snapshot = await get(gameRef);
      if (!snapshot.exists()) {
        Swal.fire('Error', 'Game room not found', 'error');
        return;
      }

      const data = snapshot.val();
      const players = data.players || {};
      const myUserId = currentUser.userId;

      // Find my player slot by matching userid
      let myPlayerId = null;
      for (const [pid, p] of Object.entries(players)) {
        if (p.userid === myUserId) {
          myPlayerId = pid;
          break;
        }
      }

      // If not found by userid, try to find by name (for refresh scenarios)
      if (!myPlayerId) {
        const myName = currentUser.name || currentUser.firstName || userData?.name;
        for (const [pid, p] of Object.entries(players)) {
          if (p.name === myName) {
            myPlayerId = pid;
            // Update the userid to ensure future lookups work
            await update(ref(realtimeDatabase, `games/${gameId}/players/${pid}`), {
              userid: myUserId
            });
            break;
          }
        }
      }

      // If still not found, claim the first slot whose userid doesn't match any real user
      if (!myPlayerId) {
        // Collect real userIds already in the game (exclude placeholder values like 'player2')
        const realUserIds = new Set(
          Object.values(players).map(p => p?.userid).filter(uid => uid && /^player\d$/.test(uid) === false)
        );

        // Find slots that are either empty or have a placeholder userid (not a real user)
        const claimableSlots = Object.keys(players).filter(pid => {
          const uid = players[pid]?.userid;
          return !uid || !realUserIds.has(uid);
        });

        if (claimableSlots.length > 0) {
          // For 1v1 live, joiner should get player2 so striker appears on opposite side for each user
          myPlayerId = (data.gameMode === '1v1' && claimableSlots.includes('player2'))
            ? 'player2'
            : claimableSlots[0];
          await update(ref(realtimeDatabase, `games/${gameId}/players/${myPlayerId}`), {
            name: currentUser.name || currentUser.firstName || userData?.name || 'Player',
            userid: myUserId,
            email: currentUser.email || userData?.email || '',
            ready: data.status === 'playing' || data.status === 'waiting',
            score: players[myPlayerId]?.score ?? 0,
            fouls: players[myPlayerId]?.fouls ?? 0,
            missedTurns: players[myPlayerId]?.missedTurns ?? 0
          });
        } else if (data.gameMode === '1v1' && !players.player2) {
          myPlayerId = 'player2';
          await update(ref(realtimeDatabase, `games/${gameId}/players/player2`), {
            name: currentUser.name || currentUser.firstName || userData?.name || 'Player',
            userid: myUserId,
            email: currentUser.email || userData?.email || '',
            ready: data.status === 'playing' || data.status === 'waiting',
            score: 0,
            fouls: 0,
            missedTurns: 0
          });
        }
      }

      if (!myPlayerId) {
        Swal.fire('Error', 'You are not in this game', 'error');
        return;
      }

      // Use reliable name for this player (so player2 shows real name on creator's screen)
      const myDisplayName = currentUser.name || currentUser.firstName || players[myPlayerId]?.name || userData?.name || 'Player';

      // If game is already over (e.g. opponent left, or normal game over), show game over popup instead of board/lobby
      if (data.status === 'gameover' || data.status === 'players_exiting') {
        const currentGametype = gametypeRef.current || gametype || (data.gameMode === '1v1' && players?.player1?.userid && players?.player2?.userid ? 'live' : 'tournament');
        const isLiveGameOver = currentGametype === 'live' || currentGametype === 'live-2v2' || (data.gameMode === '1v1' && players?.player1?.userid && players?.player2?.userid);
        const isTournamentGameOver = currentGametype === 'tournament';
        if (data.status === 'players_exiting' || isLiveGameOver || isTournamentGameOver) {
          setRoomCode(gameId);
          playerIdRef.current = myPlayerId;
          setPlayerId(myPlayerId);
          setPlayerName(myDisplayName);
          saveSession(gameId, myPlayerId, myDisplayName);
          gameStateRef.current = 'gameover';
          setGameState('gameover');
          setGameData(data);
          const winnerColor = data.winner ? getPlayerColor(data.winner, data.gameMode) : null;
          const currentUserId = userData?.userId;
          const winnerUserId = data.players?.[data.winner]?.userid;
          // Merge scores so game over popup shows correct values (data.players + gameData.players + local scores)
          const basePlayers = data.players || gameData?.players || {};
          const latestScoresJoin = scoresRef.current ?? scores;
          const playersWithScores = Object.keys(basePlayers).length > 0
            ? Object.keys(basePlayers).reduce((acc, pid) => {
              const fromData = basePlayers[pid]?.score ?? 0;
              const fromGameData = gameData?.players?.[pid]?.score ?? 0;
              const fromLocal = latestScoresJoin?.[pid] ?? 0;
              acc[pid] = { ...basePlayers[pid], score: Math.max(Number(fromData) || 0, Number(fromGameData) || 0, Number(fromLocal) || 0) };
              return acc;
            }, {})
            : basePlayers;
          setWinnerData({
            winnerColor,
            winner: data.winner,
            gameMode: data.gameMode,
            players: playersWithScores,
            isLive: isLiveGameOver,
            currentGametype
          });
          setGameData(prev => ({ ...(prev || data), ...data, status: 'gameover', players: playersWithScores }));
          setScores(prev => ({ ...prev, ...Object.fromEntries(Object.entries(playersWithScores).map(([pid, p]) => [pid, Number(p?.score ?? 0) || 0])) }));
          if (isLiveGameOver && data.gameEndedBy === 'leave' && data.players) {
            const isLive1v1 = data.gameMode === '1v1';
            resetUsersStatusToOnline(isLive1v1 ? { currentUser: { userid: userData?.userId } } : data.players).catch(err => console.error('Error resetting user status on rejoin:', err));
          }
          setLoading(false);
          attachGameListener(gameId);
          return;
        }
      }

      // For live games: roomCode always from URL (gameId); never show lobby – go straight to playing
      setRoomCode(gameId);
      playerIdRef.current = myPlayerId;
      setPlayerId(myPlayerId);
      setPlayerName(myDisplayName);
      saveSession(gameId, myPlayerId, myDisplayName);
      const isLive = currentUser.isLiveGame || gametype === 'live';
      const isLive2v2Reattach = gametype === 'live-2v2';
      const startState = (isLive && !isLive2v2Reattach) ? 'playing' : (data.status === 'playing' ? 'playing' : 'lobby');
      gameStateRef.current = startState;
      setGameState(startState);
      const updates = {};

      // For live games: always write this player's name and email to Firebase so the other client and API have them
      const myEmail = currentUser.email || userData?.email || '';
      if (isLive) {
        const existingName = players[myPlayerId]?.name;
        // Always update the name to ensure it's current
        if (existingName !== myDisplayName || !existingName || existingName === 'Player 2') {
          updates[`games/${gameId}/players/${myPlayerId}/name`] = myDisplayName;
        }
        if (myEmail) {
          updates[`games/${gameId}/players/${myPlayerId}/email`] = myEmail;
        }

        // Always update userid to ensure proper identification
        if (!players[myPlayerId]?.userid || players[myPlayerId]?.userid !== myUserId) {
          updates[`games/${gameId}/players/${myPlayerId}/userid`] = myUserId;
        }
      } else if (players[myPlayerId]?.name !== myDisplayName) {
        updates[`games/${gameId}/players/${myPlayerId}/name`] = myDisplayName;
      }

      // Also set opponent's name in Firebase if we have it (e.g. receiver has challenger's name)
      if (isLive && currentUser.opponentName) {
        const opponentPlayerId = myPlayerId === 'player1' ? 'player2' : 'player1';
        if (players[opponentPlayerId]?.name !== currentUser.opponentName) {
          updates[`games/${gameId}/players/${opponentPlayerId}/name`] = currentUser.opponentName;
        }
        // Also set opponent's email if we have it
        if (currentUser.opponentEmail) {
          updates[`games/${gameId}/players/${opponentPlayerId}/email`] = currentUser.opponentEmail;
        }
      }

      // For live games, ensure both players have complete data
      if (isLive) {
        // If opponent exists but has incomplete data, try to fill it from userData or Firebase session
        const opponentPlayerId = myPlayerId === 'player1' ? 'player2' : 'player1';
        if (players[opponentPlayerId]) {
          const opponent = players[opponentPlayerId];
          if (!opponent.name || opponent.name === 'Player 2') {
            let opponentNameToUse = currentUser.opponentName;

            // If we don't have opponent name locally, try to get it from Firebase session
            if (!opponentNameToUse && userData?.sessionId) {
              try {
                const sessionRef = ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${opponent.userid}`);
                const sessionSnapshot = await get(sessionRef);
                if (sessionSnapshot.exists()) {
                  const sessionData = sessionSnapshot.val();
                  opponentNameToUse = sessionData.name || sessionData.firstName;
                }
              } catch (error) {
                console.log('Could not fetch opponent name from session:', error);
              }
            }

            if (opponentNameToUse) {
              updates[`games/${gameId}/players/${opponentPlayerId}/name`] = opponentNameToUse;
            }
          }
          if (!opponent.email && currentUser.opponentEmail) {
            updates[`games/${gameId}/players/${opponentPlayerId}/email`] = currentUser.opponentEmail;
          }
        }
      }

      if (Object.keys(updates).length > 0) {
        await update(ref(realtimeDatabase, '/'), updates);
      }

      // Set gameData and board state immediately so joiner can see board and turn (both users can play)
      setGameData(data);
      setCurrentTurn(data.currentTurn || 1);
      if (data.carromMen && data.carromMen.length) {
        carromMenRef.current = data.carromMen;
        setCarromMen(data.carromMen);
      }
      if (data.players) {
        const scores = {};
        const fouls = {};
        Object.keys(data.players).forEach(pid => {
          scores[pid] = data.players[pid].score || 0;
          fouls[pid] = data.players[pid].fouls || 0;
        });
        setScores(scores);
        setFoulCount(fouls);
      }
      setQueenPocketed(data.queenPocketed);
      setMatchFormat(data.matchFormat || 'single');
      setBoardsPlayed(data.boardsPlayed || 0);
      if (data.matchFormat === 'match') {
        setGameType('25/8');
      }

      if (data.status === 'playing' || (isLive && !isLive2v2Reattach)) {
        initializeStriker(data.currentTurn || 1, data.gameMode || '1v1');
      }

      attachGameListener(gameId);

      if (gametypeRef.current === 'tournament' || gametype === 'tournament') {
        await updatePlayerPresence(myUserId);
      }
    } catch (error) {
      Swal.fire('Error', 'Error joining game: ' + error.message, 'error');
    }
  };

  // Create game room (2v2, etc.) – optional code for live-2v2 when creating from menu
  const createRoom = async (user = null, optionalCode = null) => {
    const currentUser = user || { name: playerName };
    if (!realtimeDatabase || !currentUser.name) {
      alert('Please enter your name and initialize Firebase');
      return;
    }

    // Get the correct player name from API data
    let playerNameToUse = currentUser.name;
    if (apiPlayersData && apiPlayersData.length > 0) {
      const thisPlayerFromApi = apiPlayersData.find(p => p.userid === currentUser.userId);
      if (thisPlayerFromApi && thisPlayerFromApi.name) {
        playerNameToUse = thisPlayerFromApi.name;
      }
    }

    const code = optionalCode != null ? optionalCode : (gameId || roomCode || generateRoomCode());
    const newPlayerId = 'player1';
    const isLive2v2 = gametype === 'live-2v2';

    const initialGameState = {
      roomCode: code,
      gameMode: gameMode || '2v2',
      matchFormat: 'single',
      boardsPlayed: 0,
      matchDraw: false,
      host: newPlayerId,
      currentTurn: 1,
      turnStartedAt: null,
      turnDurationMs: 30000,
      shotInProgress: false,
      players: {
        player1: { name: playerNameToUse, userid: currentUser.userId, ready: true, score: 0, fouls: 0, missedTurns: 0 }
      },
      carromMen: initializeCarromMen(),
      striker: null,
      queenPocketed: null,
      queenCovered: false,
      status: 'waiting',
      lobbyStartedAt: isLive2v2 ? null : Date.now(),
      lobbyTimeoutMs: LOBBY_TIMEOUT_MS,
      lobbyTimeoutCancelled: false,
      lobbyTimeoutHandled: false,
      turnLog: [],
      boardResult: null
    };

    try {
      await set(ref(realtimeDatabase, `games/${code}`), initialGameState);
      setRoomCode(code);
      setPlayerId(newPlayerId);
      saveSession(code, newPlayerId, currentUser.name);
      gameStateRef.current = 'lobby';
      setGameState('lobby');

      // Listen to game updates
      attachGameListener(code);

      if (!isLive2v2 && currentUser.userId) {
        await updatePlayerPresence(currentUser.userId);
      }
    } catch (error) {
      alert('Error creating room: ' + error.message);
    }
  };

  // Join game room (optional roomCodeOverride when joining by link/code)
  const joinRoom = async (user = null, roomCodeOverride = null) => {
    const currentUser = user || userData;
    const codeToUse = roomCodeOverride != null ? roomCodeOverride : roomCode;

    if (!realtimeDatabase || !currentUser?.name || !codeToUse) {
      alert('Missing user name or room code, please try again');
      return;
    }

    try {
      const gameRef = ref(realtimeDatabase, `games/${codeToUse}`);
      // Force server read so we don't use stale cache (which can show room as full when it isn't)
      const snapshot = await get(gameRef, { source: 'server' });

      let gameData;
      let isCreatingRoom = false;

      if (!snapshot.exists()) {
        // For live-2v2, never auto-create room; room must exist
        if (gametype === 'live-2v2') {
          alert('Room not found. Check the room code and try again.');
          return;
        }
        // Room doesn't exist, create it
        isCreatingRoom = true;
        const maxPlayers = 2; // Default to 1v1 if room doesn't exist

        const initialGameState = {
          roomCode: codeToUse,
          gameMode: '1v1',
          matchFormat: 'single',
          boardsPlayed: 0,
          matchDraw: false,
          host: 'player1',
          currentTurn: 1,
          turnStartedAt: null,
          turnDurationMs: 30000,
          shotInProgress: false,
          players: {},
          carromMen: initializeCarromMen(),
          striker: null,
          queenPocketed: null,
          queenCovered: false,
          status: 'waiting',
          lobbyStartedAt: Date.now(),
          lobbyTimeoutMs: LOBBY_TIMEOUT_MS,
          lobbyTimeoutCancelled: false,
          lobbyTimeoutHandled: false,
          turnLog: [],
          boardResult: null
        };

        await set(gameRef, initialGameState);
        gameData = initialGameState;
      } else {
        gameData = snapshot.val() || {};
        // Ensure players is always an object (can be missing after leave or partial Firebase data)
        if (!gameData.players || typeof gameData.players !== 'object') {
          gameData.players = {};
        }
      }

      const maxPlayers = (gameData.gameMode === '2v2') ? 4 : 2;
      const is1v1 = gameData.gameMode === '1v1';
      // Count only valid filled slots (player1, player2, ...) with actual data; avoids stale/extra keys
      const validSlots = Array.from({ length: maxPlayers }, (_, i) => `player${i + 1}`);
      const playerCount = validSlots.filter(pid => {
        const p = gameData.players[pid];
        return p && typeof p === 'object' && (p.userid != null || p.name != null);
      }).length;

      console.log('joinRoom - Current players:', gameData.players);
      console.log('joinRoom - Player count:', playerCount, 'Max players:', maxPlayers);

      if (playerCount >= maxPlayers) {
        alert('Room is full!');
        return;
      }

      // Find the next available player slot (for 1v1, second joiner always gets player2 so board sides are correct)
      let newPlayerId = null;
      if (is1v1 && playerCount === 1 && !gameData.players.player2) {
        newPlayerId = 'player2';
      } else {
        for (let i = 1; i <= maxPlayers; i++) {
          const pid = `player${i}`;
          if (!gameData.players[pid]) {
            newPlayerId = pid;
            break;
          }
        }
      }

      console.log('joinRoom - Assigned player ID:', newPlayerId);

      if (!newPlayerId) {
        alert('Room is full!');
        return;
      }

      // Get the correct player name from API data
      let playerNameToUse = currentUser.name;
      if (apiPlayersData && apiPlayersData.length > 0) {
        const thisPlayerFromApi = apiPlayersData.find(p => p.userid === currentUser.userId);
        if (thisPlayerFromApi && thisPlayerFromApi.name) {
          playerNameToUse = thisPlayerFromApi.name;
        }
      }

      // If this is the first player and we're creating a new room, set them as host
      if (isCreatingRoom && newPlayerId === 'player1') {
        await set(ref(realtimeDatabase, `games/${codeToUse}/host`), newPlayerId);
      }

      await update(ref(realtimeDatabase, `games/${codeToUse}/players/${newPlayerId}`), {
        name: playerNameToUse,
        userid: currentUser.userId,
        ready: true,
        score: 0,
        fouls: 0,
        missedTurns: 0
      });

      console.log('joinRoom - Player added to Firebase:', newPlayerId, playerNameToUse);

      setRoomCode(codeToUse);
      setPlayerId(newPlayerId);
      saveSession(codeToUse, newPlayerId, currentUser.name);
      gameStateRef.current = 'lobby';
      setGameState('lobby');

      await updatePlayerPresence(currentUser.userId);

      // Listen to game updates
      attachGameListener(codeToUse);
    } catch (error) {
      alert('Error joining room: ' + error.message);
    }
  };

  // Initialize carrom men positions - Standard Carrom Formation
  const initializeCarromMen = () => {
    const men = [];
    const centerX = BOARD_SIZE / 2;
    const centerY = BOARD_SIZE / 2;
    const pieceSpacing = CARROM_MAN_RADIUS * 2 + 1;

    // Get player colors from API data
    let player1Color = 'white';
    let player2Color = 'black';

    if (apiPlayersData && apiPlayersData.length >= 2) {
      // Find colors for both players from API data
      const player1 = apiPlayersData.find(p => p.userid === userData?.userId);
      const player2 = apiPlayersData.find(p => p.userid !== userData?.userId);

      if (player1?.color && player2?.color) {
        player1Color = player1.color;
        player2Color = player2.color;
      }
    } else if (playerColorFromApi) {
      // Fallback: use current player's color and opposite
      player1Color = playerColorFromApi;
      player2Color = playerColorFromApi === 'white' ? 'black' : 'white';
    }

    // Queen (red) at center
    men.push({
      x: centerX,
      y: centerY,
      color: 'red',
      id: 'queen',
      inPlay: true,
      vx: 0,
      vy: 0,
      radius: CARROM_MAN_RADIUS
    });

    // Standard Y-formation around queen
    // Layer 1: 6 pieces touching the queen in Y-pattern
    const layer1 = [
      { x: centerX, y: centerY - pieceSpacing, color: player1Color }, // top
      { x: centerX - pieceSpacing * Math.cos(Math.PI / 6), y: centerY - pieceSpacing * Math.sin(Math.PI / 6), color: player2Color }, // top-left
      { x: centerX - pieceSpacing * Math.cos(Math.PI / 6), y: centerY + pieceSpacing * Math.sin(Math.PI / 6), color: player1Color }, // bottom-left
      { x: centerX, y: centerY + pieceSpacing, color: player2Color }, // bottom
      { x: centerX + pieceSpacing * Math.cos(Math.PI / 6), y: centerY + pieceSpacing * Math.sin(Math.PI / 6), color: player1Color }, // bottom-right
      { x: centerX + pieceSpacing * Math.cos(Math.PI / 6), y: centerY - pieceSpacing * Math.sin(Math.PI / 6), color: player2Color }, // top-right
    ];

    layer1.forEach((pos, i) => {
      men.push({
        x: pos.x,
        y: pos.y,
        color: pos.color,
        id: `${pos.color}-layer1-${i}`,
        inPlay: true,
        vx: 0,
        vy: 0,
        radius: CARROM_MAN_RADIUS
      });
    });

    // Layer 2: 12 pieces in outer ring
    const layer2Radius = pieceSpacing * 2;
    for (let i = 0; i < 12; i++) {
      const angle = (i * Math.PI) / 6;
      // Alternate colors in outer ring to ensure 9 of each color
      const color = i % 2 === 0 ? player2Color : player1Color;
      men.push({
        x: centerX + Math.cos(angle) * layer2Radius,
        y: centerY + Math.sin(angle) * layer2Radius,
        color: color,
        id: `${color}-layer2-${i}`,
        inPlay: true,
        vx: 0,
        vy: 0,
        radius: CARROM_MAN_RADIUS
      });
    }

    return men;
  };

  // Update local game state from Firebase
  const updateLocalGameState = (data) => {
    if (!data) return;
    if (roomCode && data.roomCode && data.roomCode !== roomCode) {
      return;
    }

    console.log("updateLocalGameState------------", data);

    // Once we're in gameover, ignore later Firebase updates that say 'playing' (e.g. boardReset)
    // so we don't overwrite gameover state and reset the board before API/redirect run
    if (gameStateRef.current === 'gameover' && data.status === 'playing') {
      return;
    }

    const turnChanged = lastTurnRef.current !== data.currentTurn;
    const shouldInitOnTurn = turnChanged && data.status === 'playing' && !data.shotInProgress;

    if (turnChanged && data.status === 'playing') {
      const parsedStart = parseFirebaseTimestamp(data.turnStartedAt);
      turnStartedAtFallbackRef.current = parsedStart ?? Date.now();
      lastTurnClockKeyRef.current = `${data.currentTurn}-${data.turnStartedAt}`;
    }

    const timeoutKeyChanged = data.lastTimeoutKey && data.lastTimeoutKey !== lastProcessedTimeoutKeyRef.current;

    // Derive or re-verify playerId from gameData (fixes both users seeing board on same side)
    const effectivePid = playerIdRef.current ?? playerId;
    const isValidSlot = effectivePid && /^player[1-4]$/.test(effectivePid);
    let myUserId = userData?.userId;
    if (!myUserId) {
      try {
        const parsed = sessionStorage.getItem('userData');
        if (parsed) {
          const u = JSON.parse(parsed);
          myUserId = u?.userId;
        }
      } catch (_) { }
    }
    if ((data.status === 'playing' || data.status === 'waiting') && (data.gameMode === '1v1' || data.gameMode === '2v2') && data.players && myUserId) {
      const slotThatIsMe = (() => {
        for (const [pid, p] of Object.entries(data.players)) {
          if (p?.userid === myUserId) return pid;
        }
        return null;
      })();
      // If we have a slot but it's not us, or we have no slot – set to the slot that matches our userid
      if (slotThatIsMe && effectivePid !== slotThatIsMe) {
        playerIdRef.current = slotThatIsMe;
        setPlayerId(slotThatIsMe);
        const code = roomCode || data.roomCode || listeningRoomRef.current || '';
        saveSession(code, slotThatIsMe, userData?.name || userData?.firstName || 'Player');
      } else if (!isValidSlot && slotThatIsMe) {
        playerIdRef.current = slotThatIsMe;
        setPlayerId(slotThatIsMe);
        const code = roomCode || data.roomCode || listeningRoomRef.current || '';
        saveSession(code, slotThatIsMe, userData?.name || userData?.firstName || 'Player');
      }
    }

    const pidForTurn = playerIdRef.current ?? playerId;
    // We are "mid-shot" if we have a shot turn locked and we're that player – don't let listener overwrite turn or re-init striker until shot completes
    const amShooterByRef = shotTurnRef.current != null && pidForTurn === `player${shotTurnRef.current}`;

    // After 25/8 board reset, ignore listener currentTurn if it differs from the turn we just set (avoids stale snapshot skipping winner's chance)
    const skipTurnFromListener = boardResetLockUntilRef.current && Date.now() < boardResetLockUntilRef.current && data.currentTurn !== boardResetLockTurnRef.current;
    // While we are mid-shot, never apply listener's currentTurn so turn/striker don't switch before physics finishes (prevents jerk / interrupted shot)
    const skipTurnBecauseShooter = amShooterByRef && data.currentTurn !== shotTurnRef.current;
    if (skipTurnFromListener || skipTurnBecauseShooter) {
      // Keep our local turn and lastTurnRef; don't overwrite with possibly stale listener data
    } else {
      if (boardResetLockUntilRef.current) boardResetLockUntilRef.current = 0;
      setCurrentTurn(data.currentTurn);
      lastTurnRef.current = data.currentTurn;
    }
    const men = data.carromMen || [];
    const prevMen = carromMenRef.current || [];
    const prevInPlay = prevMen.filter(m => m.inPlay).length;
    const inPlayCount = men.filter(m => m.inPlay).length;
    const whiteInPlay = men.filter(m => m.inPlay && m.color === 'white').length;
    const blackInPlay = men.filter(m => m.inPlay && m.color === 'black').length;

    const listeningRoom = listeningRoomRef.current;

    // During shot: only observer applies live state; shooter keeps local physics as source of truth
    const isShooter = data.shotInProgress && amShooterByRef;
    const isObserver = data.shotInProgress && pidForTurn !== `player${data.currentTurn}`;
    const liveStriker = data.liveStriker;

    if (!isShooter) {
      carromMenRef.current = men;
      setCarromMen(men);
    }
    if (isObserver && liveStriker && typeof liveStriker.x === 'number' && typeof liveStriker.y === 'number') {
      const copy = { ...liveStriker, radius: liveStriker.radius ?? STRIKER_RADIUS };
      strikerRef.current = copy;
      setStriker(copy);
    }
    setQueenPocketed(data.queenPocketed);
    // For live 1v1: when userData.boardType is 'match', always use 25/8 (match format) even if DB had single
    const effectiveMatchFormat = (data.gameMode === '1v1' && userData?.boardType === 'match')
      ? 'match'
      : (data.matchFormat || 'single');
    setMatchFormat(effectiveMatchFormat);
    setBoardsPlayed(data.boardsPlayed || 0);
    if (effectiveMatchFormat === 'match') {
      setGameType('25/8');
    }

    const scores = {};
    const fouls = {};
    if (data.players) {
      Object.keys(data.players).forEach(pid => {
        scores[pid] = data.players[pid].score || 0;
        fouls[pid] = data.players[pid].fouls || 0;
      });
    }
    setScores(scores);
    setFoulCount(fouls);

    // Use ref to check gameState to avoid stale closure in Firebase listener
    if (data.status === 'playing' && gameStateRef.current !== 'playing') {
      gameStateRef.current = 'playing';
      setGameState('playing');
      initializeStriker(data.currentTurn, data.gameMode);
    }

    if (shouldInitOnTurn && !amShooterByRef) {
      initializeStriker(data.currentTurn, data.gameMode);
    }
    if (timeoutKeyChanged && data.status === 'playing' && !data.shotInProgress) {
      lastProcessedTimeoutKeyRef.current = data.lastTimeoutKey;
      shotTurnRef.current = null;
      turnEndHandledRef.current = null;
      physicsTurnEndingRef.current = false;
      setTimeout(() => {
        initializeStriker(data.currentTurn, data.gameMode);
      }, 500);
    }
    // 25/8 match: after a board reset both clients must re-init striker; clear refs so first shot is attributed correctly. When mid-shot, do not clear refs so first shot of board 2 is not ignored.
    if (data.lastUpdate?.type === 'boardReset' && !amShooterByRef) {
      shotTurnRef.current = null;
      turnEndHandledRef.current = null;
      physicsTurnEndingRef.current = false;
      initializeStriker(data.currentTurn, data.gameMode || gameMode);
    }

    if (!skipTurnFromListener && !skipTurnBecauseShooter) lastTurnRef.current = data.currentTurn;
    console.log("updateLocalGameState status-------------", data.status);
    console.log("updateLocalGameState data-------------", data);

    if (data.status === 'gameover') {
      gameStateRef.current = 'gameover';
      setGameState('gameover');

      // If game ended by someone leaving: other player is winner (API already called by leaver). Show game over popup for both live and tournament; no auto-redirect.
      if (data.gameEndedBy === 'leave') {
        let leaveGametype = gametypeRef.current;
        if (data.gameMode === '1v1' && data.players?.player1?.userid && data.players?.player2?.userid && leaveGametype !== 'tournament') {
          leaveGametype = leaveGametype || 'live';
        }
        if (leaveGametype === 'live') {
          // For live 1v1: don't reset here - each user resets when they click Exit
          const isLive1v1 = data.gameMode === '1v1';
          if (!isLive1v1) resetUsersStatusToOnline(data.players);
        } else if (leaveGametype === 'tournament' && data.gameMode === '1v1') {
          // For tournament 1v1: set status to gameover for both users (do NOT reset to online)
          setUsersStatusToGameover(data.players || {}).catch(err => console.error('Error setting tournament status to gameover:', err));
        }
        const winnerColor = data.winner ? getPlayerColor(data.winner, data.gameMode) : null;
        // Merge scores and ensure BOTH players are shown (data.players may have only one after remove race)
        const dataPlayers = data.players || {};
        const prevPlayers = gameData?.players || {};
        const allPids = [...new Set([...Object.keys(dataPlayers), ...Object.keys(prevPlayers), 'player1', 'player2'])];
        const latestScores = scoresRef.current ?? scores;
        const playersWithScores = allPids.reduce((acc, pid) => {
          const fromData = dataPlayers[pid] || {};
          const fromPrev = prevPlayers[pid] || {};
          const merged = { ...fromData, ...fromPrev, name: fromData?.name || fromPrev?.name };
          const scoreVal = Math.max(
            Number(fromData?.score ?? 0) || 0,
            Number(fromPrev?.score ?? 0) || 0,
            Number(latestScores?.[pid] ?? 0) || 0
          );
          acc[pid] = { ...merged, score: scoreVal };
          return acc;
        }, {});
        setWinnerData({
          winnerColor,
          winner: data.winner,
          gameMode: data.gameMode,
          players: playersWithScores,
          isLive: leaveGametype === 'live',
          currentGametype: leaveGametype
        });
        // Update gameData with merged players so game over popup always shows scores (live 1v1 leave)
        setGameData(prev => prev ? { ...prev, ...data, status: 'gameover', players: playersWithScores } : { ...data, status: 'gameover', players: playersWithScores });
        // Sync scores state so game over popup and scoresRef have correct points for both players
        const scoresFromMerge = Object.keys(playersWithScores).reduce((acc, pid) => {
          acc[pid] = Number(playersWithScores[pid]?.score ?? 0) || 0;
          return acc;
        }, {});
        setScores(prev => ({ ...prev, ...scoresFromMerge }));

        if (leaveGametype === 'tournament') {
          const myPid = playerIdRef.current || playerId;
          if (data.winner && data.winner === myPid && !liveWinnerReportSentRef.current) {
            const wPlayerData = playersWithScores[data.winner] || {};
            const wScore = Number(wPlayerData?.score ?? 0) || 0;
            const wInfo = {
              name: userData?.name ?? wPlayerData?.name ?? '',
              userId: userData?.userId ?? wPlayerData?.userid ?? '',
              sessionId: userData?.sessionId ?? '',
              organizationId: userData?.organizationId ?? '',
              winnerScore: wScore,
            };
            const { url: rUrl, payload: rPayload, reportHeaders: rHeaders } = getReportUrlAndPayload(wInfo);
            if (rUrl) {
              axios.post(rUrl, rPayload, { headers: rHeaders })
                .then(res => {
                  console.log('Tournament leave: winner report saved to API:', res.data);
                  liveWinnerReportSentRef.current = true;
                })
                .catch(err => console.error('Error saving tournament leave winner report:', err));
            }
          }
        }
        return;
      }

      if (data.gameEndedBy === 'missed_turns') {
        if (gametypeRef.current === 'tournament' && data.gameMode === '1v1') {
          setUsersStatusToGameover(data.players || {}).catch((err) => console.error('Error setting tournament status to gameover:', err));
        }
        const winnerColor = data.winner ? getPlayerColor(data.winner, data.gameMode) : null;
        const dataPlayers = data.players || {};
        const prevPlayers = gameData?.players || {};
        const allPids = [...new Set([...Object.keys(dataPlayers), ...Object.keys(prevPlayers), 'player1', 'player2'])];
        const latestScores = scoresRef.current ?? scores;
        const playersWithScores = allPids.reduce((acc, pid) => {
          const fromData = dataPlayers[pid] || {};
          const fromPrev = prevPlayers[pid] || {};
          const merged = { ...fromPrev, ...fromData, name: fromData?.name || fromPrev?.name };
          const scoreVal = Math.max(
            Number(fromData?.score ?? 0) || 0,
            Number(fromPrev?.score ?? 0) || 0,
            Number(latestScores?.[pid] ?? 0) || 0
          );
          acc[pid] = { ...merged, score: scoreVal };
          return acc;
        }, {});
        setWinnerData({
          winnerColor,
          winner: data.winner,
          gameMode: data.gameMode,
          players: playersWithScores,
          isLive: false,
          currentGametype: 'tournament',
        });
        setGameData((prev) => (prev ? { ...prev, ...data, status: 'gameover', players: playersWithScores, boardResult: data.boardResult || prev.boardResult } : { ...data, status: 'gameover', players: playersWithScores }));
        const scoresFromMerge = Object.keys(playersWithScores).reduce((acc, pid) => {
          acc[pid] = Number(playersWithScores[pid]?.score ?? 0) || 0;
          return acc;
        }, {});
        setScores((prev) => ({ ...prev, ...scoresFromMerge }));
        return;
      }

      if (data.gameEndedBy === 'lobby_timeout') {
        if (gametypeRef.current === 'tournament' && data.gameMode === '1v1') {
          setUsersStatusToGameover(data.players || {}).catch((err) => console.error('Error setting tournament status to gameover:', err));
        }
        const winnerColor = data.winner ? resolveWinnerColorForApi(data.winner, data.players || {}, data.gameMode) : null;
        const dataPlayers = data.players || {};
        const prevPlayers = gameData?.players || {};
        const allPids = [...new Set([...Object.keys(dataPlayers), ...Object.keys(prevPlayers), 'player1', 'player2'])];
        const latestScores = scoresRef.current ?? scores;
        const playersWithScores = allPids.reduce((acc, pid) => {
          const fromData = dataPlayers[pid] || {};
          const fromPrev = prevPlayers[pid] || {};
          const merged = { ...fromPrev, ...fromData, name: fromData?.name || fromPrev?.name };
          const scoreVal = Math.max(
            Number(fromData?.score ?? 0) || 0,
            Number(fromPrev?.score ?? 0) || 0,
            Number(latestScores?.[pid] ?? 0) || 0
          );
          acc[pid] = { ...merged, score: scoreVal };
          return acc;
        }, {});
        setWinnerData({
          winnerColor,
          winner: data.winner,
          gameMode: data.gameMode,
          players: playersWithScores,
          isLive: false,
          currentGametype: 'tournament',
        });
        setGameData((prev) => (prev ? { ...prev, ...data, status: 'gameover', players: playersWithScores } : { ...data, status: 'gameover', players: playersWithScores }));
        const scoresFromMerge = Object.keys(playersWithScores).reduce((acc, pid) => {
          acc[pid] = Number(playersWithScores[pid]?.score ?? 0) || 0;
          return acc;
        }, {});
        setScores((prev) => ({ ...prev, ...scoresFromMerge }));
        gameStateRef.current = 'gameover';
        setGameState('gameover');
        return;
      }

      // Handle case where game room is removed after game over (no auto-redirect; user clicks Exit)
      if (data.status === 'removed' && gameStateRef.current === 'gameover') {
        console.log("Game room removed after game over, showing gameover popup...");
        return;
      }

      // Skip handling for 1vCPU - already handled in shot handler via saveCpuWinnerToAPI
      const mode = data.gameMode || gameMode;
      if (mode === '1vcpu') {
        return; // saveCpuWinnerToAPI already handles API, status reset, and redirect
      }

      // Save winner to API when game ends (by game type). Live: API is called from shot handler (winning client); listener only resets users + redirects.
      let currentGametype = gametypeRef.current;
      if (data.winner) {
        const winnerColor = getPlayerColor(data.winner, data.gameMode);
        const currentUserId = userData?.userId;
        const winnerUserId = data.players?.[data.winner]?.userid;
        const isCurrentUserWinner = currentUserId === winnerUserId;

        // Store winner data for API call when exit button is clicked (merge scores so popup shows correct values)
        const playersWithScoresForWinner = (data.players || {});
        const mergedPlayers = Object.keys(playersWithScoresForWinner).length > 0
          ? Object.keys(playersWithScoresForWinner).reduce((acc, pid) => {
            const p = playersWithScoresForWinner[pid] || {};
            const fromData = p?.score ?? 0;
            const fromLocal = scores[pid] ?? 0;
            acc[pid] = { ...p, score: Math.max(Number(fromData) || 0, Number(fromLocal) || 0) };
            return acc;
          }, {})
          : playersWithScoresForWinner;
        setWinnerData({
          winnerColor,
          winner: data.winner,
          gameMode: data.gameMode,
          players: mergedPlayers,
          isLive: currentGametype === 'live',
          currentGametype
        });

        // For tournament games: both winner and loser stay on game over screen with exit button
        // For live 1v1: both stay on gameover popup until user clicks Exit (no auto-redirect)
        // For other non-tournament: winner auto-redirects, loser stays with exit button
        const isLive1v1 = currentGametype === 'live' && (data.gameMode || gameMode) === '1v1';
        if (currentGametype !== 'tournament' && isCurrentUserWinner && !isLive1v1) {
          setTimeout(() => navigate('/allusers'), 1000);
        }
        // Both winner and loser stay on game over screen with exit button for tournament and live 1v1
      }
    }
  };

  const applyLocalGameState = (data) => {
    setGameData(data);
    setCurrentTurn(data.currentTurn);
    const men = data.carromMen || [];
    carromMenRef.current = men;
    setCarromMen(men);
    setQueenPocketed(data.queenPocketed);
    setMatchFormat(data.matchFormat || 'single');
    setBoardsPlayed(data.boardsPlayed || 0);

    const scores = {};
    const fouls = {};
    if (data.players) {
      Object.keys(data.players).forEach(pid => {
        scores[pid] = data.players[pid].score || 0;
        fouls[pid] = data.players[pid].fouls || 0;
      });
    }
    setScores(scores);
    setFoulCount(fouls);
  };

  useEffect(() => {
    if (gameData?.gameMode === '1vcpu') {
      localStorage.setItem('carrom_localGame', JSON.stringify(gameData));
    }
  }, [gameData]);

  // Reset both player and opponent to online in Firebase: sessions/{sessionId}/users/{userId}/status = "online"
  const resetUsersStatusToOnline = async (players) => {
    try {
      if (!userData?.sessionId || !realtimeDatabase || !players) return;
      const statusUpdates = {};
      const userIds = [];
      Object.keys(players).forEach((playerSlot) => {
        const player = players[playerSlot];
        if (player?.userid) {
          userIds.push(player.userid);
          const base = `sessions/${userData.sessionId}/users/${player.userid}`;
          statusUpdates[`${base}/status`] = "online";
          statusUpdates[`${base}/islive`] = true;
          statusUpdates[`${base}/timestamp`] = serverTimestamp();
        }
      });
      if (Object.keys(statusUpdates).length > 0) {
        await update(ref(realtimeDatabase, '/'), statusUpdates);
        console.log('Live game over: both users set to online at sessions/' + userData.sessionId + '/users/', userIds);
      }
    } catch (error) {
      console.error('Error resetting users status:', error);
    }
  };

  // For tournament 1v1: set status to "gameover" (do NOT reset to online)
  const setUsersStatusToGameover = async (players) => {
    try {
      if (!userData?.sessionId || !realtimeDatabase || !players) return;
      const statusUpdates = {};
      Object.keys(players).forEach((playerSlot) => {
        const player = players[playerSlot];
        if (player?.userid) {
          const base = `sessions/${userData.sessionId}/users/${player.userid}`;
          statusUpdates[`${base}/status`] = "gameover";
          statusUpdates[`${base}/timestamp`] = serverTimestamp();
        }
      });
      if (Object.keys(statusUpdates).length > 0) {
        await update(ref(realtimeDatabase, '/'), statusUpdates);
        console.log('Tournament 1v1: users set to gameover status');
      }
    } catch (error) {
      console.error('Error setting users status to gameover:', error);
    }
  };

  const handleGameEnd = async ({ winnerId, winnerColor, gameType, gameMode, players, sessionId, organizationId, outcome = 'win', missedTurns = null }) => {
    if (winnerSavedRef.current) {
      console.log('handleGameEnd: winner already saved, skipping');
      return false;
    }
    if (!winnerId || gameMode !== '1v1') return false;

    try {
      if (gameType === 'live') {
        const livePayload = {
          players,
          winner: winnerId,
          gameMode,
          sessionId: sessionId || userData?.sessionId,
          organizationId: organizationId || userData?.organizationId,
          winnerColor,
        };
        console.log('handleGameEnd: saving live 1v1 result', livePayload);
        await saveLiveWinnerToAPI(livePayload);
        winnerSavedRef.current = true;
        await resetUsersStatusToOnline(players);
      } else if (gameType === 'tournament') {
        console.log('handleGameEnd: saving tournament 1v1 result', winnerId, winnerColor);
        await saveWinnerToAPI(winnerColor, winnerId, players, { outcome, missedTurns });
        winnerSavedRef.current = true;
        if (players && Object.keys(players).length > 0) {
          await setUsersStatusToGameover(players);
        }
      } else {
        return false;
      }
      return true;
    } catch (error) {
      console.error('handleGameEnd: error saving winner', error);
      winnerSavedRef.current = true;
      if (gameType === 'live') {
        try { await resetUsersStatusToOnline(players); } catch (e) { console.error('handleGameEnd: error resetting status', e); }
      } else if (gameType === 'tournament') {
        try { if (players && Object.keys(players).length > 0) await setUsersStatusToGameover(players); } catch (e) { console.error('handleGameEnd: error setting gameover status', e); }
      }
      return false;
    }
  };

  // Report API: guest uses ADD_GUEST_REPORT_URL with full payload; else ADD_REPORT_URL. Payload is winner-only: name, userId, sessionId, organizationId, points (always 0).
  // winnerInfo: { name, userId, sessionId, organizationId } – only these; no winner score (points = 0).
  const getReportUrlAndPayload = (winnerInfo) => {
    console.log("getReportUrlAndPayload winnerInfo-------------", winnerInfo);
    let reportUser = userData;
    try {
      const stored = sessionStorage.getItem('userData');
      if (stored) {
        reportUser = { ...JSON.parse(stored), ...userData };
      }
    } catch (_) { /* ignore parse errors */ }
    const userRole = reportUser?.source || reportUser?.roles;
    const isGuest = userRole === 'GUEST_USER';
    const url = isGuest
      ? process.env.REACT_APP_ADD_GUEST_REPORT_URL
      : process.env.REACT_APP_ADD_REPORT_URL;
    // Report is always winner-only: use winnerInfo for identity. When caller is leaver (leave game) or winner is CPU, don't use userData for identity so DB does not record leaver/user as winner.
    const isReportingForOtherUser = winnerInfo?.userId != null && winnerInfo?.userId !== reportUser?.userId;
    const isCpuWinner = winnerInfo?.userId === 'Cpu' || winnerInfo?.name === 'CPU';
    const useWinnerIdentityOnly = isReportingForOtherUser || isCpuWinner;
    // CPU games: user lost → points 0; user won → points = user's winning score
    const reportPoints = isCpuWinner ? 0 : (winnerInfo?.winnerScore ?? 0);
    const payload = isGuest
      ? {
        gameId: reportUser?.gameId || '',
        name: winnerInfo?.name ?? '',
        sessionId: reportUser?.sessionId ?? '',
        userId: (winnerInfo?.userId ?? reportUser?.userId) ?? '',
        organizationId: reportUser?.organizationId ?? '',
        points: reportPoints,
        time: '00:00:00',
        ans: winnerInfo?.name ?? '',
      }
      : {
        points: reportPoints,
        time: '00:00:00',

      };

     console.log("payload-------------", payload);
     console.log("reportUser token-------------", reportUser?.token);

    const currentToken = isGuest ? null : (reportUser?.token ?? null);
    const reportHeaders = {
      ...(process.env.REACT_APP_CLIENT_SECRET && { 'client-secret': process.env.REACT_APP_CLIENT_SECRET }),
      'Content-Type': 'application/json',
      ...(currentToken && { Authorization: `Bearer ${currentToken}` }),
      'Idempotency-Key': uuidv4(),
    };
    return { url, payload, reportHeaders };
  };

  const calculateBoardWinScore = ({
    winnerSlot,
    loserSlot,
    modeValue,
    carromMen,
    gameSnapshot,
    scoresToUse,
  }) => {
    const men = Array.isArray(carromMen) ? carromMen : [];
    const remainingWhite = men.filter((m) => m.inPlay && m.color === 'white').length;
    const remainingBlack = men.filter((m) => m.inPlay && m.color === 'black').length;
    const loserColor = getPlayerColor(loserSlot, modeValue);
    const winnerColor = getPlayerColor(winnerSlot, modeValue);
    const opponentRemaining = loserColor === 'white' ? remainingWhite : remainingBlack;
    const winnerScoreBefore = Number(
      scoresToUse?.[winnerSlot] ?? gameSnapshot?.players?.[winnerSlot]?.score ?? 0
    );
    const loserFinalScore = Number(
      scoresToUse?.[loserSlot] ?? gameSnapshot?.players?.[loserSlot]?.score ?? 0
    );
    const effectiveQueenCovered = gameSnapshot?.queenCovered === true;
    const effectiveQueenPocketed = gameSnapshot?.queenPocketed ?? null;
    const queenPointsEligible =
      effectiveQueenCovered &&
      effectiveQueenPocketed === winnerSlot &&
      winnerScoreBefore <= QUEEN_BONUS_MAX_SCORE;
    const queenPoints = queenPointsEligible ? QUEEN_BONUS_POINTS : 0;
    const boardPoints = Math.min(MAX_POINTS_PER_BOARD, opponentRemaining + queenPoints);
    const winnerFinalScore = winnerScoreBefore + boardPoints;

    return {
      boardPoints,
      opponentRemaining,
      queenPoints,
      winnerColor,
      winnerFinalScore,
      loserFinalScore,
      winnerPlayers: [winnerSlot],
    };
  };

  const resolveWinnerColorForApi = (winnerSlot, players, modeValue) => {
    const winnerPlayer = players?.[winnerSlot];
    if (winnerPlayer?.userid && Array.isArray(apiPlayersData) && apiPlayersData.length > 0) {
      const apiPlayer = apiPlayersData.find((p) => String(p.userid) === String(winnerPlayer.userid));
      if (apiPlayer?.color) return apiPlayer.color;
    }
    return getPlayerColor(winnerSlot, modeValue, players);
  };

  const saveWinnerToAPI = async (winnerColor, winnerId, players, options = {}) => {
    const { outcome = 'win', missedTurns = null } = options;
    try {
      // Report API – payload with winner user only (no loser): name, userId, sessionId, organizationId; points = 0
      const winnerSlot = winnerId && (winnerId === 'player1' || winnerId === 'player2') ? winnerId : null;

      // Original PHP API – resolve winner by joined player's userid/color, never the current viewer's color
      const modeValue = gameData?.gameMode || gameMode;
      const finalColor = resolveWinnerColorForApi(winnerSlot, players, modeValue) || winnerColor;
      const winnerUserIdForApi = winnerSlot && players?.[winnerSlot]?.userid
        ? String(players[winnerSlot].userid)
        : null;
      const winnerScore = (players && winnerSlot) ? (Number(players[winnerSlot]?.score) ?? 0) : 0;
      const winnerPlayer = (players && winnerSlot) ? players[winnerSlot] : null;
      const isCurrentUserWinner = winnerPlayer?.userid === userData?.userId;
      const winnerInfo = winnerSlot ? {
        name: isCurrentUserWinner ? (userData?.name ?? winnerPlayer?.name) : (winnerPlayer?.name ?? ''),
        userId: isCurrentUserWinner ? (userData?.userId ?? winnerPlayer?.userid) : (winnerPlayer?.userid ?? ''),
        sessionId: isCurrentUserWinner ? (userData?.sessionId ?? winnerPlayer?.sessionId) : (winnerPlayer?.sessionId ?? ''),
        organizationId: isCurrentUserWinner ? (userData?.organizationId ?? winnerPlayer?.organizationId) : (winnerPlayer?.organizationId ?? ''),
        winnerScore: winnerScore,
      } : null;

      // Send report only once per game and only from winner's client (avoids duplicate when both users click Exit to Home)
      if (isCurrentUserWinner && !liveWinnerReportSentRef.current) {
        const { url, payload, reportHeaders } = getReportUrlAndPayload(winnerInfo);
        if (url) {
          try {
            const reportRes = await axios.post(url, payload, {
              headers: reportHeaders
            });
            console.log('Winner report saved to API:', reportRes.data);
            liveWinnerReportSentRef.current = true;
          } catch (reportErr) {
            console.error('Error saving winner report to API:', reportErr);
          }
        }
      }

      const response = await axios.post(
        `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}save-winner.php`,
        {
          color: finalColor,
          winnerId: winnerId,
          winnerUserId: winnerUserIdForApi,
          gameId: gameId,
          tournamentId: tournamentId,
          winnerScore,
          outcome,
          missedTurns: missedTurns || buildMissedTurnsPayload(players),
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('Winner saved to API:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error saving winner to API:', error);
      throw error;
    }
  };

  const declareForfeitWin = async ({
    winnerSlot,
    loserSlot = null,
    winnerScore = FORFEIT_WIN_SCORE,
    gameEndedBy = 'lobby_timeout',
    outcome = 'abandonment',
  }) => {
    if (!realtimeDatabase || !roomCode || gameEndInProgressRef.current) return;

    const data = gameDataRef.current || gameData;
    if (!data) return;
    if (data.status === 'gameover' || data.lobbyTimeoutHandled) return;
    if (gameEndedBy === 'lobby_timeout' && (data.status !== 'waiting' || data.lobbyTimeoutCancelled)) return;
    if (gameEndedBy === 'missed_turns' && data.status !== 'playing') return;

    gameEndInProgressRef.current = true;

    try {
      const snap = await get(ref(realtimeDatabase, `games/${roomCode}`));
      const fresh = snap.exists() ? snap.val() : null;
      if (!fresh || fresh.status === 'gameover') return;
      if (gameEndedBy === 'lobby_timeout' && (fresh.lobbyTimeoutHandled || fresh.lobbyTimeoutCancelled)) return;

      const modeValue = fresh.gameMode || gameMode;
      const players = { ...(fresh.players || {}) };
      const updates = {
        status: 'gameover',
        winner: winnerSlot,
        gameEndedBy,
        turnStartedAt: null,
        shotInProgress: false,
        liveStriker: null,
      };

      let resolvedOutcome = outcome;
      let winnerColorVal = resolveWinnerColorForApi(winnerSlot, players, modeValue);

      if (gameEndedBy === 'missed_turns') {
        const loser = loserSlot || (winnerSlot === 'player1' ? 'player2' : 'player1');
        const scoresToUse = scoresRef.current ?? scores;
        const scoreCalc = calculateBoardWinScore({
          winnerSlot,
          loserSlot: loser,
          modeValue,
          carromMen: fresh.carromMen || carromMenRef.current || [],
          gameSnapshot: fresh,
          scoresToUse,
        });
        winnerColorVal = scoreCalc.winnerColor;
        players[winnerSlot] = { ...(players[winnerSlot] || {}), score: scoreCalc.winnerFinalScore };
        players[loser] = { ...(players[loser] || {}), score: scoreCalc.loserFinalScore };
        const nextBoardsPlayed = (fresh.boardsPlayed || 0) + 1;
        updates[`players/${winnerSlot}/score`] = scoreCalc.winnerFinalScore;
        updates[`players/${loser}/score`] = scoreCalc.loserFinalScore;
        updates.boardResult = {
          boardPoints: scoreCalc.boardPoints,
          opponentRemaining: scoreCalc.opponentRemaining,
          queenPoints: scoreCalc.queenPoints,
          winnerColor: scoreCalc.winnerColor,
          winnerPlayers: scoreCalc.winnerPlayers,
          boardsPlayed: nextBoardsPlayed,
          timestamp: Date.now(),
          endReason: 'missed_turns',
        };
        updates.boardsPlayed = nextBoardsPlayed;
        resolvedOutcome = 'missed_turns';
      } else {
        const winnerScoreNum = Number(winnerScore) || FORFEIT_WIN_SCORE;
        players[winnerSlot] = { ...(players[winnerSlot] || {}), score: winnerScoreNum };
        updates[`players/${winnerSlot}/score`] = winnerScoreNum;
        if (gameEndedBy === 'lobby_timeout') {
          updates.lobbyTimeoutHandled = true;
        }
      }

      await update(ref(realtimeDatabase, `games/${roomCode}`), updates);

      if (gametypeRef.current === 'tournament' && modeValue === '1v1') {
        setWinnerData({
          winnerColor: winnerColorVal,
          winner: winnerSlot,
          gameMode: modeValue,
          players,
          isLive: false,
          currentGametype: 'tournament',
        });
        setScores((prev) => ({
          ...prev,
          player1: Number(players.player1?.score ?? prev.player1 ?? 0),
          player2: Number(players.player2?.score ?? prev.player2 ?? 0),
        }));
        setGameData((prev) => (prev ? { ...prev, ...fresh, ...updates, status: 'gameover', players, boardResult: updates.boardResult || prev.boardResult } : null));
        await handleGameEnd({
          winnerId: winnerSlot,
          winnerColor: winnerColorVal,
          gameType: 'tournament',
          gameMode: modeValue,
          players,
          outcome: resolvedOutcome,
          missedTurns: buildMissedTurnsPayload(players),
        });
        await setUsersStatusToGameover(players);
      }
    } catch (err) {
      console.error('declareForfeitWin error:', err);
    } finally {
      gameEndInProgressRef.current = false;
    }
  };

  const checkMissedTurnForfeit = async (playerSlotId, nextMissedCount) => {
    if (nextMissedCount < MAX_MISSED_TURNS) return;
    const modeValue = gameData?.gameMode || gameMode;
    if (modeValue !== '1v1' || gametypeRef.current !== 'tournament') return;

    const winnerSlot = playerSlotId === 'player1' ? 'player2' : 'player1';
    const players = gameData?.players || {};
    if (!players[winnerSlot]?.userid) return;

    await declareForfeitWin({
      winnerSlot,
      loserSlot: playerSlotId,
      gameEndedBy: 'missed_turns',
      outcome: 'missed_turns',
    });
  };

  // Save live 1v1 game result – report API + original PHP API
  const saveLiveWinnerToAPI = async (data) => {
    try {
      const players = data.players || {};
      const winnerSlot = data.winner;
      const winnerPlayer = players[winnerSlot] || {};
      const loserSlot = winnerSlot === 'player1' ? 'player2' : 'player1';
      const loserPlayer = players[loserSlot] || {};
      const myUserId = userData?.userId;
      const isCurrentUserWinner = winnerPlayer?.userid === myUserId;
      // Original PHP API
      const winnerScore = Number(winnerPlayer?.score) ?? 0;
      const winnerName = isCurrentUserWinner ? (userData?.name || winnerPlayer?.name || '') : (winnerPlayer?.name || '');
      const winnerEmail = isCurrentUserWinner ? (userData?.email || winnerPlayer?.email || '') : (winnerPlayer?.email || '');
      const isCurrentUserLoser = loserPlayer?.userid === myUserId;
      const loserName = isCurrentUserLoser ? (userData?.name || loserPlayer?.name || '') : (loserPlayer?.name || '');
      const loserEmail = isCurrentUserLoser ? (userData?.email || loserPlayer?.email || '') : (loserPlayer?.email || '');
      const loserScore = Number(loserPlayer?.score) ?? 0;

      // Report API – payload with winner user only (no loser). In leave game, caller is leaver so we must pass the remaining player's identity (name, userId, etc.) so DB stores winner correctly, not the leaver.
      const winnerNameForReport = isCurrentUserWinner ? (userData?.name ?? winnerPlayer?.name) : (winnerPlayer?.name ?? data.winnerName ?? '');
      const winnerUserIdForReport = isCurrentUserWinner ? (userData?.userId ?? winnerPlayer?.userid) : (winnerPlayer?.userid ?? '');
      const winnerSessionIdForReport = isCurrentUserWinner ? (userData?.sessionId ?? winnerPlayer?.sessionId) : (winnerPlayer?.sessionId ?? '');
      const winnerOrgIdForReport = isCurrentUserWinner ? (userData?.organizationId ?? winnerPlayer?.organizationId) : (winnerPlayer?.organizationId ?? '');
      const winnerInfo = winnerSlot ? {
        name: winnerNameForReport,
        userId: winnerUserIdForReport,
        sessionId: winnerSessionIdForReport || undefined,
        organizationId: winnerOrgIdForReport || undefined,
        winnerScore: winnerScore,
      } : null;
      // Send report only once per game (ref avoids duplicate when both users call save, or gameover + Exit to Home)
      if (!liveWinnerReportSentRef.current) {
        const { url, payload, reportHeaders } = getReportUrlAndPayload(winnerInfo);
        if (url) {
          try {
            const reportRes = await axios.post(url, payload, {
              headers: reportHeaders
            });
            console.log('Live game winner report saved to API:', reportRes.data);
            liveWinnerReportSentRef.current = true;
          } catch (reportErr) {
            console.error('Error saving live winner report to API:', reportErr);
          }
        }
      }


      const response = await axios.post(
        `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}winner-live.php`,
        {
          gameId: gameId,
          boardtype: userData?.boardType ?? '',
          sessionId: userData?.sessionId ?? '',
          organizationId: userData?.organizationId ?? '',
          winnerScore,
          loserScore,
          data
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('Live game winner saved to API:', response.data);
      return response.data;
    } catch (error) {
      console.error('Error saving live winner to API:', error);
      throw error;
    }
  };

  // Save winner for CPU vs Player games – report API + original PHP API
  const saveCpuWinnerToAPI = async (winnerColor, winnerScore = 0, loserScore = 0) => {
    try {
      // Report API – payload with winner user only (when player wins; when CPU wins use CPU identity so DB does not record the leaver/user as winner)
      const isUserWinner = winnerColor === 'white';
      const isCpuWinner = winnerColor === 'black';
      const winnerUserId = isCpuWinner ? 'Cpu' : userData?.userId;
      const winnerName = isUserWinner ? (userData?.name ?? '') : 'CPU';
      const winnerInfo = {
        color: winnerColor,
        gameId: roomCode || 'LOCAL',
        email: userData?.email,
        isCpuWinner: isCpuWinner ? 1 : 0,
        winnerId: winnerUserId || null,
        winnerScore: Number(winnerScore) || 0,
        loserScore: Number(loserScore) || 0,
        name: winnerName,
        userId: (userData?.userId ?? ''),
        sessionId: userData?.sessionId,
        organizationId: userData?.organizationId
      };

      const { url, payload, reportHeaders } = getReportUrlAndPayload(winnerInfo);
      if (url) {
        try {
          const reportRes = await axios.post(url, payload, {
            headers: reportHeaders
          });
          console.log('CPU winner report saved to API:', reportRes.data);
        } catch (reportErr) {
          console.error('Error saving CPU winner report to API:', reportErr);
        }
      }

      // Original PHP API
      await axios.post(
        `${process.env.REACT_APP_PHP_ADMIN_BASE_URL}winner-cpu.php`,
        {
          color: winnerColor,
          gameId: roomCode || 'LOCAL',
          userId: userData?.userId,
          email: userData?.email,
          sessionId: userData?.sessionId,
          organizationId: userData?.organizationId,
          name: winnerName,
          isCpuWinner: isCpuWinner ? 1 : 0,
          winnerId: winnerUserId || null,
          winnerScore: Number(winnerScore) || 0,
          loserScore: Number(loserScore) || 0
        },
        { headers: { 'Content-Type': 'application/json' } }
      );
      console.log('CPU winner saved to API');

      // Reset user status to "Engaged" in Firebase (only one user in 1vCPU)
      if (userData?.userId && userData?.sessionId) {
        await update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), {
          status: "Engaged",
          islive: true,
          timestamp: serverTimestamp()
        });
        console.log('User status reset to Engaged for CPU game');
      }

      // Do not redirect here – game over popup is shown; user clicks Exit to go to allusers
    } catch (error) {
      console.error('Error saving CPU winner to API:', error);
      // Still reset status and redirect even if API fails
      if (userData?.userId && userData?.sessionId) {
        try {
          await update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), {
            status: "Engaged",
            islive: true,
            timestamp: serverTimestamp()
          });
        } catch (statusError) {
          console.error('Error resetting user status:', statusError);
        }
      }
      setTimeout(() => {
        localStorage.removeItem('carrom_localGame');
        navigate('/allusers');
      }, 1000);
    }
  };

  const saveSession = (code, pid, name) => {
    localStorage.setItem('carrom_roomCode', code);
    localStorage.setItem('carrom_playerId', pid); // store slot id (player1/player2), not userId
    localStorage.setItem('carrom_playerName', name || userData?.name || '');
  };

  /** Leave lobby only – remove self from room so slot is freed; no confirmation. User can rejoin or others can join. */
  const handleLeaveLobby = async () => {
    const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';
    if (isLocalGame || !realtimeDatabase || !roomCode || !playerId) return;
    try {
      const gameRef = ref(realtimeDatabase, `games/${roomCode}`);
      const snapshot = await get(gameRef);
      if (snapshot.exists()) {
        const data = snapshot.val();
        if (data.status === 'waiting') {
          const playerInGameRef = ref(realtimeDatabase, `games/${roomCode}/players/${playerId}`);
          await remove(playerInGameRef);
        }
      }
    } catch (err) {
      console.error('Error leaving lobby:', err);
    }
    clearSession();
    setGameData(null);
    setRoomCode('');
    setPlayerId(null);
    if (gametypeRef.current === 'live') {
      navigate('/allusers');
    } else {
      navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
    }
  };

  const handleLeaveGame = async () => {
    console.log("handleLeaveGame------------", gameData, gameMode);
    const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';

    const result = await Swal.fire({
      title: 'Leave Game?',
      text: 'Are you sure you want to leave the game?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Yes, Leave',
      cancelButtonText: 'Cancel',
      reverseButtons: true
    });

    if (!result.isConfirmed) {
      return; // User cancelled, don't leave the game
    }

    try {
      if (!isLocalGame && realtimeDatabase && roomCode) {
        // For multiplayer games, check if there's only one player left
        const gameRef = ref(realtimeDatabase, `games/${roomCode}`);
        const snapshot = await get(gameRef);
        if (snapshot.exists()) {
          const data = snapshot.val();
          const players = data.players || {};
          const remainingPlayers = Object.keys(players).filter(pid => pid !== playerId);
          // If this is the last player leaving, clean up the game
          if (remainingPlayers.length === 0) {
            await remove(gameRef);
            clearSession();
            setGameData(null);
            setRoomCode('');
            setPlayerId(null);
            const currentGametype = gametypeRef.current;
            if (currentGametype === 'live') {
              navigate('/allusers');
            } else {
              navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
            }
            return;
          }

          // Remove this player from Firebase so the slot is freed (user can leave lobby and rejoin; others can join)
          const playerInGameRef = ref(realtimeDatabase, `games/${roomCode}/players/${playerId}`);
          await remove(playerInGameRef);

          // Leaving from lobby only (game not started) – free the slot and go back; do NOT set game over
          if (data.status === 'waiting') {
            clearSession();
            setGameData(null);
            setRoomCode('');
            setPlayerId(null);
            const currentGametype = gametypeRef.current;
            if (currentGametype === 'live') {
              navigate('/allusers');
            } else {
              navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
            }
            return;
          }

          if (remainingPlayers.length === 1) {
            // If one player leaves during an active game, the remaining player wins
            // But first check if game is already over
            if (gameStateRef.current === 'gameover') {
              await update(gameRef, {
                playerExited: true,
                exitedAt: serverTimestamp(),
                status: 'gameover' // Ensure status remains gameover for remaining player
              });
              clearSession();
              setGameData(null);
              setRoomCode('');
              setPlayerId(null);
              if (userData.gametype === 'live') {
                navigate('/allusers');
              } else {
                navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
              }
            } else {
              const winnerId = remainingPlayers[0];
              const winnerName = players[winnerId]?.name;
              const winnerColor = getPlayerColor(winnerId, data.gameMode);
              const leaverId = playerId;
              const leaverColor = getPlayerColor(leaverId, data.gameMode);

              // Count leaver's remaining coins on the board and transfer to winner
              const currentMen = carromMenRef.current || carromMen || [];
              const leaverRemainingCoins = currentMen.filter(m => m.inPlay && m.color === leaverColor).length;

              // Keep both players' data for game over popup (include leaver's info before they were removed)
              const playersForPopup = { ...players };
              if (gameData?.players?.[playerId]) {
                playersForPopup[playerId] = { ...gameData.players[playerId], name: gameData.players[playerId].name || userData?.name };
              } else {
                playersForPopup[playerId] = { name: userData?.name, userid: userData?.userId };
              }

              const currentGametype = gametypeRef.current;
              // Merge scores and transfer leaver's remaining coins to winner
              const latestScores = scoresRef.current ?? scores;
              const playersForUpdate = (() => {
                const out = {};
                const src = playersForPopup || gameData?.players || data.players || {};
                const allPids = [...new Set([...Object.keys(src), 'player1', 'player2'])];
                allPids.forEach(pid => {
                  const s = src[pid] || {};
                  let scoreVal = Math.max(
                    Number(s?.score ?? 0) || 0,
                    Number(gameData?.players?.[pid]?.score ?? 0) || 0,
                    Number(data.players?.[pid]?.score ?? 0) || 0,
                    Number(latestScores?.[pid] ?? 0) || 0
                  );
                  if (pid === winnerId && leaverRemainingCoins > 0) {
                    scoreVal += leaverRemainingCoins;
                  }
                  out[pid] = { ...s, score: scoreVal };
                });
                return out;
              })();

              await update(gameRef, {
                status: 'gameover',
                winner: winnerId,
                winnerName: winnerName,
                gameEndedBy: 'leave',
                endedAt: serverTimestamp(),
                players: playersForUpdate
              });
              const isLiveLeave = currentGametype === 'live' || (data.gameMode === '1v1' && players?.player1?.userid && players?.player2?.userid);
              const leaveGameType = isLiveLeave ? 'live' : 'tournament';

              await handleGameEnd({
                winnerId,
                winnerColor,
                gameType: leaveGameType,
                gameMode: modeValue,
                players: playersForUpdate,
                sessionId: userData.sessionId,
                organizationId: userData.organizationId,
              });

              const updatedGameData = {
                ...gameData,
                status: 'gameover',
                winner: winnerId,
                winnerName: winnerName,
                gameEndedBy: 'leave',
                players: playersForUpdate
              };
              setGameData(updatedGameData);
              gameStateRef.current = 'gameover';
              setGameState('gameover');
              setWinnerData({
                winnerColor,
                winner: winnerId,
                gameMode: modeValue,
                players: playersForUpdate,
                isLive: isLiveLeave,
                currentGametype: leaveGameType
              });

              if (isLiveLeave) {
                return;
              }
            }
          } else {
            // Normal leave (e.g. 2v2 with 3+ players), player already removed from Firebase above
            if (gameStateRef.current === 'gameover') {
              await update(gameRef, {
                playerExited: true,
                exitedAt: serverTimestamp(),
                status: 'gameover' // Ensure status remains gameover for remaining player
              });
            }
            clearSession();
            setGameData(null);
            setRoomCode('');
            setPlayerId(null);
            if (userData.gametype === 'live') {
              navigate('/allusers');
            } else {
              navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
            }
          }
        }
      }
    }
    catch (error) {
      console.error('Error handling leave game:', error);
      // Fallback navigation
      //navigate('/allusers');
    }
    // alert(isLocalGame);
    // Reset game state to menu for game type selection

    if (isLocalGame) {
      // Player (player1) left vs CPU (player2) → CPU wins; transfer player's remaining coins to CPU
      const latestGameData = gameDataRef.current;
      const currentMen = carromMenRef.current || carromMen || [];
      const playerRemainingCoins = currentMen.filter(m => m.inPlay && m.color === 'white').length;

      const p1FromData = Number(latestGameData?.players?.player1?.score ?? 0) || 0;
      const p2FromData = Number(latestGameData?.players?.player2?.score ?? 0) || 0;
      const p1Score = Math.max(p1FromData, Number(scores?.player1 ?? 0) || 0);
      const p2Score = Math.max(p2FromData, Number(scores?.player2 ?? 0) || 0) + playerRemainingCoins;
      const actualWinner = 'player2';
      const actualWinnerColor = 'black';
      const winnerScoreVal = p2Score;
      const loserScoreVal = p1Score;

      try {
        await saveCpuWinnerToAPI(actualWinnerColor, winnerScoreVal, loserScoreVal);
        console.log("CPU winner saved on leave:", actualWinnerColor, winnerScoreVal, loserScoreVal);
      } catch (apiError) {
        console.error('Error saving CPU winner on leave:', apiError);
      }
      // Do NOT reset status to online here – keep Engaged until user clicks "Exit to Home"
      localStorage.removeItem('cpuGameState');
      localStorage.removeItem('cpuGameScore');
      localStorage.removeItem('cpuGameSettings');
      localStorage.removeItem('lastCpuGame');
      try {
        localStorage.removeItem('carrom_localGame');
        // Show game over popup with actual winner and scores; user clicks Exit to redirect to userpage
        const playersForPopup = {
          player1: { name: playerName || userData?.name || latestGameData?.players?.player1?.name || 'Player 1', score: p1Score },
          player2: { name: 'CPU', score: p2Score }
        };
        setGameData(prev => ({ ...(prev || {}), winner: actualWinner, status: 'gameover', gameMode: '1vcpu', players: playersForPopup }));
        setScores({ player1: p1Score, player2: p2Score, player3: 0, player4: 0 });
        gameStateRef.current = 'gameover';
        setGameState('gameover');
        setWinnerData({
          winner: actualWinner,
          winnerColor: actualWinnerColor,
          players: playersForPopup,
          gameMode: '1vcpu',
          currentGametype: '1vcpu'
        });
      } catch (error) {
        console.error('Error handling local game data:', error);
      }
    }

    // Reset game mode and match format to allow reselection
    setGameMode(null);
  };

  const attachGameListener = (code) => {
    if (!realtimeDatabase || !code) return;
    // For live games, allow listener re-attachment even if game is playing
    // This ensures both players show when second user joins
    if (roomCode && code !== roomCode && gameStateRef.current === 'playing' && gametypeRef.current !== 'live' && gametypeRef.current !== 'live-2v2') {
      return;
    }
    if (gameRef.current) {
      gameRef.current();
    }
    const prevListening = listeningRoomRef.current;
    listeningRoomRef.current = code;
    const roomRef = ref(realtimeDatabase, `games/${code}`);
    const unsubscribe = onValue(roomRef, (snapshot) => {
      const data = snapshot.val();
      if (data) {
        // SPECTATOR: read-only. Reflect the live state locally and never write back.
        if (isSpectatorRef.current) {
          setGameData(data);
          updateLocalGameState(data);
          if (data.status === 'gameover' || data.status === 'completed') {
            gameStateRef.current = 'gameover';
            setGameState('gameover');
            const winnerColor = data.winner ? getPlayerColor(data.winner, data.gameMode) : null;
            setWinnerData({
              winnerColor,
              winner: data.winner,
              gameMode: data.gameMode,
              players: data.players || {},
              isLive: false,
              currentGametype: 'spectator',
              spectator: true
            });
          } else {
            gameStateRef.current = 'playing';
            setGameState('playing');
          }
          return;
        }
        console.log('Firebase update - players:', data.players);
        console.log('Current gameData before update:', gameData?.players);
        setGameData(data);
        updateLocalGameState(data);
        console.log('Current gameData after update:', gameData?.players);

        // Debug: Check if players count changed
        const currentPlayersCount = Object.keys(data.players || {}).length;
        const previousPlayersCount = Object.keys(gameData?.players || {}).length;
        console.log(`Players count change: ${previousPlayersCount} -> ${currentPlayersCount}`);

        // Auto-start tournament 2v2 when lobby is full (1v1 starts when both players auto-ready).
        const isTournament = gametypeRef.current === 'tournament' || gametype === 'tournament';
        if (isTournament && data.status === 'waiting' && !data.lobbyTimeoutCancelled) {
          const lobbyPlayers = data.players || {};
          const requiredForLobby = data.gameMode === '2v2' ? 4 : 2;
          const validLobbySlots = Array.from({ length: requiredForLobby }, (_, i) => `player${i + 1}`);
          const filledLobbySlots = validLobbySlots.filter((pid) => {
            const p = lobbyPlayers[pid];
            return p && (p.userid || p.name);
          });
          if (filledLobbySlots.length >= requiredForLobby) {
            update(ref(realtimeDatabase, `games/${code}`), { lobbyTimeoutCancelled: true }).catch((err) => {
              console.error('Error cancelling lobby timeout:', err);
            });
          }
        }

        if (isTournament && data.status === 'waiting' && data.gameMode === '2v2') {
          const players = data.players || {};
          const currentPlayersCount = Object.keys(players).length;
          const requiredPlayersForMode = data.gameMode === '2v2' ? 4 : 2;

          // Host triggers auto-start when full; any player can trigger as fallback (avoids stuck lobby if host's client lags)
          if (playerId && currentPlayersCount === requiredPlayersForMode) {
            const updates = {};

            // Mark all joined players as ready
            Object.keys(players).forEach((pid) => {
              updates[`players/${pid}/ready`] = true;
            });

            updates['status'] = 'playing';
            updates['turnStartedAt'] = serverTimestamp();
            updates['shotInProgress'] = false;
            updates['turnDurationMs'] = data.turnDurationMs || 30000;

            update(ref(realtimeDatabase, `games/${code}`), updates)
              .then(() => {
                console.log('Tournament game auto-started without lobby');
              })
              .catch((err) => {
                console.error('Error auto-starting tournament game:', err);
              });
          }
        }

        // Handle players exiting during gameover state
        if (data.status === 'players_exiting' && gameState === 'gameover') {
          const exitedPlayers = data.exitedPlayers || [];
          const totalPlayers = Object.keys(data.players || {}).length;

          console.log(`Gameover state - Players exiting: ${exitedPlayers.length}/${totalPlayers}`);

          // If current player hasn't exited yet but others have, show notification
          if (!exitedPlayers.includes(playerId) && exitedPlayers.length > 0) {
            const remainingPlayers = totalPlayers - exitedPlayers.length;
            console.log(`${remainingPlayers} players remaining in game`);

            // If this is the last player, redirect them after a delay
            if (remainingPlayers === 1) {
              setTimeout(() => {
                Swal.fire({
                  title: 'All Players Exited',
                  text: 'All players have exited the game. Redirecting to menu...',
                  icon: 'info',
                  timer: 2000,
                  timerProgressBar: true,
                  showConfirmButton: false
                }).then(() => {
                  if (gametypeRef.current === 'tournament') {
                    navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
                  } else {
                    navigate('/allusers');
                  }
                  // clearSession();
                  setGameData(null);
                  setRoomCode('');
                  setPlayerId(null);
                });
              }, 1000);
            }
          }
        }

        // Check if a player left the lobby
        const currentPlayers = data.players ? Object.keys(data.players).length : 0;
        console.log('Player count change:', previousPlayerCount, '->', currentPlayers);

        if (previousPlayerCount > currentPlayers && currentPlayers > 0 && gameState === 'lobby') {
          // A player left and we're still in lobby
          const isLive2v2 = gametypeRef.current === 'live-2v2';
          Swal.fire({
            title: 'Player Left',
            text: isLive2v2 ? 'Another player has left the lobby.' : 'Another player has left the lobby. Redirecting to tournament structure...',
            icon: 'info',
            timer: isLive2v2 ? 2000 : 3000,
            timerProgressBar: true,
            showConfirmButton: false
          }).then(() => {
            if (isLive2v2) {
              try {
                const ss = sessionStorage.getItem('userData');
                if (realtimeDatabase && ss) {
                  const u = JSON.parse(ss);
                  if (u?.sessionId && u?.userId) {
                    update(ref(realtimeDatabase, `sessions/${u.sessionId}/users/${u.userId}`), { islive: false, live: false }).catch(() => { });
                  }
                }
              } catch (_) { }
              clearSession();
              navigate('/userpage');
            } else {
              navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
            }
          });
        }

        setPreviousPlayerCount(currentPlayers);

        // Handle forfeit game endings synced from Firebase (lobby timeout / missed turns)
        if (data.status === 'gameover' && (data.gameEndedBy === 'lobby_timeout' || data.gameEndedBy === 'missed_turns')) {
          const myPid = playerIdRef.current || playerId;
          if (data.winner && data.winner === myPid && gametypeRef.current === 'tournament' && !winnerSavedRef.current) {
            const winnerColorVal = resolveWinnerColorForApi(data.winner, data.players || {}, data.gameMode);
            handleGameEnd({
              winnerId: data.winner,
              winnerColor: winnerColorVal,
              gameType: 'tournament',
              gameMode: data.gameMode,
              players: data.players || {},
              outcome: data.gameEndedBy === 'missed_turns' ? 'missed_turns' : 'lobby_timeout',
              missedTurns: buildMissedTurnsPayload(data.players),
            }).catch((err) => console.error('Error saving forfeit winner:', err));
          }
        }
      } else if (gameState === 'lobby') {
        // Game room was completely removed
        const isLive2v2 = gametypeRef.current === 'live-2v2';
        Swal.fire({
          title: 'Game Ended',
          text: isLive2v2 ? 'The game has been ended.' : 'The game has been ended. Redirecting to tournament structure...',
          icon: 'info',
          timer: isLive2v2 ? 2000 : 3000,
          timerProgressBar: true,
          showConfirmButton: false
        }).then(() => {
          if (isLive2v2) {
            try {
              const ss = sessionStorage.getItem('userData');
              if (realtimeDatabase && ss) {
                const u = JSON.parse(ss);
                if (u?.sessionId && u?.userId) {
                  update(ref(realtimeDatabase, `sessions/${u.sessionId}/users/${u.userId}`), { islive: false, live: false }).catch(() => { });
                }
              }
            } catch (_) { }
            clearSession();
            navigate('/userpage');
          } else {
            navigate(`/tournamentStructure?tournamentId=${tournamentId}`);
          }
        });
      }
    });
    gameRef.current = unsubscribe;
  };

  // Auto-mark player ready and start game when all players are ready
  const checkAndStartGameIfAllReady = async (code) => {
    if (!realtimeDatabase || !code) return;

    const freshSnapshot = await get(ref(realtimeDatabase, `games/${code}`));
    const freshData = freshSnapshot.exists() ? freshSnapshot.val() : null;
    if (!freshData || freshData.status !== 'waiting') return;

    const players = freshData.players || {};
    const playerCount = Object.keys(players).length;
    const requiredPlayers = freshData.gameMode === '2v2' ? 4 : 2;
    const allReady = playerCount === requiredPlayers && Object.values(players).every((p) => p.ready);

    if (allReady) {
      await update(ref(realtimeDatabase, `games/${code}`), {
        status: 'playing',
        turnStartedAt: serverTimestamp(),
        shotInProgress: false,
        turnDurationMs: freshData.turnDurationMs || 30000,
        currentTurn: 1,
        lobbyTimeoutCancelled: true,
      });
    }
  };

  const markPlayerReady = async () => {
    if (!realtimeDatabase || !roomCode || !playerId) return;

    try {
      const currentReady = gameData?.players?.[playerId]?.ready || false;
      if (!currentReady) {
        await update(ref(realtimeDatabase, `games/${roomCode}/players/${playerId}`), {
          ready: true,
        });
        await updatePlayerPresence(userData?.userId);
      }
      await checkAndStartGameIfAllReady(roomCode);
    } catch (error) {
      console.error('Error marking ready:', error);
    }
  };

  useEffect(() => {
    if (gameState !== 'lobby') {
      autoReadyInProgressRef.current = false;
      return;
    }
    if (gametype !== 'tournament' && gametype !== 'live-2v2') return;
    if (!roomCode || !playerId || !realtimeDatabase) return;

    const isReady = gameData?.players?.[playerId]?.ready;
    if (!isReady) {
      if (autoReadyInProgressRef.current) return;
      autoReadyInProgressRef.current = true;
      markPlayerReady().finally(() => {
        autoReadyInProgressRef.current = false;
      });
      return;
    }

    checkAndStartGameIfAllReady(roomCode);
  }, [
    gameState,
    gametype,
    roomCode,
    playerId,
    gameData?.players?.[playerId]?.ready,
    gameData?.players ? Object.keys(gameData.players).length : 0,
    gameData?.players ? Object.values(gameData.players).filter((p) => p.ready).length : 0,
  ]);

  // Initialize striker position
  const initializeStriker = (playerNum, modeOverride) => {
    const mode = modeOverride || gameData?.gameMode || gameMode;
    const seat = getPlayerSeat(playerNum, mode);
    const baseline = getBaselineForSeat(seat);
    // Striker center can go from red circle to red circle (full baseline extent)
    const center = (baseline.min + baseline.max) / 2;

    const newStriker = {
      x: baseline.axis === 'x' ? center : baseline.fixed,
      y: baseline.axis === 'y' ? center : baseline.fixed,
      vx: 0,
      vy: 0,
      inPlay: true,
      radius: STRIKER_RADIUS
    };


    strikerRef.current = newStriker; // Also update ref
    setStriker(newStriker);
  };

  const syncStrikerAfterTurnTimeout = (turnNum, modeValue, turnStartedAt = null) => {
    shotTurnRef.current = null;
    turnEndHandledRef.current = null;
    physicsTurnEndingRef.current = false;
    setCurrentTurn(turnNum);
    lastTurnRef.current = turnNum;
    const parsedStart = parseFirebaseTimestamp(turnStartedAt);
    turnStartedAtFallbackRef.current = parsedStart ?? Date.now();
    lastTurnClockKeyRef.current = `${turnNum}-${turnStartedAt}`;
    setTimeout(() => {
      initializeStriker(turnNum, modeValue);
    }, 500);
  };

  // Physics update
  const updatePhysics = async () => {
    // Use refs for physics to avoid React state timing issues
    if (!strikerRef.current || !carromMenRef.current.length || !isAnimating) return;
    // Already ending turn this frame – skip so we don't run turn-end logic twice
    if (physicsTurnEndingRef.current) return;

    let newStriker = { ...strikerRef.current };
    let newMen = carromMenRef.current.map(m => ({ ...m }));
    let isMoving = false;
    let pocketedPieces = [];

    // Apply pending shot velocity (from ref, bypasses React state timing issues)
    if (pendingShotRef.current) {
      // Enforce baseline position: snap striker to the correct baseline before applying velocity
      const shotTurn = shotTurnRef.current ?? currentTurn;
      const shotMode = gameData?.gameMode || gameMode;
      const shotSeat = getPlayerSeat(shotTurn, shotMode);
      const shotBaseline = getBaselineForSeat(shotSeat);
      if (shotBaseline.axis === 'x') {
        newStriker.y = shotBaseline.fixed;
        newStriker.x = Math.max(shotBaseline.min, Math.min(shotBaseline.max, newStriker.x));
      } else {
        newStriker.x = shotBaseline.fixed;
        newStriker.y = Math.max(shotBaseline.min, Math.min(shotBaseline.max, newStriker.y));
      }
      newStriker.vx = pendingShotRef.current.vx;
      newStriker.vy = pendingShotRef.current.vy;
      pendingShotRef.current = null;
      physicsStableFramesRef.current = 0; // New shot – require stable frames again before switching turn
    }

    const recordPocketed = (piece) => {
      if (!piece || !piece.id) return;
      if (!pocketedThisTurnRef.current.find(p => p.id === piece.id)) {
        pocketedThisTurnRef.current.push({ id: piece.id, color: piece.color });
      }
    };

    const pockets = [
      { x: BOARD_PADDING, y: BOARD_PADDING },
      { x: BOARD_SIZE - BOARD_PADDING, y: BOARD_PADDING },
      { x: BOARD_PADDING, y: BOARD_SIZE - BOARD_PADDING },
      { x: BOARD_SIZE - BOARD_PADDING, y: BOARD_SIZE - BOARD_PADDING }
    ];

    // Only treat as "inside pocket" when actually within pocketing distance (so brown patch is always blocked)
    const isInsidePocket = (x, y, radius) => {
      return pockets.some(pocket => {
        const dx = x - pocket.x;
        const dy = y - pocket.y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        return dist < POCKET_RADIUS + radius * 0.2;
      });
    };

    // Update striker (save old position and pre-friction velocity for collision impulse)
    let oldStrikerX = newStriker.x;
    let oldStrikerY = newStriker.y;
    let preFrictionVx = newStriker.vx;
    let preFrictionVy = newStriker.vy;
    if (Math.abs(newStriker.vx) > 0.1 || Math.abs(newStriker.vy) > 0.1) {
      isMoving = true;
      newStriker.x += newStriker.vx;
      newStriker.y += newStriker.vy;
      newStriker.vx *= FRICTION;
      newStriker.vy *= FRICTION;

      // Slow down more when very slow
      if (Math.abs(newStriker.vx) < 0.3) newStriker.vx *= 0.95;
      if (Math.abs(newStriker.vy) < 0.3) newStriker.vy *= 0.95;

      // Check pocket: only pocket when actually inside pocket opening
      if (isInsidePocket(newStriker.x, newStriker.y, newStriker.radius)) {
        pockets.forEach(pocket => {
          const dx = newStriker.x - pocket.x;
          const dy = newStriker.y - pocket.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          if (dist < POCKET_RADIUS + newStriker.radius * 0.2) {
            newStriker.inPlay = false;
            isMoving = false;
          }
        });
      }

      // Wall collisions: always block brown patch (play area boundary) unless just pocketed
      if (newStriker.inPlay) {
        const minX = BOARD_PADDING + newStriker.radius;
        const maxX = BOARD_SIZE - BOARD_PADDING - newStriker.radius;
        const minY = BOARD_PADDING + newStriker.radius;
        const maxY = BOARD_SIZE - BOARD_PADDING - newStriker.radius;

        if (newStriker.x < minX || newStriker.x > maxX) {
          newStriker.vx *= -RESTITUTION;
          newStriker.x = Math.max(minX, Math.min(maxX, newStriker.x));
        }
        if (newStriker.y < minY || newStriker.y > maxY) {
          newStriker.vy *= -RESTITUTION;
          newStriker.y = Math.max(minY, Math.min(maxY, newStriker.y));
        }
      }
    } else {
      // Stop completely when velocity is very low
      newStriker.vx = 0;
      newStriker.vy = 0;
    }

    // Update carrom men
    newMen = newMen.map(man => {
      if (!man.inPlay) return man;

      const newMan = { ...man };

      if (Math.abs(newMan.vx) > 0.1 || Math.abs(newMan.vy) > 0.1) {
        isMoving = true;
        newMan.x += newMan.vx;
        newMan.y += newMan.vy;
        newMan.vx *= FRICTION;
        newMan.vy *= FRICTION;

        if (Math.abs(newMan.vx) < 0.3) newMan.vx *= 0.95;
        if (Math.abs(newMan.vy) < 0.3) newMan.vy *= 0.95;

        // Check pocket: only pocket when actually inside pocket opening
        if (isInsidePocket(newMan.x, newMan.y, newMan.radius)) {
          pockets.forEach(pocket => {
            const dx = newMan.x - pocket.x;
            const dy = newMan.y - pocket.y;
            const dist = Math.sqrt(dx * dx + dy * dy);
            if (dist < POCKET_RADIUS + newMan.radius * 0.2) {
              newMan.inPlay = false;
              pocketedPieces.push(newMan);
              recordPocketed(newMan);
            }
          });
        }

        // Wall collisions: always block brown patch (keep coins on play surface) unless just pocketed
        if (newMan.inPlay) {
          const minX = BOARD_PADDING + newMan.radius;
          const maxX = BOARD_SIZE - BOARD_PADDING - newMan.radius;
          const minY = BOARD_PADDING + newMan.radius;
          const maxY = BOARD_SIZE - BOARD_PADDING - newMan.radius;

          if (newMan.x < minX || newMan.x > maxX) {
            newMan.vx *= -RESTITUTION;
            newMan.x = Math.max(minX, Math.min(maxX, newMan.x));
          }
          if (newMan.y < minY || newMan.y > maxY) {
            newMan.vy *= -RESTITUTION;
            newMan.y = Math.max(minY, Math.min(maxY, newMan.y));
          }
        }
      } else {
        // Stop completely when velocity is very low
        newMan.vx = 0;
        newMan.vy = 0;
      }

      return newMan;
    });

    // Collision detection between striker and carrom men (iterative to fix deep overlap / nearest-coin)
    // 1) Sweep test: detect high-speed hits where striker tunnels past the coin in one frame (no overlap at frame end)
    let sweptCoinIndex = -1;
    if (newStriker.inPlay) {
      const ax = oldStrikerX, ay = oldStrikerY;
      const bx = newStriker.x, by = newStriker.y;
      const vx = bx - ax, vy = by - ay;
      const segLenSq = vx * vx + vy * vy;

      const sweepHits = [];
      newMen.forEach((man, index) => {
        if (!man.inPlay) return;
        const manRadius = man.radius ?? CARROM_MAN_RADIUS;
        const minDist = newStriker.radius + manRadius;
        const cx = man.x, cy = man.y;
        const dx = newMen[index].x - newStriker.x, dy = newMen[index].y - newStriker.y;
        const distNow = Math.sqrt(dx * dx + dy * dy);
        if (distNow < minDist) return; // will be handled by overlap loop

        // Closest point on segment (ax,ay)-(bx,by) to coin center (cx,cy)
        const wx = cx - ax, wy = cy - ay;
        const t = segLenSq < 1e-6 ? 0 : Math.max(0, Math.min(1, (wx * vx + wy * vy) / segLenSq));
        const closestX = ax + t * vx, closestY = ay + t * vy;
        const distAtClosest = Math.hypot(cx - closestX, cy - closestY);
        if (distAtClosest > minDist) return;

        const nx = (cx - closestX) / (distAtClosest || 1);
        const ny = (cy - closestY) / (distAtClosest || 1);
        sweepHits.push({ index, t, distAtClosest, nx, ny });
      });

      // Apply impulse to first coin hit along the path (nearest in time)
      if (sweepHits.length > 0) {
        sweepHits.sort((a, b) => a.t - b.t);
        const hit = sweepHits[0];
        const index = hit.index;
        sweptCoinIndex = index;
        const totalMass = STRIKER_MASS + CARROM_MAN_MASS;
        const speed = Math.hypot(newStriker.vx, newStriker.vy);
        const velocityAlongNormal = newStriker.vx * hit.nx + newStriker.vy * hit.ny;
        const impulseMagnitude = Math.max(
          speed * 0.8 * (STRIKER_MASS * CARROM_MAN_MASS) / totalMass,
          (1 + RESTITUTION) * Math.max(0, velocityAlongNormal) * (STRIKER_MASS * CARROM_MAN_MASS) / totalMass
        );
        const impulseX = impulseMagnitude * hit.nx;
        const impulseY = impulseMagnitude * hit.ny;
        newStriker.vx -= impulseX / STRIKER_MASS;
        newStriker.vy -= impulseY / STRIKER_MASS;
        newMen[index].vx += impulseX / CARROM_MAN_MASS;
        newMen[index].vy += impulseY / CARROM_MAN_MASS;
      }
    }

    // 2) Overlap resolution (and impulse when overlapping)
    if (newStriker.inPlay) {
      const COLLISION_EPS = 2; // use velocity-based normal when centres within 2px (avoid wrong separation)
      const MAX_STRIKER_COIN_ITER = 4; // resolve overlap fully so striker doesn't sit on coin
      for (let iter = 0; iter < MAX_STRIKER_COIN_ITER; iter++) {
        let anyOverlap = false;
        // Sort indices by distance to striker so nearest coin is processed first
        const indicesByDist = newMen
          .map((man, index) => ({ index, dist: man.inPlay ? Math.hypot(man.x - newStriker.x, man.y - newStriker.y) : Infinity }))
          .filter(({ dist }) => dist < Infinity)
          .sort((a, b) => a.dist - b.dist)
          .map(({ index }) => index);

        indicesByDist.forEach((index) => {
          const man = newMen[index];
          if (!man.inPlay) return;

          const dx = newMen[index].x - newStriker.x;
          const dy = newMen[index].y - newStriker.y;
          const dist = Math.sqrt(dx * dx + dy * dy);
          const manRadius = man.radius ?? CARROM_MAN_RADIUS;
          const minDist = newStriker.radius + manRadius;

          if (dist < minDist) {
            anyOverlap = true;
            const overlap = minDist - dist;
            // Safe collision normal: when dist tiny or very small, use striker velocity so we push coin away correctly
            let nx = dx;
            let ny = dy;
            if (dist < COLLISION_EPS) {
              const speed = Math.sqrt(newStriker.vx * newStriker.vx + newStriker.vy * newStriker.vy);
              if (speed > 0.05) {
                nx = newStriker.vx / speed;
                ny = newStriker.vy / speed;
              } else {
                nx = dist > 0.001 ? dx / dist : 1;
                ny = dist > 0.001 ? dy / dist : 0;
              }
            } else {
              nx = dx / dist;
              ny = dy / dist;
            }

            // Separate: striker back, coin forward (guarantee at least minDist)
            const separationRatio = 0.55; // striker heavier, moves less
            const extraPush = 1.05;
            const strikerSep = overlap * (1 - separationRatio) * extraPush;
            const manSep = overlap * separationRatio * extraPush;

            newStriker.x -= nx * strikerSep;
            newStriker.y -= ny * strikerSep;
            newMen[index].x += nx * manSep;
            newMen[index].y += ny * manSep;

            // Velocity transfer (skip if this coin already got impulse from sweep hit to avoid double-impulse)
            if (index !== sweptCoinIndex) {
              const relativeVx = newStriker.vx - newMen[index].vx;
              const relativeVy = newStriker.vy - newMen[index].vy;
              const velocityAlongNormal = relativeVx * nx + relativeVy * ny;
              const totalMass = STRIKER_MASS + CARROM_MAN_MASS;

              let impulseMagnitude;
              if (velocityAlongNormal > 0) {
                impulseMagnitude = 1.25 * (1 + RESTITUTION) * velocityAlongNormal * (STRIKER_MASS * CARROM_MAN_MASS) / totalMass;
              } else {
                // Overlap or tunneled: ensure coin gets a strong push so it visibly moves
                const minImpulseFromOverlap = Math.max(overlap * 1.2, 3) * (STRIKER_MASS * CARROM_MAN_MASS) / totalMass;
                const fromVelocity = -velocityAlongNormal * (STRIKER_MASS * CARROM_MAN_MASS) / totalMass * 0.6;
                impulseMagnitude = Math.max(minImpulseFromOverlap, fromVelocity);
              }

              const impulseX = impulseMagnitude * nx;
              const impulseY = impulseMagnitude * ny;

              newStriker.vx -= impulseX / STRIKER_MASS;
              newStriker.vy -= impulseY / STRIKER_MASS;
              newMen[index].vx += impulseX / CARROM_MAN_MASS;
              newMen[index].vy += impulseY / CARROM_MAN_MASS;
            }
          }
        });
        if (!anyOverlap) break;
      }
    }

    // Collision detection between carrom men
    for (let i = 0; i < newMen.length; i++) {
      if (!newMen[i].inPlay) continue;

      for (let j = i + 1; j < newMen.length; j++) {
        if (!newMen[j].inPlay) continue;

        const dx = newMen[j].x - newMen[i].x;
        const dy = newMen[j].y - newMen[i].y;
        const dist = Math.sqrt(dx * dx + dy * dy);
        const minDist = newMen[i].radius + newMen[j].radius;

        if (dist < minDist && dist > 0.1) {
          const angle = Math.atan2(dy, dx);
          const overlap = minDist - dist;

          // Separate pieces equally (same mass)
          const separationX = Math.cos(angle) * overlap * 0.5;
          const separationY = Math.sin(angle) * overlap * 0.5;

          newMen[i].x -= separationX;
          newMen[i].y -= separationY;
          newMen[j].x += separationX;
          newMen[j].y += separationY;

          // Calculate relative velocity
          const relativeVx = newMen[i].vx - newMen[j].vx;
          const relativeVy = newMen[i].vy - newMen[j].vy;

          // Velocity along collision normal
          const velocityAlongNormal = relativeVx * Math.cos(angle) + relativeVy * Math.sin(angle);

          if (velocityAlongNormal > 0) {
            // Equal mass collision
            const impulseMagnitude = (1 + RESTITUTION) * velocityAlongNormal * 0.5;

            const impulseX = impulseMagnitude * Math.cos(angle);
            const impulseY = impulseMagnitude * Math.sin(angle);

            newMen[i].vx -= impulseX;
            newMen[i].vy -= impulseY;
            newMen[j].vx += impulseX;
            newMen[j].vy += impulseY;
          }
        }
      }
    }

    // Update refs immediately (for next physics frame)
    strikerRef.current = newStriker;
    carromMenRef.current = newMen;

    // Final clamp: ensure no in-play piece stays in the brown (e.g. after collision resolution)
    if (newStriker.inPlay) {
      const minX = BOARD_PADDING + newStriker.radius;
      const maxX = BOARD_SIZE - BOARD_PADDING - newStriker.radius;
      const minY = BOARD_PADDING + newStriker.radius;
      const maxY = BOARD_SIZE - BOARD_PADDING - newStriker.radius;
      newStriker.x = Math.max(minX, Math.min(maxX, newStriker.x));
      newStriker.y = Math.max(minY, Math.min(maxY, newStriker.y));
    }
    newMen.forEach((m) => {
      if (!m.inPlay) return;
      const minX = BOARD_PADDING + m.radius;
      const maxX = BOARD_SIZE - BOARD_PADDING - m.radius;
      const minY = BOARD_PADDING + m.radius;
      const maxY = BOARD_SIZE - BOARD_PADDING - m.radius;
      m.x = Math.max(minX, Math.min(maxX, m.x));
      m.y = Math.max(minY, Math.min(maxY, m.y));
    });

    // Update React state (for rendering)
    setStriker(newStriker);
    setCarromMen(newMen);

    // Stream live state to Firebase during shot so opponent sees movement in real time
    const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';
    const amShooter = playerId === `player${shotTurnRef.current}`;
    if (!isLocalGame && realtimeDatabase && roomCode && amShooter && Date.now() - lastLiveStateWriteRef.current > 60) {
      lastLiveStateWriteRef.current = Date.now();
      const serializedMen = newMen.map(m => ({
        id: m.id, x: m.x, y: m.y, vx: m.vx ?? 0, vy: m.vy ?? 0,
        inPlay: !!m.inPlay, color: m.color, radius: m.radius ?? CARROM_MAN_RADIUS
      }));
      const serializedStriker = {
        x: newStriker.x, y: newStriker.y, vx: newStriker.vx ?? 0, vy: newStriker.vy ?? 0,
        inPlay: !!newStriker.inPlay, radius: newStriker.radius ?? STRIKER_RADIUS
      };
      update(ref(realtimeDatabase, `games/${roomCode}`), {
        carromMen: serializedMen,
        liveStriker: serializedStriker
      }).catch(err => console.error('Live state write error:', err));
    }

    // Board stable check: only switch turn when ALL bodies have stopped (allBodiesSleeping)
    const strikerMoving = Math.abs(newStriker.vx) > VELOCITY_SLEEP_THRESHOLD || Math.abs(newStriker.vy) > VELOCITY_SLEEP_THRESHOLD;
    const anyCoinMoving = newMen.some(m => m.inPlay && (Math.abs(m.vx) > VELOCITY_SLEEP_THRESHOLD || Math.abs(m.vy) > VELOCITY_SLEEP_THRESHOLD));
    const anythingMoving = strikerMoving || anyCoinMoving;

    if (anythingMoving) {
      physicsStableFramesRef.current = 0;
    } else {
      physicsStableFramesRef.current = (physicsStableFramesRef.current || 0) + 1;
    }

    // End turn ONLY after all pieces have stopped AND we've seen enough consecutive stable frames (prevents jerk/premature switch)
    const allBodiesSleeping = !anythingMoving && physicsStableFramesRef.current >= STABLE_FRAMES_REQUIRED;
    if (allBodiesSleeping) {
      physicsStableFramesRef.current = 0;
      // Zero striker velocity so it never "moves again" from residual velocity or a stray frame
      newStriker.vx = 0;
      newStriker.vy = 0;
      strikerRef.current = newStriker;
      setStriker(newStriker);
      pendingShotRef.current = null;
      physicsTurnEndingRef.current = true;
      setIsAnimating(false);
      const allPocketedThisTurn = pocketedThisTurnRef.current.length
        ? pocketedThisTurnRef.current
        : pocketedPieces;
      await handleTurnEnd(newStriker, allPocketedThisTurn, newMen);
      pocketedThisTurnRef.current = [];
    }
  };

  // Handle turn end – only called from physics when allBodiesSleeping (turn must NOT switch while striker/coins are moving)
  const handleTurnEnd = async (finalStriker, pocketedPieces, finalMen = carromMen) => {
    const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';
    if (!isLocalGame && (!realtimeDatabase || !roomCode)) return;

    // Defensive: never switch turn if any body is still moving (prevents premature turn change / jerk)
    const strikerMoving = finalStriker && (Math.abs(finalStriker.vx ?? 0) > VELOCITY_SLEEP_THRESHOLD || Math.abs(finalStriker.vy ?? 0) > VELOCITY_SLEEP_THRESHOLD);
    const anyPieceMoving = (finalMen || []).some(m => m.inPlay && (Math.abs(m.vx ?? 0) > VELOCITY_SLEEP_THRESHOLD || Math.abs(m.vy ?? 0) > VELOCITY_SLEEP_THRESHOLD));
    if (strikerMoving || anyPieceMoving) return;

    // Ensure no queued shot can fire after turn ends (stops striker moving again automatically)
    pendingShotRef.current = null;

    // Use turn at shot start to avoid wrong turn when listener has already updated currentTurn
    const turnForThisShot = shotTurnRef.current ?? currentTurn;
    const turnKey = `${roomCode || 'local'}-${turnForThisShot}-${finalStriker?.x ?? 0}-${finalStriker?.y ?? 0}`;
    if (turnEndHandledRef.current === turnKey) return;
    turnEndHandledRef.current = turnKey;

    const currentPlayerId = `player${turnForThisShot}`;
    // Use API color for multiplayer games, fallback to calculated color for CPU games
    let playerColor;
    if (gameData?.gameMode === '1vcpu') {
      playerColor = getPlayerColor(currentPlayerId, gameData?.gameMode || gameMode);
    } else {
      // For multiplayer games, check if current player matches the API color
      const currentPlayer = gameData?.players?.[currentPlayerId];
      const currentPlayerUserId = currentPlayer?.userid || userData?.userId;

      // Find this player in the API data to get their correct color
      const thisPlayerFromApi = apiPlayersData?.find(
        (p) => p.userid === currentPlayerUserId
      );

      playerColor = thisPlayerFromApi?.color || getPlayerColor(currentPlayerId, gameData?.gameMode || gameMode);
    }
    const opponentColor = playerColor === 'white' ? 'black' : 'white';
    const matchFormatValue = gameData?.matchFormat || matchFormat || 'single';
    const updatedMen = finalMen.map(piece => ({ ...piece }));
    const currentPlayerName = gameData?.players?.[currentPlayerId]?.name || currentPlayerId;
    const logEntries = [...(gameData?.turnLog || [])];
    const addLog = (message) => {
      logEntries.push({ message, ts: Date.now(), by: currentPlayerId });
      if (logEntries.length > 50) {
        logEntries.splice(0, logEntries.length - 50);
      }
    };

    let strikerFoul = !finalStriker.inPlay;
    let strikerOffBaselineFoul = false;
    let strikerOnBaseCircleFoul = false;
    const shotStartPos = shotStartStrikerRef.current;
    if (shotStartPos) {
      const modeValue = gameData?.gameMode || gameMode;
      const seat = getPlayerSeat(turnForThisShot, modeValue);
      const bl = getBaselineForSeat(seat);
      const perpTolerance = BASELINE_THICKNESS / 2; // Striker center must be within baseline band
      const onBaseline = bl.axis === 'x'
        ? (Math.abs(shotStartPos.y - bl.fixed) <= perpTolerance &&
          shotStartPos.x >= bl.min && shotStartPos.x <= bl.max)
        : (Math.abs(shotStartPos.x - bl.fixed) <= perpTolerance &&
          shotStartPos.y >= bl.min && shotStartPos.y <= bl.max);
      if (!onBaseline) strikerOffBaselineFoul = true;
      // Base circle foul: only for human (in 1vCPU, human is turn 1)
      const isHumanShooter = modeValue !== '1vcpu' || turnForThisShot === 1;
      if (isHumanShooter) {
        const baseCircles = getBaseCirclesForSeat(seat);
        const overlapDist = STRIKER_RADIUS + BASE_CIRCLE_RADIUS;
        // Foul when striker is half on circle (overlap but center outside); no foul when fully on circle (center inside)
        if (baseCircles.some(c => {
          const d = Math.hypot(shotStartPos.x - c.x, shotStartPos.y - c.y);
          return d < overlapDist && d >= BASE_CIRCLE_RADIUS;
        })) {
          strikerOnBaseCircleFoul = true;
        }
      }
      shotStartStrikerRef.current = null;
    }

    let queenPocketedThisTurn = false;
    let queenCoveredThisTurn = false;
    let wrongColorPocketed = false;
    let coverBeforeQueenOpponentWins = false;
    let opponentPocketedCoverPlayerWins = false;
    let invalidQueenPocket = false;
    let queenReturnedThisTurn = false;
    let duePieceReturned = false;

    const ownPocketedThisTurn = pocketedPieces.filter(piece => piece.color === playerColor).length;
    const opponentPocketedThisTurn = pocketedPieces.filter(piece => piece.color === opponentColor).length;

    const pocketedIds = new Set(
      pocketedPieces.map(piece => piece && piece.id).filter(Boolean)
    );
    if (pocketedIds.size) {
      updatedMen.forEach(piece => {
        if (pocketedIds.has(piece.id)) {
          piece.inPlay = false;
          piece.vx = 0;
          piece.vy = 0;
        }
      });
    }

    const remainingOwnAfter = updatedMen.filter(m => m.inPlay && m.color === playerColor).length;
    const hadOwnPocketedBefore = (9 - remainingOwnAfter - ownPocketedThisTurn) > 0;

    // Track pocketed pieces this turn (25/8 uses same rules: must pocket own color; opponent coin = foul)
    pocketedPieces.forEach(piece => {
      if (piece.id === 'queen') {
        queenPocketedThisTurn = true;
      } else if (piece.color === opponentColor) {
        wrongColorPocketed = true;
      }
    });

    const returnQueenToCenter = (reasonMessage) => {
      const queen = updatedMen.find(m => m.id === 'queen');
      if (queen) {
        queen.inPlay = true;
        const pos = findNonOverlappingPosition(updatedMen, CARROM_MAN_RADIUS, 'queen');
        queen.x = pos.x;
        queen.y = pos.y;
        queen.vx = 0;
        queen.vy = 0;
      }
      if (reasonMessage) {
        addLog(reasonMessage);
      }
      queenPocketedThisTurn = false;
      queenCoveredThisTurn = false;
      queenReturnedThisTurn = true;
    };

    // Handle queen rules (same for single board and 25/8: own coin, cover rules unchanged)
    if (queenPocketedThisTurn && !hadOwnPocketedBefore && ownPocketedThisTurn === 0) {
      returnQueenToCenter(`${currentPlayerName} pocketed Queen before any own coin. Queen returned.`);
      invalidQueenPocket = true;
    } else if (queenPocketedThisTurn && ownPocketedThisTurn === 0 && opponentPocketedThisTurn > 0) {
      returnQueenToCenter(`${currentPlayerName} pocketed Queen then opponent coin. Queen returned.`);
    } else if (queenPocketedThisTurn && ownPocketedThisTurn > 0) {
      queenCoveredThisTurn = true;
      addLog(`${currentPlayerName} pocketed and covered the Queen (+3).`);
    } else if (gameData?.queenPocketed && !gameData.queenCovered && ownPocketedThisTurn > 0 && gameData.queenPocketed === currentPlayerId) {
      queenCoveredThisTurn = true;
      addLog(`${currentPlayerName} covered the Queen (+3).`);
    }

    // Foul handling
    let newFouls = foulCount[currentPlayerId] || 0;
    // IDs of pieces pocketed in THIS shot. A coin correctly pocketed this turn must NEVER be
    // returned to the board — even when the same shot also commits a foul. Only the foul count
    // should increase, and the due/penalty may return a PREVIOUSLY pocketed own coin (not one
    // sunk in the current turn).
    const pocketedThisTurnIds = new Set(
      pocketedPieces.map(piece => piece && piece.id).filter(Boolean)
    );
    if (strikerFoul || wrongColorPocketed || invalidQueenPocket || strikerOffBaselineFoul || strikerOnBaseCircleFoul) {
      newFouls += 1;
      // Return one PREVIOUSLY pocketed own piece to the board (due/penalty) - place without stacking.
      // Exclude coins pocketed this turn so a correctly pocketed coin is never respawned.
      const duePiece = updatedMen.find(m => !m.inPlay && m.color === playerColor && !pocketedThisTurnIds.has(m.id));
      if (duePiece) {
        duePiece.inPlay = true;
        const pos = findNonOverlappingPosition(updatedMen, CARROM_MAN_RADIUS, duePiece.id);
        duePiece.x = pos.x;
        duePiece.y = pos.y;
        duePiece.vx = 0;
        duePiece.vy = 0;
        duePieceReturned = true;
      }
    }

    // Carrom rule: pocketing an OPPONENT coin is a foul — that coin must be returned to the board.
    // (Previously the opponent coin stayed pocketed, corrupting the remaining-coin count and
    //  letting the win be awarded to the wrong color.)
    // Exception: the genuine "Queen + one cover each" endgame — if the Queen is STILL on the board
    // and you pocket the opponent's last coin, that is the terminal "opponent wins" case handled
    // in the win-resolution below, so we DO NOT return the coin then. In every other case
    // (including when the Queen has already been pocketed/covered) the fouled opponent coin IS
    // returned, so a player can never be handed a win they did not legitimately earn.
    if (wrongColorPocketed) {
      const opponentPocketedIds = new Set(
        pocketedPieces
          .filter(piece => piece && piece.id !== 'queen' && piece.color === opponentColor)
          .map(piece => piece.id)
      );
      const queenPieceNow = updatedMen.find(m => m.id === 'queen');
      const queenOnBoardNow = queenPieceNow?.inPlay ?? true;
      const opponentRemainingNow = updatedMen.filter(m => m.inPlay && m.color === opponentColor).length;
      // Only skip the return for the terminal cover endgame: Queen still on board AND this foul
      // emptied the opponent's coins. Otherwise always return the fouled opponent coin(s).
      const isTerminalCoverEndgame = queenOnBoardNow && opponentRemainingNow === 0;
      if (!isTerminalCoverEndgame && opponentPocketedIds.size > 0) {
        updatedMen.forEach(piece => {
          if (opponentPocketedIds.has(piece.id)) {
            piece.inPlay = true;
            const pos = findNonOverlappingPosition(updatedMen, CARROM_MAN_RADIUS, piece.id);
            piece.x = pos.x;
            piece.y = pos.y;
            piece.vx = 0;
            piece.vy = 0;
          }
        });
        addLog(`${currentPlayerName} pocketed opponent coin — coin returned to board.`);
      }
    }

    if (strikerFoul) {
      addLog(`${currentPlayerName} pocketed the striker (foul).`);
    }
    if (strikerOffBaselineFoul) {
      addLog(`${currentPlayerName} striker half off baseline (foul).`);
    }
    if (strikerOnBaseCircleFoul) {
      addLog(`${currentPlayerName} striker on base circle (foul).`);
    }
    if (wrongColorPocketed) {
      addLog(`${currentPlayerName} pocketed opponent coin (foul).`);
    }
    if (duePieceReturned) {
      addLog(`${currentPlayerName} due/penalty: one ${playerColor} coin returned.`);
    }

    const modeValue = gameData?.gameMode || gameMode;
    const boardsPlayedValue = gameData?.boardsPlayed || 0;
    const nextTurnStartedAtValue = isLocalGame ? Date.now() : serverTimestamp();

    // Update Firebase
    const updates = {};
    updates[`games/${roomCode}/players/${currentPlayerId}/fouls`] = newFouls;
    updates[`games/${roomCode}/shotInProgress`] = false;
    updates[`games/${roomCode}/liveStriker`] = null; // Clear live stream so next turn starts clean

    if (queenPocketedThisTurn) {
      updates[`games/${roomCode}/queenPocketed`] = currentPlayerId;
      updates[`games/${roomCode}/queenCovered`] = queenCoveredThisTurn;
    } else if (queenCoveredThisTurn) {
      updates[`games/${roomCode}/queenCovered`] = true;
    } else if (queenReturnedThisTurn) {
      updates[`games/${roomCode}/queenPocketed`] = null;
      updates[`games/${roomCode}/queenCovered`] = false;
    } else if (gameData?.queenPocketed && !gameData.queenCovered && gameData.queenPocketed === currentPlayerId) {
      if (opponentPocketedThisTurn > 0 && ownPocketedThisTurn === 0) {
        returnQueenToCenter(`${currentPlayerName} pocketed opponent coin instead of covering. Queen returned.`);
        updates[`games/${roomCode}/queenPocketed`] = null;
        updates[`games/${roomCode}/queenCovered`] = false;
      } else if (ownPocketedThisTurn > 0 && !queenCoveredThisTurn && remainingOwnAfter === 0) {
        // Player pocketed their last cover coin before covering queen → opponent wins
        updates[`games/${roomCode}/queenPocketed`] = null;
        updates[`games/${roomCode}/queenCovered`] = false;
        addLog(`${currentPlayerName} pocketed cover coin before Queen. Opponent wins.`);
        coverBeforeQueenOpponentWins = true;
      } else {
        // Failed to cover on your next turn: return queen to center (no stacking)
        const queen = updatedMen.find(m => m.id === 'queen');
        if (queen) {
          queen.inPlay = true;
          const pos = findNonOverlappingPosition(updatedMen, CARROM_MAN_RADIUS, 'queen');
          queen.x = pos.x;
          queen.y = pos.y;
          queen.vx = 0;
          queen.vy = 0;
        }
        updates[`games/${roomCode}/queenPocketed`] = null;
        updates[`games/${roomCode}/queenCovered`] = false;
        addLog(`${currentPlayerName} failed to cover Queen. Queen returned to center.`);
      }
    }

    // Check win condition
    const remainingWhite = updatedMen.filter(m => m.inPlay && m.color === 'white').length;
    const remainingBlack = updatedMen.filter(m => m.inPlay && m.color === 'black').length;
    const queenPiece = updatedMen.find(m => m.id === 'queen');
    const queenStillOnBoard = queenPiece?.inPlay ?? true;
    let winnerColor = null;

    // Queen + one cover each: current player pocketed opponent's last piece (cover) → opponent wins (set first so it always applies)
    if (wrongColorPocketed && queenStillOnBoard && (remainingWhite === 0 || remainingBlack === 0)) {
      const opponentName = gameData?.players?.[currentPlayerId === 'player1' ? 'player2' : 'player1']?.name || (currentPlayerId === 'player1' ? 'CPU' : 'Opponent');
      addLog(`${currentPlayerName} pocketed opponent's last cover. ${opponentName} wins.`);
      winnerColor = remainingBlack === 0 ? 'black' : 'white';
    }

    // Opponent pocketed player's cover coin by mistake → player (queen's owner) wins
    if (!winnerColor && wrongColorPocketed && gameData?.queenPocketed && !gameData?.queenCovered && gameData.queenPocketed !== currentPlayerId) {
      const queenPlayerColor = getPlayerColor(gameData.queenPocketed, modeValue);
      const queenPlayerRemaining = queenPlayerColor === 'white' ? remainingWhite : remainingBlack;
      if (queenPlayerRemaining === 0) {
        opponentPocketedCoverPlayerWins = true;
        addLog(`${currentPlayerName} pocketed cover coin by mistake. ${gameData?.players?.[gameData.queenPocketed]?.name || gameData.queenPocketed} wins.`);
        winnerColor = getPlayerColor(gameData.queenPocketed, modeValue);
      }
    }

    if (!winnerColor && coverBeforeQueenOpponentWins) {
      winnerColor = opponentColor;
    } else if (!winnerColor && opponentPocketedCoverPlayerWins) {
      winnerColor = getPlayerColor(gameData.queenPocketed, modeValue);
    } else if (!winnerColor && remainingWhite === 0 && remainingBlack === 0) {
      winnerColor = playerColor;
    } else if (!winnerColor && remainingWhite === 0) {
      winnerColor = 'white';
    } else if (!winnerColor && remainingBlack === 0) {
      winnerColor = 'black';
    }

    // If player cleared all their coins without queen being collected, they lose - opponent wins
    // Exception: when current player pocketed opponent's last piece (cover) by mistake, opponent already wins — do not flip
    let clearedWithoutQueen = false;
    const wonByPocketingOpponentCover = wrongColorPocketed && (remainingWhite === 0 || remainingBlack === 0);
    if (winnerColor && queenStillOnBoard && !wonByPocketingOpponentCover) {
      winnerColor = winnerColor === 'white' ? 'black' : 'white';
      clearedWithoutQueen = true;
      addLog('Cleared all coins without Queen collected. Opponent wins the board.');
    }

    if (winnerColor) {
      // Use ref so score calculations use latest scores (important when game ends on CPU shot in 1vcpu)
      const scoresToUse = scoresRef.current ?? scores;
      const isDoubles = modeValue === '2v2';
      const winnerPlayers = isDoubles
        ? (winnerColor === 'white' ? ['player1', 'player3'] : ['player2', 'player4'])
        : (winnerColor === 'white' ? ['player1'] : ['player2']);

      // When opponent wins because player pocketed opponent's last coin (cover): points = pocketing player's (loser's) remaining coins + queen bonus, never fixed 9
      const opponentRemaining = wonByPocketingOpponentCover || opponentPocketedCoverPlayerWins
        ? (playerColor === 'white' ? remainingWhite : remainingBlack)  // loser's remaining (pocketing player)
        : (winnerColor === 'white' ? remainingBlack : remainingWhite);
      const winnerScore = scoresToUse[winnerPlayers[0]] || 0;
      // Queen bonus +3 only when: (1) queen was covered by board winner, (2) winner score ≤ 21 before adding
      // Include this turn: if winner pocketed and covered queen on the winning shot, gameData still has old state
      const effectiveQueenCovered = (gameData?.queenCovered === true) || (queenCoveredThisTurn === true);
      const effectiveQueenPocketed = queenPocketedThisTurn ? currentPlayerId : (gameData?.queenPocketed ?? null);
      const queenPointsEligible = effectiveQueenCovered && effectiveQueenPocketed && winnerPlayers.includes(effectiveQueenPocketed) && winnerScore <= QUEEN_BONUS_MAX_SCORE;
      const queenPoints = queenPointsEligible ? QUEEN_BONUS_POINTS : 0;

      // Points per board = opponent (loser) coins left + queen bonus (if eligible), max 12 per board
      // Special case: cleared without queen → opponent wins, award 9 points. When opponent wins by "pocketed last cover" use remaining coins only.
      const boardPoints = clearedWithoutQueen ? 9 : Math.min(MAX_POINTS_PER_BOARD, opponentRemaining + queenPoints);
      const nextBoardsPlayed = boardsPlayedValue + 1;

      winnerPlayers.forEach(pid => {
        updates[`games/${roomCode}/players/${pid}/score`] = (scoresToUse[pid] || 0) + boardPoints;
      });
      // Write all players' scores to Firebase so Game Over popup shows correct scores on both clients
      const allPlayerIds = Object.keys(gameData?.players || {});
      allPlayerIds.forEach(pid => {
        if (updates[`games/${roomCode}/players/${pid}/score`] === undefined) {
          updates[`games/${roomCode}/players/${pid}/score`] = scoresToUse[pid] ?? gameData?.players?.[pid]?.score ?? 0;
        }
      });

      updates[`games/${roomCode}/boardResult`] = {
        boardPoints,
        opponentRemaining,
        queenPoints,
        winnerColor,
        winnerPlayers,
        boardsPlayed: nextBoardsPlayed,
        timestamp: Date.now()
      };
      updates[`games/${roomCode}/boardsPlayed`] = nextBoardsPlayed;

      // Live 1v1: single-board (one board = game over) unless boardType is 'match' (25/8)
      const isLive1v1 = gametypeRef.current === 'live' && modeValue === '1v1';
      let matchOver = matchFormatValue === 'single' || (isLive1v1 && matchFormatValue !== 'match');
      let matchWinner = winnerPlayers[0];
      let matchDraw = false;

      if (matchFormatValue === 'match') {
        const nextScores = { ...scoresToUse };
        winnerPlayers.forEach(pid => {
          nextScores[pid] = (scoresToUse[pid] || 0) + boardPoints;
        });

        if (isDoubles) {
          const whiteScore = nextScores.player1 || 0;
          const blackScore = nextScores.player2 || 0;
          if (whiteScore >= MATCH_TARGET_POINTS || blackScore >= MATCH_TARGET_POINTS) {
            matchOver = true;
            matchWinner = whiteScore >= blackScore ? 'player1' : 'player2';
          } else if (nextBoardsPlayed >= MATCH_MAX_BOARDS) {
            matchOver = true;
            if (whiteScore === blackScore) {
              matchDraw = true;
              matchWinner = null;
            } else {
              matchWinner = whiteScore > blackScore ? 'player1' : 'player2';
            }
          }
        } else {
          const p1Score = nextScores.player1 || 0;
          const p2Score = nextScores.player2 || 0;
          if (p1Score >= MATCH_TARGET_POINTS || p2Score >= MATCH_TARGET_POINTS) {
            matchOver = true;
            matchWinner = p1Score >= p2Score ? 'player1' : 'player2';
          } else if (nextBoardsPlayed >= MATCH_MAX_BOARDS) {
            matchOver = true;
            if (p1Score === p2Score) {
              matchDraw = true;
              matchWinner = null;
            } else {
              matchWinner = p1Score > p2Score ? 'player1' : 'player2';
            }
          }
        }
      }
      console.log("matchOver", matchOver);

      if (matchOver) {
        updates[`games/${roomCode}/status`] = 'gameover';
        updates[`games/${roomCode}/winner`] = matchWinner;
        updates[`games/${roomCode}/matchDraw`] = matchDraw;
        updates[`games/${roomCode}/turnStartedAt`] = null;

        const winnerName = matchWinner ? (gameData?.players?.[matchWinner]?.name || matchWinner) : 'Draw';
        addLog(`${winnerName} wins board: ${boardPoints} points.`);

        // If this is a local CPU game, show game over popup and notify backend (no redirect; user clicks Exit)
        const isLocalCpuGame = (gameData?.gameMode || gameMode) === '1vcpu';
        if (isLocalCpuGame) {
          // Build final scores for game over popup (scores not yet in gameData.players for local CPU)
          const finalScoresForCpu = Object.fromEntries(
            ['player1', 'player2'].map(pid => [
              pid,
              (scoresToUse[pid] || 0) + (winnerPlayers.includes(pid) ? boardPoints : 0)
            ])
          );
          const finalPlayersForCpu = {};
          ['player1', 'player2'].forEach(pid => {
            finalPlayersForCpu[pid] = {
              ...(gameData?.players?.[pid] || {}),
              name: gameData?.players?.[pid]?.name || (pid === 'player1' ? (playerName || userData?.name || 'Player 1') : 'CPU'),
              score: finalScoresForCpu[pid] ?? 0
            };
          });
          const winnerScoreVal = matchWinner ? (finalScoresForCpu[matchWinner] ?? 0) : 0;
          const loserSlot = matchWinner === 'player1' ? 'player2' : 'player1';
          const loserScoreVal = matchWinner ? (finalScoresForCpu[loserSlot] ?? 0) : 0;

          gameStateRef.current = 'gameover';
          setGameState('gameover');
          setScores(prev => ({ ...prev, ...finalScoresForCpu }));
          setWinnerData({
            winnerColor: matchWinner ? getPlayerColor(matchWinner, modeValue) : null,
            winner: matchWinner,
            gameMode: modeValue,
            players: finalPlayersForCpu,
            isLive: false,
            currentGametype: '1vcpu'
          });
          if (!matchDraw && winnerColor) {
            saveCpuWinnerToAPI(winnerColor, winnerScoreVal, loserScoreVal);
          }
          // Do NOT reset status to online here – keep Engaged until user clicks "Exit to Home"
        }
      } else {
        // Reset board for next game in match. Loser gets first turn (striker on loser's side so they can break).
        const resetMen = initializeCarromMen();
        updates[`games/${roomCode}/carromMen`] = resetMen;
        updates[`games/${roomCode}/lastUpdate`] = {
          by: currentPlayerId,
          type: 'boardReset',
          ts: Date.now(),
          inPlayCount: resetMen.filter(m => m.inPlay).length
        };
        updates[`games/${roomCode}/queenPocketed`] = null;
        updates[`games/${roomCode}/queenCovered`] = false;
        updates[`games/${roomCode}/shotInProgress`] = false;
        // First turn of new board goes to loser; striker shows on loser's side so they can start/break
        const firstTurnPlayerId = isDoubles
          ? (winnerColor === 'white' ? 'player2' : 'player1')
          : (winnerPlayers[0] === 'player1' ? 'player2' : 'player1');
        updates[`games/${roomCode}/currentTurn`] = firstTurnPlayerId === 'player3' ? 3 : firstTurnPlayerId === 'player4' ? 4 : parseInt(firstTurnPlayerId.replace('player', ''), 10);
        updates[`games/${roomCode}/turnStartedAt`] = nextTurnStartedAtValue;

        const winnerName = gameData?.players?.[winnerPlayers[0]]?.name || (gameData?.players?.[winnerPlayers[0]]?.userid ? 'Waiting for name...' : winnerPlayers[0]);
        addLog(`${winnerName} wins board: ${boardPoints} points.`);
      }
    } else {
      // Next turn (continue turn if valid pocket and no foul)
      const continueTurn = !strikerFoul && !wrongColorPocketed && !invalidQueenPocket && (ownPocketedThisTurn > 0 || queenPocketedThisTurn);
      const maxPlayers = modeValue === '2v2' ? 4 : 2;
      const nextTurn = continueTurn ? turnForThisShot : (turnForThisShot % maxPlayers) + 1;
      if (!continueTurn) {
        updates[`games/${roomCode}/currentTurn`] = nextTurn;
        updates[`games/${roomCode}/turnStartedAt`] = nextTurnStartedAtValue;
      } else {
        updates[`games/${roomCode}/turnStartedAt`] = nextTurnStartedAtValue;
      }
    }

    updates[`games/${roomCode}/turnLog`] = logEntries;
    if (!updates[`games/${roomCode}/carromMen`]) {
      updates[`games/${roomCode}/carromMen`] = updatedMen;
      updates[`games/${roomCode}/lastUpdate`] = {
        by: currentPlayerId,
        type: 'turnEnd',
        ts: Date.now(),
        inPlayCount: updatedMen.filter(m => m.inPlay).length
      };
    }

    if (isLocalGame) {
      const nextPlayers = { ...gameData.players };
      nextPlayers[currentPlayerId] = { ...nextPlayers[currentPlayerId], fouls: newFouls };
      Object.keys(nextPlayers).forEach(pid => {
        const scoreKey = `games/${roomCode}/players/${pid}/score`;
        if (updates[scoreKey] !== undefined) {
          nextPlayers[pid] = { ...nextPlayers[pid], score: updates[scoreKey] };
        }
      });

      const nextTurnValue = updates[`games/${roomCode}/currentTurn`] ?? turnForThisShot;
      const nextGameData = {
        ...gameData,
        players: nextPlayers,
        currentTurn: nextTurnValue,
        shotInProgress: false,
        turnStartedAt: updates[`games/${roomCode}/turnStartedAt`] || gameData.turnStartedAt,
        queenPocketed: updates[`games/${roomCode}/queenPocketed`] !== undefined ? updates[`games/${roomCode}/queenPocketed`] : gameData.queenPocketed,
        queenCovered: updates[`games/${roomCode}/queenCovered`] !== undefined ? updates[`games/${roomCode}/queenCovered`] : gameData.queenCovered,
        boardResult: updates[`games/${roomCode}/boardResult`] || gameData.boardResult,
        boardsPlayed: updates[`games/${roomCode}/boardsPlayed`] || boardsPlayedValue,
        matchDraw: updates[`games/${roomCode}/matchDraw`] || false,
        status: updates[`games/${roomCode}/status`] || gameData.status,
        winner: updates[`games/${roomCode}/winner`] || gameData.winner,
        turnLog: logEntries,
        carromMen: updates[`games/${roomCode}/carromMen`]
      };

      applyLocalGameState(nextGameData);
      setIsAnimating(false);
      initializeStriker(nextGameData.currentTurn, modeValue);
      // When CPU keeps turn (potted a coin): delay before next shot so user sees striker back on baseline
      if (nextGameData.currentTurn === 2) {
        const CPU_CONTINUE_TURN_DELAY_MS = 2200;
        cpuShotReadyAtRef.current = Date.now() + CPU_CONTINUE_TURN_DELAY_MS;
      }
      shotTurnRef.current = null;
      turnEndHandledRef.current = null;

      // Demo bypass: after N completed human (red striker) turns in local CPU mode, go to plan page
      // After this many completed human (player 1) striker turns, redirect (use 2 for a shorter demo).
      const DEMO_MAX_HUMAN_STRIKER_ROUNDS = 3;
      let sessionIdForDemo = '';
      try {
        const raw = sessionStorage.getItem('userData');
        if (raw) sessionIdForDemo = String(JSON.parse(raw).sessionId ?? '').toLowerCase();
      } catch (_) { /* ignore */ }
      const isDemoBypassSession = sessionIdForDemo === 'demobypass';
      if (
        modeValue === '1vcpu' &&
        turnForThisShot === 1 &&
        isDemoBypassSession
      ) {
        demoHumanStrikerTurnsRef.current += 1;
        if (demoHumanStrikerTurnsRef.current >= DEMO_MAX_HUMAN_STRIKER_ROUNDS) {
          demoHumanStrikerTurnsRef.current = 0;
          const demoPlansUrl =
            process.env.REACT_APP_DEMO_PLANS_URL ||
            `${String(process.env.REACT_APP_BASE_URL || 'https://staging.extramileplay.com').replace(/\/$/, '')}/plans`;

          const swalResult = await Swal.fire({
            title: 'Thank you for playing',
            html: 'Subscribe to any <strong>PLAN</strong> to play with your peers.',
            icon: 'info',
            iconColor: '#38bdf8',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            allowEscapeKey: false,
            buttonsStyling: true,
            background: '#1e1e2d',
            color: '#e2e8f0',
            customClass: {
              popup: 'demo-plans-swal-popup',
              confirmButton: 'demo-plans-swal-btn'
            }
          });

          if (!swalResult.isConfirmed) {
            return;
          }

          try {
            if (userData?.userId && userData?.sessionId && realtimeDatabase) {
              await resetUsersStatusToOnline({ player1: { userid: userData.userId } });
              await update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), {
                status: 'online',
                islive: true,
                live: false,
                timestamp: serverTimestamp()
              });
            }
          } catch (e) {
            console.error('Demo plans redirect: Firebase user reset failed', e);
          }

          clearSession();
          [
            'carrom_localGame',
            'cpuGameState',
            'cpuGameScore',
            'cpuGameSettings',
            'lastCpuGame'
          ].forEach((key) => {
            try {
              localStorage.removeItem(key);
            } catch (_) { /* ignore */ }
          });

          carromMenRef.current = [];
          strikerRef.current = null;
          pendingShotRef.current = null;
          pocketedThisTurnRef.current = [];
          turnEndHandledRef.current = null;
          shotTurnRef.current = null;
          shotStartStrikerRef.current = null;
          physicsStableFramesRef.current = 0;
          physicsTurnEndingRef.current = false;
          cpuShotReadyAtRef.current = null;
          cpuShotTurnRef.current = null;
          lastTurnRef.current = null;
          isRepositioningRef.current = false;
          playerIdRef.current = null;
          gameDataRef.current = null;
          scoresRef.current = { player1: 0, player2: 0, player3: 0, player4: 0 };

          sessionStorage.removeItem('userData');
          sessionStorage.removeItem('resetToOnlineOnUnload');
          setUserData(null);
          gameStateRef.current = 'menu';
          setGameState('menu');
          setGameData(null);
          setRoomCode('');
          setPlayerId(null);
          setCarromMen([]);
          setStriker(null);
          setCurrentTurn(1);
          setBoardsPlayed(0);
          setScores({ player1: 0, player2: 0, player3: 0, player4: 0 });
          setQueenPocketed(null);
          setLastPocketedPiece(null);
          setFoulCount({ player1: 0, player2: 0, player3: 0, player4: 0 });
          setWinnerData(null);
          setIsDragging(false);
          setIsAnimating(false);
          setIsRepositioning(false);
          if (animationRef.current) {
            cancelAnimationFrame(animationRef.current);
            animationRef.current = null;
          }

          if (/^https?:\/\//i.test(demoPlansUrl)) {
            window.location.assign(demoPlansUrl);
          } else {
            navigate(demoPlansUrl.startsWith('/') ? demoPlansUrl : `/${demoPlansUrl}`);
          }
          return;
        }
      }

      return;
    }

    await update(ref(realtimeDatabase), updates);

    const missedTurnKey = `games/${roomCode}/players/${currentPlayerId}/missedTurns`;
    if (updates[missedTurnKey] !== undefined) {
      await checkMissedTurnForfeit(currentPlayerId, updates[missedTurnKey]);
      if (gameDataRef.current?.status === 'gameover') {
        shotTurnRef.current = null;
        turnEndHandledRef.current = null;
        return;
      }
    }

    const writtenNextTurn = updates[`games/${roomCode}/currentTurn`] ?? turnForThisShot;
    const newCarromMen = updates[`games/${roomCode}/carromMen`];
    // Only update carromMen when we have new data (e.g. turn end). When matchOver we didn't write carromMen – keep current board so live game doesn't reset
    if (newCarromMen !== undefined) {
      carromMenRef.current = newCarromMen;
      setCarromMen(newCarromMen);
    }
    // 25/8 board reset: update writer's local turn/boardsPlayed so winner can play immediately (avoids stale currentTurn and "skip" glitch)
    const writtenBoardsPlayed = updates[`games/${roomCode}/boardsPlayed`];
    if (writtenBoardsPlayed !== undefined) {
      setBoardsPlayed(writtenBoardsPlayed);
    }
    if (updates[`games/${roomCode}/lastUpdate`]?.type === 'boardReset') {
      setCurrentTurn(writtenNextTurn);
      lastTurnRef.current = writtenNextTurn;
      setGameData(prev => prev ? { ...prev, currentTurn: writtenNextTurn, boardsPlayed: writtenBoardsPlayed ?? prev.boardsPlayed } : prev);
      boardResetLockTurnRef.current = writtenNextTurn;
      boardResetLockUntilRef.current = Date.now() + 2500; // Don't let listener overwrite first turn (loser's) with stale snapshot
    }
    const newStatus = updates[`games/${roomCode}/status`] || gameData.status;
    if (newStatus === 'gameover') {
      gameStateRef.current = 'gameover';
      setGameState('gameover');
      setIsAnimating(false);
      const isTournament = gametypeRef.current === 'tournament';
      const isLive = !isTournament && (gametypeRef.current === 'live' || (modeValue === '1v1' && gameData?.players?.player1?.userid && gameData?.players?.player2?.userid));
      const isLive1v1 = gametypeRef.current === 'live' && modeValue === '1v1';
      const isMatchDraw = updates[`games/${roomCode}/matchDraw`] === true;
      const winnerSlot = updates[`games/${roomCode}/winner`] || gameData.winner;

      // Merge final scores into gameData so Game Over popup shows correct scores immediately
      const finalPlayers = { ...gameData.players };
      Object.keys(finalPlayers || {}).forEach(pid => {
        const scoreVal = updates[`games/${roomCode}/players/${pid}/score`];
        if (scoreVal !== undefined) {
          finalPlayers[pid] = { ...finalPlayers[pid], score: scoreVal };
        } else {
          finalPlayers[pid] = { ...finalPlayers[pid], score: scores[pid] ?? finalPlayers[pid]?.score ?? 0 };
        }
      });
      setGameData(prev => (prev ? { ...prev, players: finalPlayers } : prev));

      if (isTournament && winnerSlot && !isMatchDraw) {
        const winnerColorVal = getPlayerColor(winnerSlot, modeValue);
        setWinnerData({
          winnerColor: winnerColorVal,
          winner: winnerSlot,
          gameMode: modeValue,
          players: finalPlayers,
          isLive: false,
          currentGametype: 'tournament'
        });
        handleGameEnd({
          winnerId: winnerSlot,
          winnerColor: winnerColorVal,
          gameType: 'tournament',
          gameMode: modeValue,
          players: finalPlayers,
        }).catch(err => console.error('Error saving tournament winner:', err));
      } else if (isLive && !isMatchDraw && winnerSlot) {
        if (isLive1v1) {
          setWinnerData({
            winnerColor: winnerColor,
            winner: winnerSlot,
            gameMode: modeValue,
            players: finalPlayers,
            isLive: true,
            currentGametype: 'live'
          });
          const isCurrentUserWinner = finalPlayers[winnerSlot]?.userid === userData?.userId;
          if (isCurrentUserWinner) {
            handleGameEnd({
              winnerId: winnerSlot,
              winnerColor: winnerColor,
              gameType: 'live',
              gameMode: modeValue,
              players: finalPlayers,
              sessionId: userData.sessionId,
              organizationId: userData.organizationId,
            }).catch((err) => console.error('Error in live game over:', err));
          }
        } else {
          const livePayload = {
            players: finalPlayers,
            winner: winnerSlot,
            gameMode: modeValue,
            sessionId: userData.sessionId,
            organizationId: userData.organizationId,
            winnerColor: winnerColor,
          };
          saveLiveWinnerToAPI(livePayload)
            .then(() => resetUsersStatusToOnline(gameData.players))
            .catch((err) => {
              console.error('Error in live game over:', err);
              return resetUsersStatusToOnline(gameData.players);
            })
            .finally(() => {
              setTimeout(() => navigate('/allusers'), 1000);
            });
        }
      } else if (isLive && !isLive1v1) {
        resetUsersStatusToOnline(gameData.players).then(() => setTimeout(() => navigate('/allusers'), 1000));
      }
      shotTurnRef.current = null;
      turnEndHandledRef.current = null;
      return;
    }
    // Reinitialize striker for next turn (use written value so listener and shooter agree)
    shotTurnRef.current = null;
    turnEndHandledRef.current = null;
    physicsTurnEndingRef.current = false; // Allow next shot's physics to run (e.g. loser's first shot on new board)
    setTimeout(() => {
      initializeStriker(writtenNextTurn, gameData?.gameMode || gameMode);
    }, 500);
  };

  const clearBoardResult = () => {
    const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';
    if (isLocalGame) {
      setGameData(prev => (prev ? { ...prev, boardResult: null } : prev));
      return;
    }
    if (realtimeDatabase && roomCode) {
      update(ref(realtimeDatabase, `games/${roomCode}`), { boardResult: null });
    }
  };

  // Recovery: clear stale shotInProgress after 5 seconds
  useEffect(() => {
    const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';
    if (isLocalGame) return;
    if (!realtimeDatabase || !roomCode || !gameData) return;
    if (gameData.status !== 'playing') return;
    if (!gameData.shotInProgress) return;
    if (isAnimating) return;

    const recoveryTimer = setTimeout(() => {
      update(ref(realtimeDatabase, `games/${roomCode}`), {
        shotInProgress: false,
        liveStriker: null
      });
    }, 5000);

    return () => clearTimeout(recoveryTimer);
  }, [realtimeDatabase, roomCode, gameData?.shotInProgress, gameData?.status, isAnimating]);

  // Shared clock for timers
  useEffect(() => {
    if (gameState !== 'playing' && gameState !== 'lobby') return;
    let rafId;
    const tick = () => {
      setNowMs(Date.now());
      rafId = requestAnimationFrame(tick);
    };
    if (gameState === 'lobby') {
      const interval = setInterval(() => setNowMs(Date.now()), 1000);
      return () => clearInterval(interval);
    }
    rafId = requestAnimationFrame(tick);
    return () => {
      if (rafId) cancelAnimationFrame(rafId);
    };
  }, [gameState]);

  // Lobby timeout – declare winner if opponent does not join within 10 minutes
  useEffect(() => {
    if (gameState !== 'lobby' || gametype !== 'tournament') return;
    const data = gameData;
    if (!data || data.status !== 'waiting' || data.lobbyTimeoutCancelled || data.lobbyTimeoutHandled) return;

    const lobbyStartedAtMs = parseFirebaseTimestamp(data.lobbyStartedAt);
    if (!lobbyStartedAtMs) return;

    const lobbyTimeoutMs = data.lobbyTimeoutMs || LOBBY_TIMEOUT_MS;
    if (Date.now() - lobbyStartedAtMs < lobbyTimeoutMs) return;
    if (lobbyTimeoutHandledRef.current) return;

    const players = data.players || {};
    const maxPlayers = data.gameMode === '2v2' ? 4 : 2;
    const validSlots = Array.from({ length: maxPlayers }, (_, i) => `player${i + 1}`);
    // Only count slots with a real joined userid (not name-only placeholders).
    const joinedSlots = validSlots.filter((pid) => {
      const p = players[pid];
      const uid = p?.userid;
      return uid && !/^player\d+$/.test(String(uid));
    });
    if (joinedSlots.length === 0 || joinedSlots.length >= maxPlayers) return;

    lobbyTimeoutHandledRef.current = true;
    // Winner = whoever actually joined the lobby; prefer the local user's slot.
    const mySlot = playerIdRef.current || playerId;
    const winnerSlot = joinedSlots.includes(mySlot)
      ? mySlot
      : joinedSlots[0];
    declareForfeitWin({
      winnerSlot,
      winnerScore: FORFEIT_WIN_SCORE,
      gameEndedBy: 'lobby_timeout',
      outcome: 'lobby_timeout',
    }).finally(() => {
      lobbyTimeoutHandledRef.current = false;
    });
  }, [gameState, gametype, gameData, nowMs]);

  useEffect(() => {
    if (gameData?.status !== 'playing') return;
    const clockKey = `${gameData.currentTurn}-${gameData.turnStartedAt}`;
    const parsed = parseFirebaseTimestamp(gameData.turnStartedAt);
    if (parsed != null) {
      turnStartedAtFallbackRef.current = parsed;
      lastTurnClockKeyRef.current = clockKey;
    } else if (lastTurnClockKeyRef.current !== clockKey) {
      turnStartedAtFallbackRef.current = Date.now();
      lastTurnClockKeyRef.current = clockKey;
    }
  }, [gameData?.status, gameData?.currentTurn, gameData?.turnStartedAt]);

  const turnDurationMs = gameData?.turnDurationMs || 30000;
  const activeTurnForTimer = gameData?.currentTurn ?? currentTurn;
  const turnStartedAtMs = parseFirebaseTimestamp(gameData?.turnStartedAt) ?? turnStartedAtFallbackRef.current;
  const remainingMs = turnStartedAtMs ? Math.max(0, turnDurationMs - (nowMs - turnStartedAtMs)) : null;
  const remainingSeconds = remainingMs != null ? Math.max(0, Math.ceil(remainingMs / 1000)) : null;
  const timeoutKey = turnStartedAtMs ? `${activeTurnForTimer}-${turnStartedAtMs}` : null;



  useEffect(() => {
    if (!timeoutKey) return;
    timeoutHandledRef.current = null;
    pendingTimeoutRef.current = null;
  }, [timeoutKey]);

  const handleTurnTimeout = async () => {
    const data = gameDataRef.current || gameData;
    if (!data || data.status !== 'playing') return;
    if (data.shotInProgress) return; // Never advance turn on timeout while a shot is in progress

    const activeTurn = data.currentTurn ?? currentTurn;
    const modeValue = data?.gameMode || gameMode;
    const maxPlayers = modeValue === '2v2' ? 4 : 2;
    const nextTurn = (activeTurn % maxPlayers) + 1;
    const startedAtMs = parseFirebaseTimestamp(data.turnStartedAt) ?? turnStartedAtFallbackRef.current;
    const thisTimeoutKey = startedAtMs ? `${activeTurn}-${startedAtMs}` : null;
    if (thisTimeoutKey && data.lastTimeoutKey === thisTimeoutKey) {
      const turnAfterTimeout = data.currentTurn != null && data.currentTurn !== activeTurn
        ? data.currentTurn
        : nextTurn;
      if (lastProcessedTimeoutKeyRef.current !== thisTimeoutKey) {
        lastProcessedTimeoutKeyRef.current = thisTimeoutKey;
        syncStrikerAfterTurnTimeout(turnAfterTimeout, modeValue, data.turnStartedAt);
      }
      return;
    }

    const currentPlayerId = `player${activeTurn}`;
    const currentPlayerName = data?.players?.[currentPlayerId]?.name || currentPlayerId;
    const logEntries = [...(data?.turnLog || [])];
    logEntries.push({ message: `${currentPlayerName} timed out.`, ts: Date.now(), by: currentPlayerId });
    if (logEntries.length > 50) {
      logEntries.splice(0, logEntries.length - 50);
    }

    if (modeValue === '1vcpu') {
      // In 1vCPU, when player times out, CPU gets 1 point
      const currentScores = data.scores || { player1: 0, player2: 0 };
      const updatedScores = { ...currentScores };

      // If current turn is player 1 (human), give point to player 2 (CPU)
      if (activeTurn === 1) {
        updatedScores.player2 = (currentScores.player2 || 0) + 1;
      }
      // If current turn is player 2 (CPU), give point to player 1 (human)
      else if (activeTurn === 2) {
        updatedScores.player1 = (currentScores.player1 || 0) + 1;
      }

      const nextGameData = {
        ...data,
        currentTurn: nextTurn,
        turnStartedAt: Date.now(),
        shotInProgress: false,
        scores: updatedScores,
        turnLog: logEntries
      };
      applyLocalGameState(nextGameData);
      initializeStriker(nextTurn, modeValue);
      return;
    }

    if (!realtimeDatabase || !roomCode) return;

    const timeoutUpdates = {
      currentTurn: nextTurn,
      turnStartedAt: serverTimestamp(),
      shotInProgress: false,
      liveStriker: null,
      turnLog: logEntries,
    };
    if (thisTimeoutKey) timeoutUpdates.lastTimeoutKey = thisTimeoutKey;

    const repositionStrikerAfterTimeout = () => {
      if (thisTimeoutKey) lastProcessedTimeoutKeyRef.current = thisTimeoutKey;
      syncStrikerAfterTurnTimeout(nextTurn, modeValue, Date.now());
      setGameData((prev) => {
        if (!prev) return prev;
        const nextPlayers = { ...prev.players };
        if (timeoutUpdates[`players/${currentPlayerId}/missedTurns`] != null) {
          nextPlayers[currentPlayerId] = {
            ...nextPlayers[currentPlayerId],
            missedTurns: timeoutUpdates[`players/${currentPlayerId}/missedTurns`],
          };
        }
        return {
          ...prev,
          currentTurn: nextTurn,
          shotInProgress: false,
          turnLog: logEntries,
          lastTimeoutKey: thisTimeoutKey || prev.lastTimeoutKey,
          turnStartedAt: Date.now(),
          players: nextPlayers,
        };
      });
    };

    if (gametypeRef.current === 'tournament' && modeValue === '1v1') {
      const nextMissed = Number(data?.players?.[currentPlayerId]?.missedTurns ?? 0) + 1;
      timeoutUpdates[`players/${currentPlayerId}/missedTurns`] = nextMissed;
      logEntries.push({ message: `${currentPlayerName} missed a turn (${nextMissed}/${MAX_MISSED_TURNS}).`, ts: Date.now(), by: currentPlayerId });
      timeoutUpdates.turnLog = logEntries;
      await update(ref(realtimeDatabase, `games/${roomCode}`), timeoutUpdates);
      repositionStrikerAfterTimeout();
      await checkMissedTurnForfeit(currentPlayerId, nextMissed);
      return;
    }

    await update(ref(realtimeDatabase, `games/${roomCode}`), timeoutUpdates);
    repositionStrikerAfterTimeout();
  };

  // Turn changes ONLY after shot completion (handleTurnEnd) or turn timeout – never on striker pull/drag
  useEffect(() => {
    if (gameState !== 'playing' || remainingMs == null || !timeoutKey) return;
    if (remainingMs > 0) return;
    if (timeoutHandledRef.current === timeoutKey) return;
    if (isAnimating) {
      pendingTimeoutRef.current = timeoutKey;
      return;
    }
    if (gameData?.shotInProgress) return; // Never advance turn while a shot is in progress (winner pulling/released)
    timeoutHandledRef.current = timeoutKey;
    handleTurnTimeout();
  }, [gameState, remainingMs, timeoutKey, isAnimating, gameData?.shotInProgress]);

  useEffect(() => {
    if (!pendingTimeoutRef.current || !timeoutKey) return;
    if (pendingTimeoutRef.current !== timeoutKey) {
      pendingTimeoutRef.current = null;
      return;
    }
    if (isAnimating) return;
    if (gameData?.shotInProgress) return; // Never advance turn while shot in progress
    if (remainingMs != null && remainingMs <= 0 && timeoutHandledRef.current !== timeoutKey) {
      timeoutHandledRef.current = timeoutKey;
      pendingTimeoutRef.current = null;
      handleTurnTimeout();
    }
  }, [isAnimating, remainingMs, timeoutKey, gameData?.shotInProgress]);

  // Game loop - uses refs so only depends on isAnimating
  useEffect(() => {
    if (isAnimating) {
      const animate = () => {
        updatePhysics();
        animationRef.current = requestAnimationFrame(animate);
      };
      animationRef.current = requestAnimationFrame(animate);
      return () => {
        if (animationRef.current) {
          cancelAnimationFrame(animationRef.current);
        }
      };
    }
  }, [isAnimating]);

  // CPU turn loop (local 1vCPU only)
  useEffect(() => {
    const mode = gameData?.gameMode || gameMode;
    if (mode !== '1vcpu') return;
    if (gameState !== 'playing') return;
    if (currentTurn !== 2) return;
    if (isAnimating) return;
    if (gameData?.shotInProgress) return;
    if (!nowMs) return;

    // Ensure striker exists and is on the baseline; re-init if missing or pocketed
    if (!strikerRef.current || !strikerRef.current.inPlay) {
      initializeStriker(2, mode);
      return;
    }

    // Validate striker is actually on the CPU's baseline, not left over from a previous position
    const cpuSeat = getPlayerSeat(2, mode);
    const cpuBaseline = getBaselineForSeat(cpuSeat);
    const curStriker = strikerRef.current;
    const baselineTolerance = STRIKER_RADIUS + 5;
    const isOnBaseline = cpuBaseline.axis === 'x'
      ? (Math.abs(curStriker.y - cpuBaseline.fixed) < baselineTolerance &&
        curStriker.x >= cpuBaseline.min - baselineTolerance &&
        curStriker.x <= cpuBaseline.max + baselineTolerance)
      : (Math.abs(curStriker.x - cpuBaseline.fixed) < baselineTolerance &&
        curStriker.y >= cpuBaseline.min - baselineTolerance &&
        curStriker.y <= cpuBaseline.max + baselineTolerance);
    if (!isOnBaseline) {
      initializeStriker(2, mode);
      return;
    }

    // First time this turn: wait so user sees striker on baseline, then aim/strike
    const CPU_FIRST_SHOT_DELAY_MS = 2800;
    if (cpuShotTurnRef.current !== currentTurn) {
      cpuShotTurnRef.current = currentTurn;
      cpuShotReadyAtRef.current = nowMs + CPU_FIRST_SHOT_DELAY_MS;
      return;
    }
    if (cpuShotReadyAtRef.current && nowMs < cpuShotReadyAtRef.current) return;
    cpuShotReadyAtRef.current = null;

    const cpuColor = getPlayerColor('player2', mode);
    const opponentColor = cpuColor === 'white' ? 'black' : 'white';
    const inPlay = carromMenRef.current.filter(m => m.inPlay);
    const queen = inPlay.find(m => m.id === 'queen');
    const ownInPlay = inPlay.filter(m => m.color === cpuColor);
    const ownPocketedCount = 9 - ownInPlay.length;
    const queenPending = gameData?.queenPocketed === 'player2' && !gameData?.queenCovered;
    const opponentInPlay = inPlay.filter(m => m.color === opponentColor);

    // End-game (Queen + cover): Carrom rules – pocketing the cover before the Queen loses the game.
    // CPU must always target the Queen first; only after Queen is pocketed may it target the cover
    // to legally secure the Queen and win. Never allow cover coin as target while Queen is on board.
    const onlyQueenAndOneCover = inPlay.length === 2 && queen && ownInPlay.length === 1;
    const queenAndTwoCovers = inPlay.length === 3 && queen && ownInPlay.length === 1 && opponentInPlay.length === 1;
    const mustQueenFirst = onlyQueenAndOneCover || queenAndTwoCovers;

    let targets = [];
    if (mustQueenFirst) {
      targets = [queen]; // Queen first only; cover is invalid (losing) until Queen is pocketed
    } else if (queenPending) {
      targets = ownInPlay;
    } else if (ownInPlay.length > 0) {
      targets = ownInPlay;
    } else if (queen && ownPocketedCount > 0) {
      targets = [queen];
    }
    if (targets.length === 0) return;

    const pockets = [
      { x: BOARD_PADDING, y: BOARD_PADDING },
      { x: BOARD_SIZE - BOARD_PADDING, y: BOARD_PADDING },
      { x: BOARD_PADDING, y: BOARD_SIZE - BOARD_PADDING },
      { x: BOARD_SIZE - BOARD_PADDING, y: BOARD_SIZE - BOARD_PADDING }
    ];

    const strikerSeat = getPlayerSeat(2, mode);
    const baseline = getBaselineForSeat(strikerSeat);
    const clamp = (value, min, max) => Math.max(min, Math.min(max, value));

    const normalizeAngle = (angle) => {
      let a = angle;
      while (a > Math.PI) a -= Math.PI * 2;
      while (a < -Math.PI) a += Math.PI * 2;
      return a;
    };

    // When queenPending, reject shots where queen or opponent piece could be potted (path piece→pocket)
    const wouldRiskQueenOrOpponent = (piece, pocket) => {
      const px = pocket.x - piece.x;
      const py = pocket.y - piece.y;
      const distTP = Math.hypot(px, py);
      if (distTP < 1) return false;
      return inPlay.some(other => {
        if (other.id === piece.id) return false;
        const isQueen = other.id === 'queen';
        const isOpponent = other.color === opponentColor;
        if (!isQueen && !isOpponent) return false;
        const ox = other.x - piece.x;
        const oy = other.y - piece.y;
        const proj = (ox * px + oy * py) / (distTP * distTP);
        if (proj <= 0 || proj >= 1) return false;
        const closestX = piece.x + proj * px;
        const closestY = piece.y + proj * py;
        const distToLine = Math.hypot(other.x - closestX, other.y - closestY);
        return distToLine < CARROM_MAN_RADIUS * 1.5;
      });
    };

    const scoreShot = (piece, pocket, striker) => {
      const sx = piece.x - striker.x;
      const sy = piece.y - striker.y;
      const px = pocket.x - piece.x;
      const py = pocket.y - piece.y;
      const angleST = Math.atan2(sy, sx);
      const angleTP = Math.atan2(py, px);
      const angleDiff = Math.abs(normalizeAngle(angleST - angleTP));
      if (angleDiff > 0.6) return null;

      if (queenPending && wouldRiskQueenOrOpponent(piece, pocket)) return null;

      const distST = Math.hypot(sx, sy);
      const distTP = Math.hypot(px, py);

      let blockers = 0;
      inPlay.forEach(other => {
        if (other.id === piece.id) return;
        const ox = other.x - striker.x;
        const oy = other.y - striker.y;
        const proj = (ox * sx + oy * sy) / (distST * distST);
        if (proj <= 0 || proj >= 1) return;
        const closestX = striker.x + proj * sx;
        const closestY = striker.y + proj * sy;
        const distToLine = Math.hypot(other.x - closestX, other.y - closestY);
        if (distToLine < CARROM_MAN_RADIUS * 1.2) blockers += 1;
      });

      const score = (1 / (angleDiff + 0.05)) * 100 - distST * 0.05 - distTP * 0.02 - blockers * 8;
      return { score, angle: angleST, distST, distTP };
    };

    // Try multiple striker positions along the baseline and pick the best shot
    const NUM_POSITIONS = 7;
    let globalBest = null;
    let globalBestStriker = null;
    let globalFallback = null;

    for (let i = 0; i < NUM_POSITIONS; i++) {
      const t = i / (NUM_POSITIONS - 1); // 0..1 across the baseline
      const candidate = {
        x: 0, y: 0, vx: 0, vy: 0, inPlay: true, radius: STRIKER_RADIUS
      };
      if (baseline.axis === 'x') {
        candidate.x = baseline.min + t * (baseline.max - baseline.min);
        candidate.y = baseline.fixed;
      } else {
        candidate.x = baseline.fixed;
        candidate.y = baseline.min + t * (baseline.max - baseline.min);
      }

      // Check for overlap with any in-play piece (skip this position if blocked)
      const overlaps = inPlay.some(m => Math.hypot(m.x - candidate.x, m.y - candidate.y) < candidate.radius + (m.radius ?? CARROM_MAN_RADIUS));
      if (overlaps) continue;

      targets.forEach(piece => {
        pockets.forEach(pocket => {
          const result = scoreShot(piece, pocket, candidate);
          if (!result) return;
          if (!globalBest || result.score > globalBest.score) {
            globalBest = { piece, pocket, ...result };
            globalBestStriker = { ...candidate };
          }
        });
      });

      // Track closest target from this position for fallback
      targets.forEach(piece => {
        const d = Math.hypot(piece.x - candidate.x, piece.y - candidate.y);
        if (!globalFallback || d < globalFallback.dist) {
          globalFallback = { piece, dist: d, striker: { ...candidate } };
        }
      });
    }

    // Queen rule: when covering, don't use fallback if it could pot queen or opponent
    if (queenPending && !globalBest && globalFallback) {
      const hasSafePocket = pockets.some(p => !wouldRiskQueenOrOpponent(globalFallback.piece, p));
      if (!hasSafePocket) globalFallback = null;
    }

    // Use the best-scoring position, or fallback to the position closest to a target
    const bestStriker = globalBestStriker || globalFallback?.striker || (() => {
      const center = (baseline.min + baseline.max) / 2;
      return {
        x: baseline.axis === 'x' ? center : baseline.fixed,
        y: baseline.axis === 'y' ? center : baseline.fixed,
        vx: 0, vy: 0, inPlay: true, radius: STRIKER_RADIUS
      };
    })();
    bestStriker.vx = 0;
    bestStriker.vy = 0;
    bestStriker.inPlay = true;
    strikerRef.current = bestStriker;
    setStriker(bestStriker);

    const aimAngle = globalBest
      ? globalBest.angle
      : Math.atan2(
        (globalFallback?.piece || targets[0]).y - bestStriker.y,
        (globalFallback?.piece || targets[0]).x - bestStriker.x
      );
    const baseDist = globalBest
      ? globalBest.distST + globalBest.distTP
      : (globalFallback?.dist || 100);
    let power = Math.min(Math.max(baseDist / 78, 1.1), 2.8);
    if (queenPending && !globalBest && !globalFallback) {
      power = Math.min(power, 1.2);
    }

    const angleJitter = (Math.random() - 0.5) * 0.12;
    let finalAngle = aimAngle + angleJitter;

    const toPocket = pockets
      .map(p => {
        const dx = p.x - bestStriker.x;
        const dy = p.y - bestStriker.y;
        const proj = dx * Math.cos(finalAngle) + dy * Math.sin(finalAngle);
        const perp = Math.abs(-dx * Math.sin(finalAngle) + dy * Math.cos(finalAngle));
        return { proj, perp };
      })
      .filter(p => p.proj > 0 && p.perp < POCKET_RADIUS * 0.9)
      .sort((a, b) => a.proj - b.proj)[0];

    if (toPocket && toPocket.proj < 120) {
      power = Math.max(1.05, power * 0.7);
    }

    const vx = Math.cos(finalAngle) * power * SHOT_VELOCITY_MULTIPLIER;
    const vy = Math.sin(finalAngle) * power * SHOT_VELOCITY_MULTIPLIER;

    // Final safety: ensure striker is exactly on the baseline with zero velocity before firing
    bestStriker.vx = 0;
    bestStriker.vy = 0;
    if (baseline.axis === 'x') {
      bestStriker.y = baseline.fixed;
      bestStriker.x = clamp(bestStriker.x, baseline.min, baseline.max);
    } else {
      bestStriker.x = baseline.fixed;
      bestStriker.y = clamp(bestStriker.y, baseline.min, baseline.max);
    }
    strikerRef.current = bestStriker;
    setStriker(bestStriker);

    pocketedThisTurnRef.current = [];
    shotTurnRef.current = currentTurn;
    shotStartStrikerRef.current = { x: bestStriker.x, y: bestStriker.y };
    physicsTurnEndingRef.current = false;
    pendingShotRef.current = { vx, vy };
    setGameData(prev => (prev ? { ...prev, shotInProgress: true } : prev));
    setIsAnimating(true);
  }, [gameState, gameData?.gameMode, gameMode, currentTurn, isAnimating, gameData?.shotInProgress, gameData?.queenPocketed, gameData?.queenCovered, nowMs]);

  useEffect(() => {
    const mode = gameData?.gameMode || gameMode;
    if (mode !== '1vcpu' || currentTurn !== 2) {
      cpuShotReadyAtRef.current = null;
      cpuShotTurnRef.current = null;
    }
  }, [gameData?.gameMode, gameMode, currentTurn]);

  // Block browser back button when player is in game (playing or lobby)
  const shouldBlockBack = gameState === 'playing' || gameState === 'lobby';
  useEffect(() => {
    const preventNavigation = (e) => {
      if (gameStateRef.current === 'playing' || gameStateRef.current === 'lobby') {
        e.preventDefault();
        e.stopPropagation();
        return false;
      }
    };

    // Block mouse events on browser back/forward area when playing
    const handleMouseDown = (e) => {
      if (gameStateRef.current === 'playing' || gameStateRef.current === 'lobby') {
        if (e.clientX <= 100 || e.clientX >= window.innerWidth - 100) {
          if (e.clientY <= 50) {
            e.preventDefault();
            e.stopPropagation();
            return false;
          }
        }
      }
    };

    // Block touch on browser nav area when playing
    const handleTouchStart = (e) => {
      if (gameStateRef.current === 'playing' || gameStateRef.current === 'lobby') {
        const touch = e.touches[0];
        if (touch && (touch.clientX <= 100 || touch.clientX >= window.innerWidth - 100) && touch.clientY <= 50) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    };

    // Block keyboard backspace and Alt+Left when playing
    const handleKeyDown = (e) => {
      if (gameStateRef.current === 'playing' || gameStateRef.current === 'lobby') {
        if (e.key === 'Backspace' || (e.altKey && e.key === 'ArrowLeft')) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      }
    };

    // Browser back/forward: when user clicks back, stay on page if we're in game
    const handlePopState = () => {
      if (gameStateRef.current === 'playing' || gameStateRef.current === 'lobby') {
        window.history.pushState(null, '', window.location.href);
      }
    };

    document.addEventListener('mousedown', handleMouseDown, true);
    document.addEventListener('touchstart', handleTouchStart, { passive: false, capture: true });
    document.addEventListener('keydown', handleKeyDown, true);
    document.addEventListener('contextmenu', preventNavigation, true);
    window.addEventListener('popstate', handlePopState);

    if (shouldBlockBack) {
      window.history.pushState(null, '', window.location.href);
    }

    return () => {
      document.removeEventListener('mousedown', handleMouseDown, true);
      document.removeEventListener('touchstart', handleTouchStart, true);
      document.removeEventListener('keydown', handleKeyDown, true);
      document.removeEventListener('contextmenu', preventNavigation, true);
      window.removeEventListener('popstate', handlePopState);
    };
  }, [gameState]);

  // Canvas drawing
  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext('2d');
    ctx.clearRect(0, 0, BOARD_SIZE, BOARD_SIZE);

    const mode = gameData?.gameMode || gameMode;
    const activeSeat = getPlayerSeat(currentTurn, mode);
    const playerNum = playerId ? parseInt(playerId.replace('player', ''), 10) : null;
    const playerSeat = playerNum ? getPlayerSeat(playerNum, mode) : null;
    // POV debug logging removed after verification

    ctx.save();
    switch (viewRotation) {
      case '180':
        ctx.setTransform(-1, 0, 0, -1, BOARD_SIZE, BOARD_SIZE);
        break;
      case '90cw':
        ctx.setTransform(0, 1, -1, 0, BOARD_SIZE, 0);
        break;
      case '90ccw':
        ctx.setTransform(0, -1, 1, 0, 0, BOARD_SIZE);
        break;
      case '0':
      default:
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        break;
    }

    // Draw outer frame (dark brown wood)
    ctx.fillStyle = '#2c1810';
    ctx.fillRect(0, 0, BOARD_SIZE, BOARD_SIZE);

    // Draw playing surface (plywood color) - extend slightly to eliminate seam at brown frame
    ctx.fillStyle = '#f4e4c1';
    ctx.fillRect(BOARD_PADDING - 2, BOARD_PADDING - 2, PLAY_AREA + 4, PLAY_AREA + 4);

    // Baseline layout (double lines + red markers)
    const leftBaselineX = BOARD_PADDING + BASELINE_OFFSET;
    const rightBaselineX = BOARD_SIZE - BOARD_PADDING - BASELINE_OFFSET;
    const topBaselineY = BOARD_PADDING + BASELINE_OFFSET;
    const bottomBaselineY = BOARD_SIZE - BOARD_PADDING - BASELINE_OFFSET;
    // Shorten at corners so striker zone doesn't overlap diagonals
    const baselineStartX = leftBaselineX + BASE_CORNER_OFFSET;
    const baselineEndX = rightBaselineX - BASE_CORNER_OFFSET;
    const baselineStartY = topBaselineY + BASE_CORNER_OFFSET;
    const baselineEndY = bottomBaselineY - BASE_CORNER_OFFSET;
    const halfGap = BASELINE_GAP / 2;

    ctx.strokeStyle = '#1a1a1a';
    ctx.lineWidth = 2;

    // Top double line
    ctx.beginPath();
    ctx.moveTo(baselineStartX, topBaselineY - halfGap);
    ctx.lineTo(baselineEndX, topBaselineY - halfGap);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(baselineStartX, topBaselineY + halfGap);
    ctx.lineTo(baselineEndX, topBaselineY + halfGap);
    ctx.stroke();

    // Bottom double line
    ctx.beginPath();
    ctx.moveTo(baselineStartX, bottomBaselineY - halfGap);
    ctx.lineTo(baselineEndX, bottomBaselineY - halfGap);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(baselineStartX, bottomBaselineY + halfGap);
    ctx.lineTo(baselineEndX, bottomBaselineY + halfGap);
    ctx.stroke();

    // Left double line
    ctx.beginPath();
    ctx.moveTo(leftBaselineX - halfGap, baselineStartY);
    ctx.lineTo(leftBaselineX - halfGap, baselineEndY);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(leftBaselineX + halfGap, baselineStartY);
    ctx.lineTo(leftBaselineX + halfGap, baselineEndY);
    ctx.stroke();

    // Right double line
    ctx.beginPath();
    ctx.moveTo(rightBaselineX - halfGap, baselineStartY);
    ctx.lineTo(rightBaselineX - halfGap, baselineEndY);
    ctx.stroke();
    ctx.beginPath();
    ctx.moveTo(rightBaselineX + halfGap, baselineStartY);
    ctx.lineTo(rightBaselineX + halfGap, baselineEndY);
    ctx.stroke();

    // 8 base circles (2 per side) – striker placement positions
    const eightBases = [
      { x: leftBaselineX + BASE_CORNER_OFFSET, y: topBaselineY },
      { x: rightBaselineX - BASE_CORNER_OFFSET, y: topBaselineY },
      { x: leftBaselineX + BASE_CORNER_OFFSET, y: bottomBaselineY },
      { x: rightBaselineX - BASE_CORNER_OFFSET, y: bottomBaselineY },
      { x: leftBaselineX, y: topBaselineY + BASE_CORNER_OFFSET },
      { x: leftBaselineX, y: bottomBaselineY - BASE_CORNER_OFFSET },
      { x: rightBaselineX, y: topBaselineY + BASE_CORNER_OFFSET },
      { x: rightBaselineX, y: bottomBaselineY - BASE_CORNER_OFFSET },
    ];

    eightBases.forEach(c => {
      ctx.fillStyle = '#e53935';
      ctx.beginPath();
      ctx.arc(c.x, c.y, BASE_CIRCLE_RADIUS, 0, Math.PI * 2);
      ctx.fill();
      ctx.strokeStyle = '#c62828';
      ctx.lineWidth = 2;
      ctx.stroke();
    });

    // Define center coordinates (used throughout drawing)
    const centerX = BOARD_SIZE / 2;
    const centerY = BOARD_SIZE / 2;

    // Draw diagonal lines from baseline corners to center circle
    const circleRadius = 65;

    ctx.strokeStyle = '#1a1a1a';
    ctx.lineWidth = 2;

    const diagonalStarts = [
      { x: leftBaselineX, y: topBaselineY },
      { x: rightBaselineX, y: topBaselineY },
      { x: leftBaselineX, y: bottomBaselineY },
      { x: rightBaselineX, y: bottomBaselineY }
    ];

    diagonalStarts.forEach(point => {
      const angle = Math.atan2(centerY - point.y, centerX - point.x);
      const circleX = centerX - Math.cos(angle) * circleRadius;
      const circleY = centerY - Math.sin(angle) * circleRadius;

      ctx.beginPath();
      ctx.moveTo(point.x, point.y);
      ctx.lineTo(circleX, circleY);
      ctx.stroke();
    });

    // Draw center circle

    ctx.strokeStyle = '#c62828';
    ctx.lineWidth = 3;
    ctx.beginPath();
    ctx.arc(centerX, centerY, 65, 0, Math.PI * 2);
    ctx.stroke();

    // Draw inner circle
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.arc(centerX, centerY, 28, 0, Math.PI * 2);
    ctx.stroke();

    // Draw center lines (cross)
    ctx.lineWidth = 2;
    ctx.beginPath();
    ctx.moveTo(centerX - 65, centerY);
    ctx.lineTo(centerX + 65, centerY);
    ctx.moveTo(centerX, centerY - 65);
    ctx.lineTo(centerX, centerY + 65);
    ctx.stroke();

    // Draw diagonal lines
    const diagonalLen = 65 / Math.sqrt(2);
    ctx.beginPath();
    ctx.moveTo(centerX - diagonalLen, centerY - diagonalLen);
    ctx.lineTo(centerX + diagonalLen, centerY + diagonalLen);
    ctx.moveTo(centerX + diagonalLen, centerY - diagonalLen);
    ctx.lineTo(centerX - diagonalLen, centerY + diagonalLen);
    ctx.stroke();

    // Pocket positions (used for arrows + drawing)
    const pockets = [
      { x: BOARD_PADDING, y: BOARD_PADDING },
      { x: BOARD_SIZE - BOARD_PADDING, y: BOARD_PADDING },
      { x: BOARD_PADDING, y: BOARD_SIZE - BOARD_PADDING },
      { x: BOARD_SIZE - BOARD_PADDING, y: BOARD_SIZE - BOARD_PADDING }
    ];

    // Draw arrows near pockets (all four sides, pointing toward center)
    const drawArrowLine = (startX, startY, endX, endY) => {
      ctx.strokeStyle = '#000';
      ctx.fillStyle = '#000';
      ctx.lineWidth = 2.5;

      ctx.beginPath();
      ctx.moveTo(startX, startY);
      ctx.lineTo(endX, endY);
      ctx.stroke();

      const angle = Math.atan2(endY - startY, endX - startX);
      const headLen = 10;
      ctx.beginPath();
      ctx.moveTo(endX, endY);
      ctx.lineTo(endX - headLen * Math.cos(angle - Math.PI / 6), endY - headLen * Math.sin(angle - Math.PI / 6));
      ctx.lineTo(endX - headLen * Math.cos(angle + Math.PI / 6), endY - headLen * Math.sin(angle + Math.PI / 6));
      ctx.closePath();
      ctx.fill();
    };

    const arrowInset = POCKET_RADIUS + 10;
    const arrowLength = 24;

    pockets.forEach(pocket => {
      const dirX = centerX - pocket.x;
      const dirY = centerY - pocket.y;
      const dirLen = Math.sqrt(dirX * dirX + dirY * dirY);
      const ux = dirX / dirLen;
      const uy = dirY / dirLen;

      const startX = pocket.x + ux * arrowInset;
      const startY = pocket.y + uy * arrowInset;
      const endX = startX + ux * arrowLength;
      const endY = startY + uy * arrowLength;

      drawArrowLine(startX, startY, endX, endY);
    });

    // Draw pockets (black holes inside the red corners)
    pockets.forEach(pocket => {
      // Outer red ring
      ctx.strokeStyle = '#c62828';
      ctx.lineWidth = 5;
      ctx.beginPath();
      ctx.arc(pocket.x, pocket.y, POCKET_RADIUS + 12, 0, Math.PI * 2);
      ctx.stroke();

      // Red fill
      ctx.fillStyle = '#e53935';
      ctx.beginPath();
      ctx.arc(pocket.x, pocket.y, POCKET_RADIUS + 8, 0, Math.PI * 2);
      ctx.fill();

      // Inner black hole with gradient
      const pocketGradient = ctx.createRadialGradient(
        pocket.x, pocket.y, 0,
        pocket.x, pocket.y, POCKET_RADIUS
      );
      pocketGradient.addColorStop(0, '#1a1a1a');
      pocketGradient.addColorStop(1, '#000000');
      ctx.fillStyle = pocketGradient;
      ctx.beginPath();
      ctx.arc(pocket.x, pocket.y, POCKET_RADIUS, 0, Math.PI * 2);
      ctx.fill();
    });

    // Draw baseline areas - all four sides shown, active one highlighted
    const activeFill = 'rgba(76, 175, 80, 0.2)';
    const activeStroke = 'rgba(76, 175, 80, 0.6)';
    const inactiveFill = 'rgba(100, 100, 100, 0.1)';
    const inactiveStroke = 'rgba(100, 100, 100, 0.2)';
    ctx.lineWidth = 2;

    // Bottom baseline
    const bottomY = bottomBaselineY - BASELINE_THICKNESS / 2;
    const bottomActive = activeSeat === 'bottom';
    ctx.fillStyle = bottomActive ? activeFill : inactiveFill;
    ctx.strokeStyle = bottomActive ? activeStroke : inactiveStroke;
    ctx.fillRect(baselineStartX, bottomY, baselineEndX - baselineStartX, BASELINE_THICKNESS);
    ctx.strokeRect(baselineStartX, bottomY, baselineEndX - baselineStartX, BASELINE_THICKNESS);

    // Top baseline
    const topY = topBaselineY - BASELINE_THICKNESS / 2;
    const topActive = activeSeat === 'top';
    ctx.fillStyle = topActive ? activeFill : inactiveFill;
    ctx.strokeStyle = topActive ? activeStroke : inactiveStroke;
    ctx.fillRect(baselineStartX, topY, baselineEndX - baselineStartX, BASELINE_THICKNESS);
    ctx.strokeRect(baselineStartX, topY, baselineEndX - baselineStartX, BASELINE_THICKNESS);

    // Left baseline
    const leftX = leftBaselineX - BASELINE_THICKNESS / 2;
    const leftActive = activeSeat === 'left';
    ctx.fillStyle = leftActive ? activeFill : inactiveFill;
    ctx.strokeStyle = leftActive ? activeStroke : inactiveStroke;
    ctx.fillRect(leftX, baselineStartY, BASELINE_THICKNESS, baselineEndY - baselineStartY);
    ctx.strokeRect(leftX, baselineStartY, BASELINE_THICKNESS, baselineEndY - baselineStartY);

    // Right baseline
    const rightX = rightBaselineX - BASELINE_THICKNESS / 2;
    const rightActive = activeSeat === 'right';
    ctx.fillStyle = rightActive ? activeFill : inactiveFill;
    ctx.strokeStyle = rightActive ? activeStroke : inactiveStroke;
    ctx.fillRect(rightX, baselineStartY, BASELINE_THICKNESS, baselineEndY - baselineStartY);
    ctx.strokeRect(rightX, baselineStartY, BASELINE_THICKNESS, baselineEndY - baselineStartY);

    // Draw carrom men
    carromMen.forEach(man => {
      if (!man.inPlay) return;

      ctx.save();

      // Shadow
      ctx.fillStyle = 'rgba(0, 0, 0, 0.2)';
      ctx.beginPath();
      ctx.arc(man.x + 2, man.y + 2, man.radius, 0, Math.PI * 2);
      ctx.fill();

      // Main piece with wood-like colors
      if (man.color === 'black') {
        // Dark brown wooden pieces
        const gradient = ctx.createRadialGradient(
          man.x - man.radius * 0.3, man.y - man.radius * 0.3, 0,
          man.x, man.y, man.radius
        );
        gradient.addColorStop(0, '#3d2817');
        gradient.addColorStop(1, '#1a0f08');
        ctx.fillStyle = gradient;
      } else if (man.color === 'white') {
        // Light beige wooden pieces
        const gradient = ctx.createRadialGradient(
          man.x - man.radius * 0.3, man.y - man.radius * 0.3, 0,
          man.x, man.y, man.radius
        );
        gradient.addColorStop(0, '#f5e6d3');
        gradient.addColorStop(1, '#d4b896');
        ctx.fillStyle = gradient;
      } else {
        // Red queen
        const gradient = ctx.createRadialGradient(
          man.x - man.radius * 0.3, man.y - man.radius * 0.3, 0,
          man.x, man.y, man.radius
        );
        gradient.addColorStop(0, '#ff6b6b');
        gradient.addColorStop(1, '#c92a2a');
        ctx.fillStyle = gradient;
      }

      ctx.beginPath();
      ctx.arc(man.x, man.y, man.radius, 0, Math.PI * 2);
      ctx.fill();

      // Border
      ctx.strokeStyle = man.color === 'red' ? '#8b0000' : man.color === 'white' ? '#a88b5f' : '#0d0704';
      ctx.lineWidth = 2;
      ctx.stroke();

      ctx.restore();
    });

    // Draw striker
    if (striker && striker.inPlay) {
      ctx.save();

      // Shadow
      ctx.fillStyle = 'rgba(0, 0, 0, 0.3)';
      ctx.beginPath();
      ctx.arc(striker.x + 3, striker.y + 3, striker.radius, 0, Math.PI * 2);
      ctx.fill();

      // Main striker (translucent plastic/acrylic look)
      const strikerGradient = ctx.createRadialGradient(
        striker.x - striker.radius * 0.4,
        striker.y - striker.radius * 0.4,
        0,
        striker.x,
        striker.y,
        striker.radius
      );
      strikerGradient.addColorStop(0, 'rgba(255, 255, 255, 0.95)');
      strikerGradient.addColorStop(0.5, 'rgba(245, 245, 245, 0.9)');
      strikerGradient.addColorStop(1, 'rgba(220, 220, 220, 0.85)');
      ctx.fillStyle = strikerGradient;
      ctx.beginPath();
      ctx.arc(striker.x, striker.y, striker.radius, 0, Math.PI * 2);
      ctx.fill();

      // Border (slightly darker edge)
      ctx.strokeStyle = '#999';
      ctx.lineWidth = 2;
      ctx.stroke();

      // Highlight for glossy effect
      ctx.fillStyle = 'rgba(255, 255, 255, 0.6)';
      ctx.beginPath();
      ctx.arc(striker.x - striker.radius * 0.3, striker.y - striker.radius * 0.3, striker.radius * 0.4, 0, Math.PI * 2);
      ctx.fill();

      ctx.restore();
    }

    // Draw aim line (only when aiming, not repositioning)
    if (isDragging && dragStart && dragEnd && !isAnimating && !isRepositioning) {
      const dx = dragEnd.x - dragStart.x;
      const dy = dragEnd.y - dragStart.y;
      const distance = Math.sqrt(dx * dx + dy * dy);

      if (distance > 5) {
        // Check if striker overlaps any coin (shot disabled)
        const strikerOverlapsCoin = carromMen.some(man => {
          if (!man.inPlay) return false;
          const ddx = dragStart.x - man.x;
          const ddy = dragStart.y - man.y;
          const minDist = striker.radius + (man.radius ?? CARROM_MAN_RADIUS);
          return Math.hypot(ddx, ddy) < minDist;
        });

        // Shot direction is opposite of drag (pull back to shoot)
        const shotAngle = Math.atan2(-dy, -dx);
        const power = Math.min(distance / 150, 1);
        const aimLineLength = 150 * power;

        // Draw shot direction line (green when valid, grey when disabled)
        const shotEndX = dragStart.x + Math.cos(shotAngle) * aimLineLength;
        const shotEndY = dragStart.y + Math.sin(shotAngle) * aimLineLength;

        ctx.strokeStyle = strikerOverlapsCoin ? 'rgba(120, 120, 120, 0.6)' : 'rgba(76, 175, 80, 0.8)';
        ctx.lineWidth = 3;
        ctx.setLineDash([10, 5]);
        ctx.beginPath();
        ctx.moveTo(dragStart.x, dragStart.y);
        ctx.lineTo(shotEndX, shotEndY);
        ctx.stroke();
        ctx.setLineDash([]);

        // Draw arrowhead at end of shot line
        const arrowSize = 12;
        ctx.fillStyle = strikerOverlapsCoin ? 'rgba(120, 120, 120, 0.6)' : 'rgba(76, 175, 80, 0.8)';
        ctx.beginPath();
        ctx.moveTo(shotEndX, shotEndY);
        ctx.lineTo(
          shotEndX - arrowSize * Math.cos(shotAngle - Math.PI / 6),
          shotEndY - arrowSize * Math.sin(shotAngle - Math.PI / 6)
        );
        ctx.lineTo(
          shotEndX - arrowSize * Math.cos(shotAngle + Math.PI / 6),
          shotEndY - arrowSize * Math.sin(shotAngle + Math.PI / 6)
        );
        ctx.closePath();
        ctx.fill();

        // Draw power indicator in screen space (not rotated) so text is always readable
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        const brownCenter = BOARD_PADDING / 2;
        const powerBarScreenY = BOARD_SIZE - brownCenter - 8;
        const powerTextScreenY = BOARD_SIZE - brownCenter;
        ctx.fillStyle = 'rgba(0, 0, 0, 0.7)';
        ctx.fillRect(BOARD_SIZE / 2 - 100, powerBarScreenY - 2, 200, 20);
        ctx.fillStyle = strikerOverlapsCoin ? '#666' : power > 0.8 ? '#f44336' : power > 0.5 ? '#ff9800' : '#4caf50';
        ctx.fillRect(BOARD_SIZE / 2 - 98, powerBarScreenY, 196 * power, 16);

        ctx.fillStyle = '#fff';
        ctx.font = 'bold 12px Arial';
        ctx.textAlign = 'center';
        ctx.fillText(strikerOverlapsCoin ? 'DISABLED - Reposition striker' : 'POWER', BOARD_SIZE / 2, powerTextScreenY);
        ctx.restore();
      }
    }

    // Draw repositioning indicator
    if (isRepositioning && isDragging) {
      ctx.fillStyle = 'rgba(33, 150, 243, 0.3)';
      ctx.beginPath();
      ctx.arc(striker.x, striker.y, striker.radius + 5, 0, Math.PI * 2);
      ctx.fill();
    }

    ctx.restore();

  }, [striker, carromMen, isDragging, dragStart, dragEnd, currentTurn, isRepositioning, isAnimating, isPerspectiveFlipped, viewRotation, playerId]);

  // Mouse handlers
  const handleMouseDown = (e) => {
    if (gameState !== 'playing' || isAnimating || !striker || !striker.inPlay) return;
    const isCurrentPlayer = playerId === `player${currentTurn}`;

    // Only the current player can touch the striker (prevents wrong player from dragging and skipping turns in 25/8 / live)
    if (!isCurrentPlayer) return;
    if (gameData?.shotInProgress) return;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    let x = (e.clientX - rect.left) * (BOARD_SIZE / rect.width);
    let y = (e.clientY - rect.top) * (BOARD_SIZE / rect.height);
    const raw = { x, y };

    const mappedPoint = mapScreenToWorld(x, y, playerSeatForView);
    x = mappedPoint.x;
    y = mappedPoint.y;
    const mapped = { x, y };

    // Use ref for most up-to-date position
    const currentStriker = strikerRef.current || striker;
    const dx = x - currentStriker.x;
    const dy = y - currentStriker.y;
    const dist = Math.sqrt(dx * dx + dy * dy);

    if (dist < currentStriker.radius * 2) {
      // Lock turn at start of drag so 25/8 winner's shot isn't attributed to wrong player if listener overwrites currentTurn mid-drag
      shotTurnRef.current = currentTurn;
      // Check if clicking on striker itself for repositioning
      isRepositioningRef.current = true; // Set ref immediately
      setIsRepositioning(true);
      setIsDragging(true);
      setIsCurrentPlayerAiming(true); // Current player is now aiming
      setDragStart({ x: currentStriker.x, y: currentStriker.y });
      setDragEnd({ x, y });
    }
  };

  const handleMouseMove = (e) => {
    if (!isDragging) return;

    const canvas = canvasRef.current;
    if (!canvas) return;
    const rect = canvas.getBoundingClientRect();
    let x = (e.clientX - rect.left) * (BOARD_SIZE / rect.width);
    let y = (e.clientY - rect.top) * (BOARD_SIZE / rect.height);
    const mappedPoint = mapScreenToWorld(x, y, playerSeatForView);
    x = mappedPoint.x;
    y = mappedPoint.y;

    // Check if we're repositioning (moving along baseline) or aiming (pulling back)
    const mode = gameData?.gameMode || gameMode;
    const seat = getPlayerSeat(currentTurn, mode);
    const baseline = getBaselineForSeat(seat);
    const isNearBaseline = baseline.axis === 'x'
      ? (y >= baseline.fixed - BASELINE_THICKNESS && y <= baseline.fixed + BASELINE_THICKNESS)
      : (x >= baseline.fixed - BASELINE_THICKNESS && x <= baseline.fixed + BASELINE_THICKNESS);

    // Use ref for immediate repositioning state (React state might be stale)
    if (isRepositioningRef.current && isNearBaseline) {
      // Repositioning mode: move striker along baseline
      const currentStriker = strikerRef.current || striker;
      if (baseline.axis === 'x') {
        const minX = baseline.min;
        const maxX = baseline.max;
        const constrainedX = Math.max(minX, Math.min(maxX, x));
        const newStriker = {
          ...currentStriker,
          x: constrainedX,
          y: baseline.fixed
        };
        strikerRef.current = newStriker; // Update ref immediately
        setStriker(newStriker); // Also update state for rendering
        setDragStart({ x: constrainedX, y: baseline.fixed });
        setDragEnd({ x: constrainedX, y: baseline.fixed });
      } else {
        const minY = baseline.min;
        const maxY = baseline.max;
        const constrainedY = Math.max(minY, Math.min(maxY, y));
        const newStriker = {
          ...currentStriker,
          x: baseline.fixed,
          y: constrainedY
        };
        strikerRef.current = newStriker; // Update ref immediately
        setStriker(newStriker); // Also update state for rendering
        setDragStart({ x: baseline.fixed, y: constrainedY });
        setDragEnd({ x: baseline.fixed, y: constrainedY });
      }
    } else if (isRepositioningRef.current && !isNearBaseline) {
      // Switching from repositioning to aiming mode
      isRepositioningRef.current = false; // Clear ref immediately
      setIsRepositioning(false);
      setDragEnd({ x, y });
    } else {
      // Aiming mode: pulling back for shot
      setDragEnd({ x, y });
    }
  };

  const handleMouseUp = async (e) => {
    if (!isDragging || !dragStart || !dragEnd) return;

    // Turn never changes here – only on shot completion (handleTurnEnd) or turn timeout. We only start the shot.
    const isCurrentPlayer = playerId === `player${currentTurn}`;
    if (!isCurrentPlayer) {
      setIsDragging(false);
      isRepositioningRef.current = false;
      setIsRepositioning(false);
      setDragStart(null);
      setDragEnd(null);
      return;
    }

    const dx = dragEnd.x - dragStart.x;
    const dy = dragEnd.y - dragStart.y;
    const distance = Math.sqrt(dx * dx + dy * dy);

    // Only shoot on release when pulled back enough (not on drag/reposition). Turn does not change until handleTurnEnd after physics.
    if (!isRepositioning && distance > 10) {
      // Prevent double shot: ignore if a shot is already queued or physics is still running
      if (pendingShotRef.current || isAnimating) {
        setIsDragging(false);
        isRepositioningRef.current = false;
        setIsRepositioning(false);
        setDragStart(null);
        setDragEnd(null);
        return;
      }
      // Block shot if striker overlaps any coin before hit
      const currentStriker = strikerRef.current || striker;
      const men = carromMenRef.current?.length ? carromMenRef.current : carromMen;
      const strikerOverlapsCoin = men.some(man => {
        if (!man.inPlay) return false;
        const dx = dragStart.x - man.x;
        const dy = dragStart.y - man.y;
        const minDist = (currentStriker?.radius ?? STRIKER_RADIUS) + (man.radius ?? CARROM_MAN_RADIUS);
        return Math.hypot(dx, dy) < minDist;
      });
      if (strikerOverlapsCoin) {
        Swal.fire({
          icon: 'warning',
          title: 'Invalid shot',
          text: 'Striker is touching a coin. Reposition the striker to shoot.',
          timer: 2000,
          showConfirmButton: false
        });
        setIsDragging(false);
        isRepositioningRef.current = false;
        setIsRepositioning(false);
        setDragStart(null);
        setDragEnd(null);
        return;
      }
      const power = Math.min(distance / 68, 3.2);
      // Drag backwards (away from baseline) shoots forwards toward opponent
      const angle = Math.atan2(-dy, -dx);
      const vx = Math.cos(angle) * power * SHOT_VELOCITY_MULTIPLIER;
      const vy = Math.sin(angle) * power * SHOT_VELOCITY_MULTIPLIER;

      pocketedThisTurnRef.current = [];

      // Allow physics to run again for the next shot
      physicsTurnEndingRef.current = false;

      // Capture striker position at shot start for baseline foul check
      shotStartStrikerRef.current = { x: dragStart.x, y: dragStart.y };

      // Store velocity in ref so physics can apply it immediately (bypasses React state timing)
      pendingShotRef.current = { vx, vy };

      // Capture turn at shot start so handleTurnEnd uses it (avoids stale currentTurn from listener)
      shotTurnRef.current = currentTurn;

      const isLocalGame = (gameData?.gameMode || gameMode) === '1vcpu';
      if (isLocalGame) {
        setGameData(prev => (prev ? { ...prev, shotInProgress: true, turnStartedAt: Date.now() } : prev));
      } else if (realtimeDatabase && roomCode) {
        update(ref(realtimeDatabase, `games/${roomCode}`), {
          shotInProgress: true,
          turnStartedAt: serverTimestamp()
        });
      }


      setIsAnimating(true);
    }

    setIsDragging(false);
    isRepositioningRef.current = false; // Clear ref
    setIsRepositioning(false);
    setDragStart(null);
    setDragEnd(null);
  };

  // Touch handlers (mobile): forward to same logic as mouse using synthetic clientX/clientY
  const handleTouchStart = (e) => {
    if (e.touches.length !== 1) return;
    const touch = e.touches[0];
    activeTouchIdRef.current = touch.identifier;
    handleMouseDown({ ...e, clientX: touch.clientX, clientY: touch.clientY });
    if (e.cancelable) e.preventDefault();
  };

  const handleTouchMove = (e) => {
    if (activeTouchIdRef.current == null) return;
    const touch = Array.from(e.touches).find(t => t.identifier === activeTouchIdRef.current);
    if (!touch) return;
    if (e.cancelable) e.preventDefault();
    handleMouseMove({ clientX: touch.clientX, clientY: touch.clientY });
  };

  const handleTouchEnd = (e) => {
    const touch = e.changedTouches && Array.from(e.changedTouches).find(t => t.identifier === activeTouchIdRef.current);
    if (touch) {
      if (e.cancelable) e.preventDefault();
      handleMouseUp({ clientX: touch.clientX, clientY: touch.clientY });
      activeTouchIdRef.current = null;
    }
  };

  const handleTouchCancel = (e) => {
    if (e.changedTouches && Array.from(e.changedTouches).some(t => t.identifier === activeTouchIdRef.current)) {
      activeTouchIdRef.current = null;
      if (isDragging) {
        setIsDragging(false);
        isRepositioningRef.current = false;
        setIsRepositioning(false);
        setDragStart(null);
        setDragEnd(null);
      }
    }
  };

  handleMouseMoveRef.current = handleMouseMove;
  handleMouseUpRef.current = handleMouseUp;

  useEffect(() => {
    if (!isDragging) return;
    const onMove = (e) => handleMouseMoveRef.current(e);
    const onUp = (e) => handleMouseUpRef.current(e);
    document.addEventListener('mousemove', onMove);
    document.addEventListener('mouseup', onUp);
    return () => {
      document.removeEventListener('mousemove', onMove);
      document.removeEventListener('mouseup', onUp);
    };
  }, [isDragging]);

  // Render
  if (gameState === 'menu') {
    // Live 2v2: simplified lobby – create room or join by room code only
    if (gametype === 'live-2v2') {
      return (
        <div className="bg-gradient-to-br flex items-center justify-center p-4">
          <div className="p-10 rounded-2xl shadow-2xl max-w-lg w-full border-4 border-amber-900" style={{ color: textcolor, background: boxcolor }}>
            <h1 className="text-4xl font-bold mb-6 text-center">
              2v2 – Create or Join Room
            </h1>
            <div className="space-y-4 mb-6">
              <p className="text-center text-sm opacity-90">Share the room code with friends. Game starts when all 4 players are ready.</p>
              <button
                onClick={() => {
                  setGameMode('2v2');
                  const code = generateRoomCode();
                  createRoom(userData, code);
                }}
                disabled={!playerName}
                className="w-full bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-6 rounded-lg text-xl shadow-lg transition-all transform hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed"
              >
                Create Room
              </button>
              <div className="relative">
                <div className="absolute inset-0 flex items-center">
                  <div className="w-full border-t-2 border-amber-300"></div>
                </div>
                <div className="relative flex justify-center text-base">
                  <span className="px-4 bg-gradient-to-br from-amber-50 to-yellow-50 text-amber-700 font-bold">OR</span>
                </div>
              </div>
              <input
                type="text"
                placeholder="Enter room code"
                value={roomCode}
                onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
                className="w-full px-4 py-3 border-2 border-amber-300 rounded-lg text-lg text-center font-bold tracking-wider focus:border-amber-500 focus:outline-none uppercase"
                maxLength={10}
              />
              <button
                onClick={() => { setGameMode('2v2'); joinRoom(userData, roomCode || undefined); }}
                disabled={!playerName || !roomCode}
                className="w-full bg-gradient-to-r from-amber-600 to-amber-700 hover:from-amber-700 hover:to-amber-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-6 rounded-lg text-xl shadow-lg transition-all transform hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed"
              >
                Join Room
              </button>
            </div>
          </div>
        </div>
      );
    }

    return (
      <div style={{ "visibility": "hidden" }} className="bg-gradient-to-br flex items-center justify-center p-4">
        <div className="p-10 rounded-2xl shadow-2xl max-w-lg w-full border-4 border-amber-900">
          <h1 className="text-5xl font-bold mb-8 text-center" style={{ fontFamily: 'Georgia, serif' }}>
            🎯 Carrom
          </h1>

          <div className="space-y-4 mb-6">
            <input
              type="text"
              placeholder="Enter your name"
              value={playerName}
              onChange={(e) => setPlayerName(e.target.value)}
              className="w-full px-4 py-3 border-2 border-amber-300 rounded-lg text-lg focus:border-amber-500 focus:outline-none"
            />

            <div className="flex gap-3 flex-wrap">
              <button
                onClick={() => setGameMode('1v1')}
                className={`flex-1 min-w-[140px] py-3 px-4 rounded-lg font-bold transition-all ${gameMode === '1v1'
                  ? 'bg-gradient-to-r from-blue-600 to-blue-700 text-white shadow-lg transform scale-105'
                  : 'bg-white border-2 border-blue-300 text-blue-700 hover:border-blue-500'
                  }`}
              >
                1 vs 1
              </button>
              <button
                onClick={() => setGameMode('2v2')}
                className={`flex-1 min-w-[140px] py-3 px-4 rounded-lg font-bold transition-all ${gameMode === '2v2'
                  ? 'bg-gradient-to-r from-green-600 to-green-700 text-white shadow-lg transform scale-105'
                  : 'bg-white border-2 border-green-300 hover:border-green-500'
                  }`}
                style={{ color: textcolor }}
              >
                2 vs 2
              </button>
              <button
                onClick={() => setGameMode('1vcpu')}
                className={`flex-1 min-w-[140px] py-3 px-4 rounded-lg font-bold transition-all ${gameMode === '1vcpu'
                  ? 'bg-gradient-to-r from-purple-600 to-purple-700 text-white shadow-lg transform scale-105'
                  : 'bg-white border-2 border-purple-300 text-purple-700 hover:border-purple-500'
                  }`}
              >
                1 vs CPU
              </button>
            </div>

            <div className="flex gap-3">
              <button
                onClick={() => setMatchFormat('single')}
                className={`flex-1 py-2 px-4 rounded-lg font-bold transition-all ${matchFormat === 'single'
                  ? 'bg-gradient-to-r from-amber-600 to-amber-700 text-white shadow-lg transform scale-105'
                  : 'bg-white border-2 border-amber-300 text-amber-700 hover:border-amber-500'
                  }`}
              >
                Single Board
              </button>
              <button
                onClick={() => setMatchFormat('match')}
                className={`flex-1 py-2 px-4 rounded-lg font-bold transition-all ${matchFormat === 'match'
                  ? 'bg-gradient-to-r from-amber-600 to-amber-700 text-white shadow-lg transform scale-105'
                  : 'bg-white border-2 border-amber-300 text-amber-700 hover:border-amber-500'
                  }`}
              >
                Match 25/8
              </button>
            </div>
          </div>

          <div className="space-y-3">
            {gameMode === '1vcpu' && (
              <button
                onClick={startCpuGame}
                disabled={!playerName}
                className="w-full bg-gradient-to-r from-purple-600 to-purple-700 hover:from-purple-700 hover:to-purple-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-6 rounded-lg text-xl shadow-lg transition-all transform hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed"
              >
                Play vs CPU
              </button>
            )}
            <button
              onClick={createRoom}
              disabled={!playerName || !gameMode || gameMode === '1vcpu'}
              className="w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-6 rounded-lg text-xl shadow-lg transition-all transform hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed"
            >
              Create Room
            </button>

            <div className="relative">
              <div className="absolute inset-0 flex items-center">
                <div className="w-full border-t-2 border-amber-300"></div>
              </div>
              <div className="relative flex justify-center text-base">
                <span className="px-4 bg-gradient-to-br from-amber-50 to-yellow-50 text-amber-700 font-bold">OR</span>
              </div>
            </div>

            <input
              type="text"
              placeholder="Enter room code"
              value={roomCode}
              onChange={(e) => setRoomCode(e.target.value.toUpperCase())}
              className="w-full px-4 py-3 border-2 border-amber-300 rounded-lg text-lg text-center font-bold tracking-wider focus:border-amber-500 focus:outline-none uppercase"
              maxLength={6}
            />

            <button
              onClick={joinRoom}
              disabled={!playerName || !roomCode || gameMode === '1vcpu'}
              className="w-full hover:from-yellow-700 hover:to-yellow-800 disabled:from-gray-400 disabled:to-gray-500 text-white font-bold py-4 px-6 rounded-lg text-xl shadow-lg transition-all transform hover:scale-105 disabled:scale-100 disabled:cursor-not-allowed"
            >
              Join Room
            </button>
          </div>
        </div>
      </div>
    );
  }

  if (gameState === 'lobby' && (gametype === 'tournament' || gametype === 'live-2v2')) {
    const maxPlayers = gameData?.gameMode === '2v2' ? 4 : 2;
    const currentPlayers = gameData?.players ? Object.keys(gameData.players).length : 0;
    const allReady = gameData?.players ? Object.values(gameData.players).every(p => p.ready) : false;
    const lobbyStartedAtMs = parseFirebaseTimestamp(gameData?.lobbyStartedAt);
    const lobbyTimeoutMs = gameData?.lobbyTimeoutMs || LOBBY_TIMEOUT_MS;
    const lobbyRemainingMs = lobbyStartedAtMs && !gameData?.lobbyTimeoutCancelled
      ? Math.max(0, lobbyTimeoutMs - (nowMs - lobbyStartedAtMs))
      : null;
    const lobbyCountdownLabel = lobbyRemainingMs != null
      ? `${String(Math.floor(lobbyRemainingMs / 60000)).padStart(2, '0')}:${String(Math.floor((lobbyRemainingMs % 60000) / 1000)).padStart(2, '0')}`
      : null;

    // --- Tournament lobby "waiting for opponent" overlay messages ---
    // Minute-wise line (changes each elapsed minute) + a rotating line (changes every 15s).
    const LOBBY_MINUTE_MESSAGES = [
      "You’re here. Your opponent’s entrance music is still loading.",            // minute 1
      "Two minutes in. Still a solo act. Stay tuned.",                            // minute 2
      "Three minutes down. Your opponent is keeping the suspense alive.",         // minute 3
      "Still waiting. Mentally warming up counts, right?",                        // minute 4
      "Halfway through the wait. Fashionably late has its limits.",               // minute 5
      "Six minutes in. Your opponent’s dramatic entrance is getting very dramatic.", // minute 6
      "Three minutes left. A good time for your opponent to appear.",             // minute 7
      "Two minutes left. This entrance could use a fast forward button.",         // minute 8
      "One minute left. It’s almost now or never.",                              // minute 9
      "Final countdown! No opponent by zero? Hello, next round.",                 // final minute (10)
    ];
    const LOBBY_ROTATING_MESSAGES = [
      "Two can play this game. Just waiting for the second.",
      "Your opponent has 10 minutes to join. Dramatic entrances take time.",
      "Stay here. We’d hate for you both to take turns waiting.",
      "That countdown? Your opponent’s late meter.",
      "No opponent when the timer hits zero? You win and head straight to the next round.",
    ];

    // Elapsed time within the 10-minute window
    const lobbyElapsedMs = lobbyRemainingMs != null ? Math.max(0, lobbyTimeoutMs - lobbyRemainingMs) : 0;
    const lobbyElapsedMinuteIndex = Math.min(
      LOBBY_MINUTE_MESSAGES.length - 1,
      Math.floor(lobbyElapsedMs / 60000)
    );
    const lobbyMinuteMessage = LOBBY_MINUTE_MESSAGES[lobbyElapsedMinuteIndex];
    // Rotating line advances every 15 seconds, cycling through the rotating set.
    const lobbyRotatingMessage = LOBBY_ROTATING_MESSAGES[
      Math.floor(lobbyElapsedMs / 15000) % LOBBY_ROTATING_MESSAGES.length
    ];

    // Overlay only for tournament, while still waiting for the opponent to join, timer running.
    const showLobbyWaitOverlay =
      gametype === 'tournament' &&
      lobbyCountdownLabel != null &&
      currentPlayers < maxPlayers &&
      !gameData?.lobbyTimeoutCancelled &&
      gameData?.status === 'waiting';

    return (
      <>
        {/* Tournament waiting-for-opponent overlay (~70% dark, full page, disappears once opponent joins) */}
        {showLobbyWaitOverlay && (
          <div
            className="fixed inset-0 z-50 flex flex-col items-center justify-center text-center px-4 pointer-events-none"
            style={{ backgroundColor: 'rgba(0, 0, 0, 0.7)' }}
          >
            <p className="text-white font-bold uppercase tracking-wide mb-3 text-lg sm:text-xl leading-snug drop-shadow max-w-2xl">
              {lobbyMinuteMessage}
            </p>
            <div className="text-white font-extrabold leading-none drop-shadow-lg" style={{ fontSize: 'clamp(3.5rem, 14vw, 7rem)' }}>
              {lobbyCountdownLabel}
            </div>
            <p className="text-white/90 font-semibold mt-3 text-sm sm:text-base leading-snug max-w-md drop-shadow">
              {lobbyRotatingMessage}
            </p>
          </div>
        )}
        {/* Show loader overlay if still loading or if gameData is not fully loaded */}
        {/* {(loading || !gameData || !gameData.players) && (
          <div className="loader-container">
            <div className="loader"></div>
            <div className="loader-text">Joining game room...</div>
          </div>
        )}
         */}
        <div className={`flex items-center justify-center p-4 ${!loading && gameData && gameData.players ? 'loaded' : ''}`}>
          <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-10 rounded-2xl shadow-2xl max-w-2xl w-full border-4" style={{ color: textcolor }}>
            <h1 className="text-4xl font-bold mb-6 text-center" style={{ color: textcolor }}>
              Game Lobby
            </h1>

            <div className="mb-6 p-4 bg-yellow-100 border-2 border-yellow-400 rounded-lg text-center">
              <p className="text-base text-amber-700 mb-2" style={{ color: textcolor }}>Room Code</p>
              <p className="text-3xl font-bold tracking-widest" style={{ color: textcolor }}>{roomCode}</p>
              {gametype === 'live-2v2' && userData?.sessionId && (
                <button
                  type="button"
                  onClick={() => setShowInviteModal(true)}
                  className="mt-3 w-full py-2 px-4 rounded-lg font-bold text-white bg-green-600 hover:bg-green-700 transition-all"
                  style={Buttoncolor ? { backgroundColor: Buttoncolor, color: buttontextcolor } : {}}
                >
                  Invite People
                </button>
              )}
            </div>

            <div className="mb-6 text-center">
              <p className="text-lg" style={{ color: textcolor }}>
                Waiting for players... ({currentPlayers}/{maxPlayers})
              </p>
              {gametype === 'tournament' && lobbyCountdownLabel && (
                <p className="text-base mt-2 font-semibold" style={{ color: textcolor }}>
                  Opponent must join within: <span className="font-bold text-red-600">{lobbyCountdownLabel}</span>
                </p>
              )}
            </div>

            <div className="space-y-3 mb-6">
              {console.log('Rendering players - gameData.players:', gameData?.players)}
              {gameData?.players && Object.entries(gameData.players).map(([pid, player]) => (
                <div
                  key={pid}
                  className={`p-4 rounded-lg border-2 ${player.ready
                    ? 'bg-green-100 border-green-400'
                    : 'bg-white border-amber-300'
                    }`}
                >
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-lg">{player.name || (player.userid ? 'Waiting for name...' : `Player ${pid.replace('player', '')}`)}</span>
                    <span className={`px-3 py-1 rounded-full text-base font-bold ${player.ready
                      ? 'bg-green-500 text-white'
                      : 'bg-gray-300 text-gray-700'
                      }`}>
                      {player.ready ? '✓ Ready' : 'Not Ready'}
                    </span>
                  </div>
                </div>
              ))}
            </div>

            <div className="space-y-3">
              {gameData?.players?.[playerId]?.ready && (
                <div className="p-4 bg-green-100 border-2 border-green-400 rounded-lg text-center">
                  <p className="font-bold text-lg" style={{ color: textcolor }}>You are ready — waiting for other players...</p>
                </div>
              )}

              <button
                onClick={() => {
                  if (gametype === 'live-2v2') {
                    if (realtimeDatabase && userData?.sessionId && userData?.userId) {
                      update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), { islive: false, live: false }).catch(() => { });
                    }
                  }
                  handleLeaveLobby();
                }}
                className="relative z-[60] w-full bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-3 px-6 rounded-lg shadow-lg transition-all"
              >
                Leave Lobby
              </button>
            </div>

            {allReady && currentPlayers === maxPlayers && (
              <div className="mt-4 p-4 bg-green-100 border-2 border-green-400 rounded-lg text-center animate-pulse">
                <p className="font-bold" style={{ color: textcolor }}>Starting game...</p>
              </div>
            )}
          </div>
        </div>
        {showInviteModal && gametype === 'live-2v2' && userData?.sessionId && (
          <InviteUsersModal
            sessionId={userData.sessionId}
            userId={userData.userId}
            inviterName={playerName || userData.name || userData.firstName}
            roomCode={roomCode}
            onClose={() => setShowInviteModal(false)}
            theme={{ box_color: boxcolor, box_text_color: boxtextcolor, button_color: Buttoncolor, button_text_color: buttontextcolor }}
          />
        )}
      </>);
  }

  if (gameState === 'gameover') {
    const modeValue = gameData?.gameMode || gameMode;
    const isLocalGame = modeValue === '1vcpu';
    const matchFormatValue = gameData?.matchFormat || matchFormat || 'single';
    const winner = gameData?.winner || winnerData?.winner;
    const isDraw = !!gameData?.matchDraw;
    const winnerName = isDraw ? 'Draw' : (
      gameData?.players?.[winner]?.name ||
      winnerData?.players?.[winner]?.name ||
      (isLocalGame && winner === 'player1' ? (playerName || userData?.name || 'Player 1') : null) ||
      (isLocalGame && winner === 'player2' ? 'CPU' : null) ||
      playerName || userData?.name || 'Unknown'
    );
    const currentUserId = userData?.userId;
    const winnerUserId = gameData?.players?.[winner]?.userid || winnerData?.players?.[winner]?.userid;
    const isCurrentUserWinner = isLocalGame ? winner === 'player1' : currentUserId === winnerUserId;
    // Prefer winnerData.players (set when game ends with final scores); fallback to gameData.players so scores show on both clients
    const playersSource = winnerData?.players && Object.keys(winnerData.players).length > 0 ? winnerData.players : (gameData?.players || {});
    let finalScores = Object.keys(playersSource).length > 0 ? playersSource : (gameData?.players || {});
    const latestScores = scoresRef.current ?? scores;
    // If still empty (e.g. 1vCPU or late sync), build from local scores so Final Scores section always shows something
    if (Object.keys(finalScores).length === 0 && latestScores && typeof latestScores === 'object') {
      finalScores = Object.keys(latestScores).reduce((acc, pid) => {
        if (latestScores[pid] !== undefined && (pid === 'player1' || pid === 'player2' || pid === 'player3' || pid === 'player4')) {
          const defaultName = pid === 'player1' ? 'Player 1' : pid === 'player2' ? (isLocalGame ? 'CPU' : 'Player 2') : pid === 'player3' ? 'Player 3' : 'Player 4';
          acc[pid] = { name: gameData?.players?.[pid]?.name || winnerData?.players?.[pid]?.name || defaultName, score: latestScores[pid] };
        }
        return acc;
      }, {});
    }
    // Merge local scores into finalScores (fixes game over popup showing 0 when user leaves or Firebase/gameData lacks scores)
    if (latestScores && typeof latestScores === 'object') {
      finalScores = Object.keys(finalScores).reduce((acc, pid) => {
        const p = finalScores[pid] || {};
        const fromPlayer = p?.score ?? gameData?.players?.[pid]?.score ?? 0;
        const fromLocal = latestScores[pid] ?? 0;
        acc[pid] = { ...p, score: Math.max(Number(fromPlayer) || 0, Number(fromLocal) || 0) };
        return acc;
      }, {});
    }
    // For live 1v1 and 1vCPU: ensure both players always show in Final Scores (even when one left and data is incomplete)
    const is1v1 = gameData?.gameMode === '1v1' || modeValue === '1v1';
    const needsBothPlayers = is1v1 || isLocalGame;
    if (needsBothPlayers && Object.keys(finalScores).length < 2) {
      ['player1', 'player2'].forEach(pid => {
        if (!finalScores[pid]) {
          finalScores[pid] = {
            name: gameData?.players?.[pid]?.name || winnerData?.players?.[pid]?.name || (pid === 'player1' ? 'Player 1' : (isLocalGame ? 'CPU' : 'Player 2')),
            score: latestScores?.[pid] ?? gameData?.players?.[pid]?.score ?? winnerData?.players?.[pid]?.score ?? 0
          };
        } else if (isLocalGame && pid === 'player2' && !finalScores[pid].name) {
          finalScores[pid] = { ...finalScores[pid], name: 'CPU' };
        }
      });
    }
    const boardResult = gameData?.boardResult;
    const showExitToHome = (matchFormatValue === 'single' || gametypeRef.current === 'live') && !isCurrentUserWinner;
    const confettiColors = ['#f97316', '#facc15', '#22c55e', '#3b82f6', '#ec4899', '#a855f7'];
    const confettiPieces = Array.from({ length: 24 }, (_, index) => ({
      left: (index * 7) % 100,
      delay: (index % 6) * 0.12,
      duration: 2.6 + (index % 5) * 0.45,
      rotate: (index * 37) % 360,
      color: confettiColors[index % confettiColors.length]
    }));

    const handleExitToMenu = async () => {
      // SPECTATOR: never wrote anything; just leave the match view.
      if (isSpectatorRef.current) {
        let tid = tournamentId;
        if (!tid) {
          try {
            const ss = sessionStorage.getItem('userData');
            if (ss) tid = JSON.parse(ss).tournamentId;
          } catch (_) {}
        }
        navigate(tid ? `/tournamentStructure?tournamentId=${tid}` : '/tournament');
        return;
      }
      // For 1v1 (live or tournament): delegate to handleGameEnd which dedup-guards the API call.
      // The API is typically already saved by turn-end gameover or handleLeaveGame; this is a safety net.
      if (winnerData && winnerData.winner && winnerData.currentGametype !== '1vcpu') {
        const exitGameMode = winnerData.gameMode || gameData?.gameMode;
        const exitGameType = winnerData.currentGametype || (gametypeRef.current === 'live' ? 'live' : gametypeRef.current === 'tournament' ? 'tournament' : null);

        if (exitGameMode === '1v1' && (exitGameType === 'live' || exitGameType === 'tournament')) {
          await handleGameEnd({
            winnerId: winnerData.winner,
            winnerColor: winnerData.winnerColor,
            gameType: exitGameType,
            gameMode: exitGameMode,
            players: winnerData.players,
            sessionId: userData?.sessionId,
            organizationId: userData?.organizationId,
          });
        }
      }

      // For multiplayer games, mark player as exited instead of immediate room removal
      if (!isLocalGame && realtimeDatabase && roomCode && playerId && (!gameData?.winner || gameData?.status !== 'gameover')) {
        try {
          const gameRef = ref(realtimeDatabase, `games/${roomCode}`);
          const snapshot = await get(gameRef);

          if (snapshot.exists()) {
            const snapData = snapshot.val();
            const exitedPlayers = snapData.exitedPlayers || [];

            if (!exitedPlayers.includes(playerId)) {
              exitedPlayers.push(playerId);
            }

            const totalPlayers = Object.keys(snapData.players || {}).length;
            console.log(`Player ${playerId} exiting. Exited players: ${exitedPlayers.length}/${totalPlayers}`);

            if (exitedPlayers.length >= totalPlayers) {
              console.log("All players have exited, removing game room");
              await remove(gameRef);
              clearSession();
              setGameData(null);
              setRoomCode('');
              setPlayerId(null);
              setCarromMen([]);
              setStriker(null);
              setCurrentTurn(1);
              setBoardsPlayed(0);
              setWinnerData(null);
            } else {
              await update(gameRef, {
                exitedPlayers: exitedPlayers,
                status: 'players_exiting'
              });
            }
          }
        } catch (error) {
          console.error('Error handling player exit:', error);
          await remove(ref(realtimeDatabase, `games/${roomCode}`));
        }
      }

      // 1vCPU (local): reset user data in Firebase, clear session, redirect to userpage
      if (isLocalGame) {
        if (userData?.userId && userData?.sessionId && realtimeDatabase) {
          try {
            await resetUsersStatusToOnline({ player1: { userid: userData.userId } });
            await update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), {
              status: 'online',
              islive: true,
              live: false,
              timestamp: serverTimestamp()
            });
            console.log('1vCPU exit: Firebase user data reset to online');
          } catch (statusError) {
            console.error('Error resetting Firebase on 1vCPU exit:', statusError);
          }
        }
        clearSession();
        localStorage.removeItem('carrom_localGame');
        setGameData(null);
        setRoomCode('');
        setPlayerId(null);
        setCarromMen([]);
        setStriker(null);
        setCurrentTurn(1);
        setBoardsPlayed(0);
        setScores({ player1: 0, player2: 0, player3: 0, player4: 0 });
        setQueenPocketed(null);
        setLastPocketedPiece(null);
        setFoulCount({ player1: 0, player2: 0, player3: 0, player4: 0 });
        setWinnerData(null);
        setIsDragging(false);
        setIsAnimating(false);
        setIsRepositioning(false);
        navigate('/userpage');
        return;
      }

      // Navigate based on game type
      if (gametypeRef.current === 'tournament') {
        clearSession();
        setGameData(null);
        setRoomCode('');
        setPlayerId(null);
        setWinnerData(null);
        let tournamentIdToUse = tournamentId;
        if (!tournamentIdToUse) {
          try {
            const storedSession = sessionStorage.getItem('userData');
            if (storedSession) {
              const parsedUser = JSON.parse(storedSession);
              tournamentIdToUse = parsedUser.tournamentId;
            }
          } catch (e) {
            console.error('Error parsing session for tournamentId on exit:', e);
          }
        }
        navigate(`/tournamentStructure?tournamentId=${tournamentIdToUse || ''}`);
      } else if (gametypeRef.current === 'live-2v2') {
        if (realtimeDatabase && userData?.sessionId && userData?.userId) {
          update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), { islive: true, live: false, status: 'online' }).catch(() => { });
        }
        navigate('/userpage');
      } else if (gametypeRef.current === 'live') {
        if (realtimeDatabase && userData?.sessionId && userData?.userId) {
          update(ref(realtimeDatabase, `sessions/${userData.sessionId}/users/${userData.userId}`), { islive: true, live: true, status: 'online' }).catch(() => { });
        }
        navigate('/allusers');
      }
    };

    return (
      <div className="bg-gradient-to-br flex items-center justify-center p-4 relative">
        <div className="confetti" style={{ display: 'none' }}>
          {confettiPieces.map((piece, index) => (
            <span
              key={`confetti-${index}`}
              className="confetti-piece"
              style={{
                left: `${piece.left}%`,
                backgroundColor: piece.color,
                animationDelay: `${piece.delay}s`,
                animationDuration: `${piece.duration}s`,
                transform: `translate3d(0, -20px, 0) rotate(${piece.rotate}deg)`
              }}
            />
          ))}
        </div>

        <div style={{ display: 'none' }} className="absolute inset-0 flex items-start justify-center pt-6 pointer-events-none z-20">
          <div className="bg-white/95 rounded-2xl shadow-2xl border-4 border-amber-900 px-8 py-6 text-center pointer-events-auto">
            <p className="text-base uppercase tracking-wide text-amber-700 font-semibold">
              {isDraw ? 'Match Draw' : 'Winner'}
            </p>
            <p className="text-3xl font-bold text-amber-900 mt-1">{winnerName}</p>
            {showExitToHome && (
              <button
                onClick={handleExitToMenu}
                className="mt-4 bg-gradient-to-r from-red-600 to-red-700 hover:from-red-700 hover:to-red-800 text-white font-bold py-2 px-6 rounded-lg shadow-lg transition-all transform hover:scale-105"
              >
                Exit to Home
              </button>
            )}
          </div>
        </div>

        {boardResult && (
          <div className="absolute inset-0 flex items-center justify-center">
            <div className="bg-white rounded-2xl shadow-2xl border-4 border-amber-900 p-6 w-[360px]">
              <h2 className="text-2xl font-bold text-amber-900 mb-3 text-center">Board Result</h2>
              <div className="space-y-2 text-base text-amber-800">
                <p><span className="font-bold">Winner:</span> {winnerName}</p>
                <p><span className="font-bold">Points Earned:</span> {boardResult.boardPoints} <span className="text-sm text-amber-600">(opponent coins + queen bonus, max 12)</span></p>
                <p><span className="font-bold">Opponent Coins Left:</span> {boardResult.opponentRemaining}</p>
                <p><span className="font-bold">Queen Bonus:</span> +{boardResult.queenPoints} {boardResult.queenPoints > 0 && <span className="text-sm text-amber-600">(covered by winner, score ≤21)</span>}</p>
              </div>
            </div>
          </div>
        )}

        <div className="bg-gradient-to-br from-amber-50 to-yellow-50 p-10 rounded-2xl shadow-2xl max-w-lg w-full border-4 border-amber-900 relative z-10">
          <h1 className="text-5xl font-bold mb-6 text-center" style={{ color: textcolor, fontFamily: 'Georgia, serif' }}>
            🏆 Game Over!
          </h1>

          <div className="mb-8 p-6 bg-gradient-to-r rounded-xl text-center border-2" style={{ background: boxcolor, color: boxtextcolor, borderColor: boxtextcolor }}>
            <p className="text-2xl font-bold mb-2" style={{ color: boxtextcolor }}>{isDraw ? 'Match Draw' : 'Winner'}</p>
            <p className="text-4xl font-bold text-white" style={{ color: boxtextcolor }}>{winnerName}</p>
          </div>

          <div className="space-y-3 mb-8">
            <h2 className="text-2xl font-bold text-center mb-4" style={{ color: textcolor }}>Final Scores</h2>
            {Object.entries(finalScores).map(([pid, player]) => {
              const displayScore = player?.score ?? gameData?.players?.[pid]?.score ?? winnerData?.players?.[pid]?.score ?? scores[pid] ?? latestScores?.[pid] ?? 0;
              const displayName = player?.name ?? gameData?.players?.[pid]?.name ?? winnerData?.players?.[pid]?.name ?? (pid === 'player1' ? 'Player 1' : pid === 'player2' ? (isLocalGame ? 'CPU' : 'Player 2') : pid === 'player3' ? 'Player 3' : 'Player 4');
              return (
                <div
                  key={pid}
                  className={`p-4 rounded-lg border-2 ${pid === winner ? '' : 'bg-white border-amber-300'}`}
                  style={pid === winner ? { backgroundColor: boxcolor, color: boxtextcolor, borderColor: boxtextcolor } : undefined}
                >
                  <div className="flex justify-between items-center">
                    <span className="font-bold text-lg">{displayName}</span>
                    <span className="text-2xl font-bold">{displayScore}</span>
                  </div>
                </div>
              );
            })}
          </div>

          {/* {showExitToHome && ( */}
          <div className="flex justify-center">
            <button
              onClick={handleExitToMenu}
              className="mt-4 bg-gradient-to-r hover:from-red-700 hover:to-red-800 font-bold py-2 px-6 rounded-lg shadow-lg transition-all transform hover:scale-105"
              style={{ color: buttontextcolor, background: Buttoncolor }}>
              Exit to Home
            </button>
          </div>
          {/* )} */}

        </div>
      </div>
    );
  }

  // Playing state
  const modeValue = gameData?.gameMode || gameMode;
  const matchFormatValue = gameData?.matchFormat || matchFormat || 'single';
  const boardsPlayedValue = gameData?.boardsPlayed || 0;
  const isLocalGame = modeValue === '1vcpu';
  const roomLabel = isLocalGame ? 'Local' : roomCode;
  const isMyTurn = playerId === `player${currentTurn}`;
  const currentPlayerData = gameData?.players?.[`player${currentTurn}`];
  const remainingWhite = carromMen.filter(m => m.inPlay && m.color === 'white').length;
  const remainingBlack = carromMen.filter(m => m.inPlay && m.color === 'black').length;
  const pocketedWhite = 9 - remainingWhite;
  const pocketedBlack = 9 - remainingBlack;
  const recentTurnLog = (gameData?.turnLog || []).slice(-6).reverse();

  const renderMissedTurnDots = (missedCount = 0) => (
    <div className="flex gap-1 items-center" title={`Missed turns: ${missedCount}/${MAX_MISSED_TURNS}`}>
      {Array.from({ length: MAX_MISSED_TURNS }).map((_, i) => (
        <span
          key={`miss-dot-${i}`}
          className="inline-block w-3 h-3 rounded-full border border-gray-400"
          style={{ backgroundColor: i < missedCount ? '#ef4444' : '#22c55e' }}
        />
      ))}
    </div>
  );

  return (
    <div className="flex items-center justify-center p-2 overflow-x-hidden overflow-y-auto min-h-0">
      <div id="mainboard" className="rounded-2xl shadow-2xl max-w-6xl mx-auto w-full h-fit max-h-full overflow-y-auto px-4 sm:px-8 md:px-12" style={{ color: boxtextcolor, "background": "white", "paddingBottom": "4rem" }}>
        {/* Header */}
        <div className="mb-2 flex justify-between items-center flex-shrink-0" style={{ color: textcolor }}>
          <div className="text-lg">
            <p style={{ "visibility": "hidden", "position": "absolute", "width": "0px" }} className="text-lg">Room: <span className="font-bold">{roomLabel}</span></p>
            <p className="text-lg">
              {matchFormatValue === 'match'
                ? `Match (first to ${MATCH_TARGET_POINTS} or most after ${MATCH_MAX_BOARDS} boards) • Board ${boardsPlayedValue}/${MATCH_MAX_BOARDS}`
                : 'Single Board'}
            </p>
            <p className={`text-lg font-bold ${isMyTurn ? 'text-green-600' : 'text-amber-900'}`} style={{ color: textcolor }}>
              {isSpectator
                ? `${currentPlayerData?.name || 'Player'}'s Turn`
                : (isMyTurn ? "🎯 Your Turn!" : `${currentPlayerData?.name}'s Turn`)}
              {remainingSeconds != null && (
                <span className="ml-1 inline-flex items-center px-1 py-0.5 rounded-full text-lg font-semibold">
                  {remainingSeconds}s
                </span>
              )}
            </p>
            {isSpectator && (
              <p className="text-sm font-bold inline-flex items-center gap-1 px-2 py-0.5 rounded-full"
                 style={{ background: '#0f766e', color: '#ffffff' }}>
                👁 Spectating
              </p>
            )}
            <p className="text-lg min-h-[1.75rem] flex items-center">
              {gameData?.shotInProgress ? 'Shot in progress...' : ''}
            </p>
          </div>
          <button
            onClick={() => {
              if (isSpectator) {
                let tid = tournamentId;
                if (!tid) {
                  try {
                    const ss = sessionStorage.getItem('userData');
                    if (ss) tid = JSON.parse(ss).tournamentId;
                  } catch (_) {}
                }
                navigate(tid ? `/tournamentStructure?tournamentId=${tid}` : '/tournament');
              } else {
                handleLeaveGame();
              }
            }}
            className="hover:bg-red-700 font-bold py-1 px-3 rounded-lg shadow transition text-lg flex-shrink-0"
            style={{ color: buttontextcolor, background: Buttoncolor }}>
            {isSpectator ? 'Exit' : 'Leave'}
          </button>

        </div>

        <div className="flex flex-col md:flex-row gap-4 md:gap-8 justify-center items-center md:items-start">
          {/* Left side - Carrom Board */}
          <div className="flex-shrink-0 w-full max-w-[min(550px,100vw-2rem)] flex flex-col items-center">
            {gameData?.boardResult && matchFormatValue === 'match' && (
              <div className="mb-2 p-2 bg-white border-2 border-amber-300 rounded-lg shadow">
                <div className="flex items-center justify-between mb-1">
                  <p className="font-bold text-amber-900 text-lg">Board Result</p>
                  <button
                    onClick={clearBoardResult}
                    className="text-lg font-bold text-amber-700 hover:text-amber-900"
                  >
                    ✖
                  </button>
                </div>
                <div className="text-lg space-y-0.5" style={{ color: textcolor }}>
                  <p><span className="font-bold">Winner:</span> {gameData.boardResult.winnerPlayers?.[0] ? (gameData.players?.[gameData.boardResult.winnerPlayers[0]]?.name || (gameData.players?.[gameData.boardResult.winnerPlayers[0]]?.userid ? 'Waiting for name...' : gameData.boardResult.winnerPlayers[0])) : 'Unknown'}</p>
                  <p><span className="font-bold">Points:</span> {gameData.boardResult.boardPoints}</p>
                  <p><span className="font-bold">Queen:</span> {gameData.boardResult.queenPoints}</p>
                </div>
              </div>
            )}

            {/* Canvas */}
            <canvas
              ref={canvasRef}
              width={BOARD_SIZE}
              height={BOARD_SIZE}
              onMouseDown={handleMouseDown}
              onTouchStart={handleTouchStart}
              onTouchMove={handleTouchMove}
              onTouchEnd={handleTouchEnd}
              onTouchCancel={handleTouchCancel}
              className="cursor-crosshair rounded-lg shadow-inner touch-none select-none"
              style={{
                touchAction: 'none',
                WebkitTouchCallout: 'none',
                userSelect: 'none',
                cursor: isMyTurn && !isAnimating ? 'crosshair' : 'not-allowed',
                maxWidth: 'min(550px, 100vw - 2rem)',
                width: '100%',
                height: 'auto'
              }}
            />

            {/* Instructions */}
            <div className="mt-2 text-center">
              {isMyTurn && !isAnimating ? (
                <div className="space-y-0.5">
                  <p className="text-lg font-bold" style={{ color: textcolor }}>
                    🎯 Click striker to move • Drag to aim & shoot
                  </p>
                </div>
              ) : isAnimating ? (
                <p className="text-lg font-bold animate-pulse" style={{ color: textcolor }}>
                  ⚡ Shot in progress...
                </p>
              ) : (
                <p className="text-lg" style={{ color: textcolor }}>
                  Waiting for {currentPlayerData?.name}...
                </p>
              )}
            </div>

            {gameData?.queenPocketed && !gameData?.queenCovered && (
              <div className="mt-2 p-2 bg-red-100 border-2 border-red-400 rounded-lg text-center">
                <p className="text-lg font-bold" style={{ color: textcolor }}>
                  👑 Queen pocketed! Cover it with your color.
                </p>
              </div>
            )}
            {gameData?.queenCovered && (
              <div className="mt-2 p-2 bg-green-100 border-2 border-green-400 rounded-lg text-center">
                <p className="text-lg font-bold" style={{ color: textcolor }}>
                  ✅ Queen covered and scored!
                </p>
              </div>
            )}
          </div>

          {/* Right side - Content/Turn Box */}
          <div className="w-full md:w-56 flex-shrink-0 max-w-md md:max-w-none">
            {/* Scoreboard */}
            <div className="mb-3" style={{ color: boxtextcolor }}>
              <h3 className="text-lg font-bold mb-2" style={{ color: textcolor }}>Scoreboard</h3>
              <div className="space-y-2">
                {gameData?.players && Object.entries(gameData.players).map(([pid, player]) => {
                  const isCurrentTurn = pid === `player${currentTurn}`;
                  const boxBg = isCurrentTurn ? boxcolor : 'white';
                  const boxText = isCurrentTurn ? boxtextcolor : 'black';
                  return (
                    <div
                      key={pid}
                      className={`p-2 rounded-lg border-2 ${isCurrentTurn
                        ? 'border-green-600'
                        : 'border-amber-300'
                        }`}
                      style={{ background: boxBg, color: boxText }}
                    >
                      <div className="flex items-center justify-between mb-1">
                        <p className="font-bold text-lg" style={{ color: boxText }}>{player.name || (player.userid ? 'Waiting for name...' : `Player ${pid.replace('player', '')}`)}</p>
                        <span
                          className="inline-flex items-center px-1 py-0.5 rounded-full text-lg font-bold border"
                          style={{
                            backgroundColor: getPlayerColor(pid, gameData?.gameMode) === 'white' ? '#f5e6d3' : '#3d2817',
                            color: getPlayerColor(pid, gameData?.gameMode) === 'white' ? '#4b3a2b' : '#f5e6d3',
                            borderColor: getPlayerColor(pid, gameData?.gameMode) === 'white' ? '#c9b39a' : '#1a0f08'
                          }}
                        >
                          {getPlayerColor(pid, gameData?.gameMode) === 'white' ? 'W' : 'B'}
                        </span>
                      </div>
                      <div className="space-y-1 text-lg">

                        {isCurrentTurn && remainingSeconds != null && (
                          <div className="flex justify-start items-center gap-2">
                            <span className="font-bold" style={{ color: boxText }}>Time:</span>
                            <span className="font-semibold" style={{ color: boxText }}>{remainingSeconds}s</span>
                          </div>
                        )}
                        <div className="flex justify-start items-center gap-2">
                          <span className="font-bold" style={{ color: boxText }}>Pocketed:</span>
                          <span style={{ color: boxText }}>{getPlayerColor(pid, gameData?.gameMode) === 'white' ? pocketedWhite : pocketedBlack}/9</span>
                        </div>
                        <div className="flex justify-start items-center gap-2">
                          <span className="font-bold" style={{ color: boxText }}>Fouls:</span>
                          <span style={{ color: boxText }}>{player.fouls || 0}</span>
                        </div>
                        {gametype === 'tournament' && (gameData?.gameMode || gameMode) === '1v1' && (
                          <div className="flex justify-start items-center gap-2">
                            <span className="font-bold" style={{ color: boxText }}>Misses:</span>
                            {renderMissedTurnDots(Number(player.missedTurns ?? 0))}
                          </div>
                        )}
                        <div className="flex justify-start items-center gap-2" style={{ visibility: gameType === '25/8' ? 'visible' : 'hidden' }}>
                          <span className="font-bold" style={{ color: boxText }}>Points</span>
                          <span className="text-xl font-bold" style={{ color: boxText }}>{player?.score ?? scores[pid] ?? 0}</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>

            {/* Turn log - visibility hidden */}
            <div className="bg-white/80 border-2 border-amber-300 rounded-lg p-2" style={{ visibility: 'hidden' }}>
              <p className="text-lg font-bold mb-1" style={{ color: textcolor }}>Match score (25/8)</p>
              <div className="space-y-0.5 text-lg text-gray-700 max-h-32 overflow-auto">
                {recentTurnLog.length === 0 ? (
                  <p className="text-lg text-gray-500" style={{ color: textcolor }}>No events yet.</p>
                ) : (
                  recentTurnLog.map((entry, idx) => (
                    <p key={`${entry.ts}-${idx}`} style={{ color: textcolor }}>• {entry.message}</p>
                  ))
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Game;
